// AUTO-GENERATED static Spanish translations (hardcoded, no runtime LLM).
// Regenerate via /tmp/gen_es.py + /tmp/gen_es_dotkeys.py.
/* eslint-disable */
export const ES_GENERATED = {
  " + auto.merk : ": "+ auto.marca :",
  " + auto.model : ": "+ auto.modelo :",
  " + model : ": "+ modelo :",
  " Bedrijfslogo op factuur": "Logotipo de la empresa en factura",
  "\"Past op\"-check werkt nu ook met aftermarket-merken (Ridex, Febi, Bosch…) via OEM cross-reference": "La comprobación «Compatible con» ahora también funciona con marcas de posventa (Ridex, Febi, Bosch…) mediante referencia cruzada OEM",
  "(KvK, BTW, IBAN voor op de factuur)": "(CIF, IVA, IBAN para la factura)",
  "(eigen lijst actief)": "(lista propia activa)",
  "(geen normaal wachtwoord). Vereist 2FA op je Google account.": "(no es una contraseña normal). Requiere 2FA en tu cuenta de Google.",
  "(geen omschrijving)": "(sin descripción)",
  "(meestal dezelfde dag).": "(normalmente el mismo día).",
  "(standaardlijst actief)": "(lista estándar activa)",
  "(straat + huisnr — klik 🔍 om plaats/postcode op te zoeken)": "(calle + n.º de casa — haz clic en 🔍 para buscar localidad/código postal)",
  "(wordt vastgelegd in het logboek)": "(se registrará en el libro de registro)",
  "(🔍 vult straat/plaats automatisch)": "(🔍 rellena calle/localidad automáticamente)",
  ", aantal: 1, prijs: 0, type, markering: ": ", cantidad: 1, precio: 0, tipo, marcaje:",
  ", kenteken: ": ", matrícula:",
  ", merk: ": ", marca:",
  ", model: ": ", modelo:",
  ", voorraad: 0, minVoorraad: 0, inkoop: 0, verkoop: 0, locatie: ": ", stock: 0, stockMínimo: 0, compra: 0, venta: 0, ubicación:",
  "-- Kies een bon --": "-- Seleccionar un recibo --",
  "0 auto": "0 coche",
  "0 auto 16px": "0 coche 16px",
  "0,00": "0,00",
  "1. Download back-up": "1. Descargar copia de seguridad",
  "1. Toepasselijkheid": "1. Aplicabilidad",
  "1. Wie zijn wij?": "1. ¿Quiénes somos?",
  "10. AI-functionaliteiten": "10. Funcionalidades de IA",
  "10. Wijzigingen": "10. Modificaciones",
  "11. Externe gegevensbronnen": "11. Fuentes de datos externas",
  "12. Beschikbaarheid": "12. Disponibilidad",
  "13. Intellectueel eigendom": "13. Propiedad intelectual",
  "14. Verboden gebruik": "14. Uso prohibido",
  "15. Vrijwaring": "15. Exención de responsabilidad",
  "16. Aansprakelijkheid": "16. Responsabilidad",
  "17. Overmacht": "17. Fuerza mayor",
  "18. Beëindiging": "18. Terminación",
  "19. Wijzigingen": "19. Modificaciones",
  "1fr 1fr 1fr auto": "1fr 1fr 1fr auto",
  "1fr 1fr auto": "1fr 1fr auto",
  "2. Back-up herstellen (import)": "2. Restaurar copia de seguridad (importar)",
  "2. Definities": "2. Definiciones",
  "2. Rolverdeling (verwerker vs. verwerkingsverantwoordelijke)": "2. Reparto de roles (encargado del tratamiento vs. responsable del tratamiento)",
  "20. Toepasselijk recht": "20. Ley aplicable",
  "21. Contact": "21. Contacto",
  "24/7 uren tonen": "Mostrar horas 24/7",
  "3. Back-up naar cloud (Pro/Enterprise)": "3. Copia de seguridad en la nube (Pro/Enterprise)",
  "3. Beschrijving van de dienst": "3. Descripción del servicio",
  "3. Welke gegevens verwerken we?": "3. ¿Qué datos tratamos?",
  "30 bonnen per maand": "30 recibos al mes",
  "4. Account en toegang": "4. Cuenta y acceso",
  "4. Doeleinden en grondslag": "4. Fines y fundamento",
  "40px auto": "40px auto",
  "5. Licenties": "5. Licencias",
  "5. Verstrekking aan derden (sub-verwerkers)": "5. Suministro a terceros (subprocesadores)",
  "6. Bewaartermijnen": "6. Plazos de conservación",
  "6. Proefversies en gratis pakketten": "6. Versiones de prueba y paquetes gratuitos",
  "7. Beveiliging": "7. Seguridad",
  "7. Prijzen en betaling": "7. Precios y pago",
  "8. Gegevens en eigendom": "8. Datos y propiedad",
  "8. Jouw rechten": "8. Tus derechos",
  "9. Back-ups": "9. Copias de seguridad",
  "9. Cookies": "9. Cookies",
  "A license is tied to your garage upon activation - reuse by another garage is blocked.": "Una licencia está vinculada a tu taller tras la activación - la reutilización por otro taller está bloqueada.",
  "AI / Gemini API-sleutel": "Clave API de IA / Gemini",
  "AI Advertentie-generator": "Generador de anuncios de IA",
  "AI Advertentiemaker Pro": "Creador de anuncios de IA Pro",
  "AI Diagnose": "Diagnóstico de IA",
  "AI Diagnose met controle": "Diagnóstico de IA con verificación",
  "AI Diagnose werkt nu in 2 stappen: AI stelt voor → jij controleert → daarna pas opslaan": "El diagnóstico de IA ahora funciona en 2 pasos: la IA sugiere → tú verificas → solo entonces guardar",
  "AI Foutcode-uitleg": "Explicación de códigos de error de IA",
  "AI Offerte-assistent": "Asistente de presupuestos de IA",
  "AI Onderdeel-advertentie": "Anuncio de pieza de IA",
  "AI advertentie": "Anuncio de IA",
  "AI analyseert het diagnoserapport...": "La IA analiza el informe de diagnóstico...",
  "AI analyseert het rapport...": "La IA analiza el informe...",
  "AI analyseert je foto's direct mee voor opties, schade en waardebepaling.": "La IA analiza tus fotos directamente para opciones, daños y valoración.",
  "AI analyseert je foto\\'s direct mee voor opties, schade en waardebepaling.": "La IA analiza tus fotos directamente para opciones, daños y valoración.",
  "AI analyseert…": "La IA analiza…",
  "AI bepaalt nieuwprijs, gebruikte marktwaarde en sloopwaarde": "La IA determina el precio de nuevo, el valor de mercado de segunda mano y el valor de desguace",
  "AI heeft de gegevens uitgelezen. Controleer en pas waar nodig aan — er wordt nog niets opgeslagen.": "La IA ha leído los datos. Verifica y ajusta donde sea necesario; aún no se ha guardado nada.",
  "AI leest de autopapieren…": "La IA lee los documentos del coche…",
  "AI leest je diagnoserapport voor je uit": "La IA lee tu informe de diagnóstico por ti",
  "AI leest merk, model, bouwjaar, VIN, brandstof en voertuigtype automatisch in": "La IA lee automáticamente la marca, modelo, año de fabricación, VIN, combustible y tipo de vehículo",
  "AI prijsadvies": "Asesoramiento de precios de IA",
  "AI prijsadvies-badge: zie in één oogopslag of je vraagprijs onder, op of boven de marktprijs ligt (incl. adviesvraagprijs)": "Distintivo de asesoramiento de precios de IA: comprueba de un vistazo si tu precio de venta está por debajo, en o por encima del precio de mercado (incl. precio de venta recomendado)",
  "AI schrijft je advertentie…": "La IA escribe tu anuncio…",
  "AI stelt offerte op…": "La IA elabora un presupuesto…",
  "AI taxeert…": "La IA tasa…",
  "AI vertaal": "Traductor IA",
  "AI vertalen": "Traducción IA",
  "AI werkt de advertentie bij…": "La IA actualiza el anuncio…",
  "AI zoekt onderdelen…": "La IA busca piezas…",
  "AI-advertentie": "Anuncio de IA",
  "AI-advertentie voor onderdelen": "Anuncio de IA para piezas",
  "AI-check mislukt": "Verificación de IA fallida",
  "AI-fotoanalyse": "Análisis de fotos de IA",
  "AI-fotoanalyse: herkent staat, schade en kenmerken van het onderdeel": "Análisis de fotos de IA: reconoce el estado, daños y características de la pieza",
  "AI-functionaliteiten worden uitsluitend aangeboden als hulpmiddel. MonteurCentraal geeft geen garantie over juistheid, volledigheid, actualiteit, geschiktheid of betrouwbaarheid.": "Las funcionalidades de IA se ofrecen exclusivamente como herramienta. MonteurCentraal no garantiza la exactitud, exhaustividad, actualidad, idoneidad o fiabilidad.",
  "AI-functionaliteiten:": "Funcionalidades de IA:",
  "AI-suggesties": "Sugerencias de IA",
  "AI: herken onderdeel uit foto's": "IA: reconocer pieza en fotos",
  "AI: herken onderdeel uit foto\\'s": "IA: reconocer pieza en fotos",
  "AI: waar past dit nog meer op?": "IA: ¿en qué más encaja esto?",
  "APK": "ITV",
  "APK & Onderhoud": "ITV y Mantenimiento",
  "APK binnen 30 dagen": "ITV en 30 días",
  "APK verlopen": "ITV vencida",
  "APK vervalt": "ITV vence",
  "APK vervalt:": "ITV vence:",
  "APK vrijgesteld": "ITV exenta",
  "APK, openstaande betalingen en slapende klanten": "ITV, pagos pendientes y clientes inactivos",
  "APK-herinnering verstuurd": "Recordatorio de ITV enviado",
  "APK-vervaldatums": "Fechas de vencimiento de ITV",
  "APK-voorkeuring": "Pre-ITV",
  "APK-voorkeuring checklist": "Lista de control pre-ITV",
  "APK-voorkeuring checklist (14 controlepunten) — afdrukbaar voor de klant": "Lista de control pre-ITV (14 puntos de control) — imprimible para el cliente",
  "Aan": "Activado",
  "Aanbetaling": "Anticipo",
  "Aanbetaling (€)": "Anticipo (€)",
  "Aanbevolen onderhoud": "Mantenimiento recomendado",
  "Aanbevolen werkzaamheden": "Trabajos recomendados",
  "Aandeel omzet": "Porcentaje de facturación",
  "Aangemaakt": "Creado",
  "Aangemaakt via diagnose": "Creado mediante diagnóstico",
  "Aangepast": "Modificado",
  "Aantal": "Cantidad",
  "Aantal artikelen": "Número de artículos",
  "Aantal monteurs/bruggen dat tegelijk kan werken.": "Número de mecánicos/elevadores que pueden trabajar simultáneamente.",
  "Aantal sleutels": "Número de llaves",
  "Accentkleur": "Color de acento",
  "Account": "Cuenta",
  "Account aangemaakt! Check je e-mail om te activeren.": "¡Cuenta creada! Revisa tu e-mail para activar.",
  "Account aangemaakt, maar mail kon niet verstuurd worden. Probeer \"Opnieuw versturen\".": "Cuenta creada, pero el e-mail no pudo ser enviado. Intenta \"Reenviar\".",
  "Account aanmaken": "Crear cuenta",
  "Account activeren...": "Activando cuenta...",
  "Account succesvol geactiveerd! Welkom bij MonteurCentraal.": "¡Cuenta activada con éxito! Bienvenido a MonteurCentraal.",
  "Account:": "Cuenta:",
  "Accountgegevens garage:": "Datos de la cuenta del taller:",
  "Actie": "Acción",
  "Actiecentrum — wat moet er vandaag gebeuren?": "Centro de actividades — ¿qué hay que hacer hoy?",
  "Actief": "Activo",
  "Actief plan met": "Plan activo con",
  "Acties: betaling toevoegen, refund, betaling verwijderen, document openen": "Acciones: añadir pago, reembolso, eliminar pago, abrir documento",
  "Actieve apparaten": "Dispositivos activos",
  "Activa (bezittingen)": "Activos (bienes)",
  "Activa en passiva op basis van je grootboek": "Activos y pasivos según tu libro mayor",
  "Activa en passiva op basis van je grootboek. Activa = Passiva + Resultaat.": "Activos y pasivos según tu libro mayor. Activos = Pasivos + Resultado.",
  "Activate a license via Settings → Plans.": "Activate a license via Settings → Plans.",
  "Activatie mislukt": "Activación fallida",
  "Activatie mislukt. Vraag een nieuwe activatiemail aan.": "Activación fallida. Solicita un nuevo correo de activación.",
  "Activatielogboek": "Registro de activación",
  "Activatielogboek / apparaten": "Registro de activación / dispositivos",
  "Activatiemail verstuurd. Check je inbox.": "E-mail de activación enviado. Revisa tu bandeja de entrada.",
  "Activeer een licentie via Instellingen → Plannen.": "Activa una licencia en Ajustes → Planes.",
  "Activeer eerst een licentie om cloud te koppelen.": "Activa primero una licencia para conectar la nube.",
  "Activeren": "Activar",
  "Add lines via the buttons above.": "Add lines via the buttons above.",
  "Add your garage details in": "Add your garage details in",
  "Admin-sleutel": "Clave de administrador",
  "Adres": "Dirección",
  "Adres (straat + huisnummer)": "Dirección (calle + número)",
  "Adres gevonden: ": "Dirección encontrada:",
  "Adres ingevuld": "Dirección rellenada",
  "Adres lookup mislukt": "Error al buscar dirección",
  "Adres niet gevonden": "Dirección no encontrada",
  "Adres opzoeken": "Buscar dirección",
  "Adres opzoeken via PDOK (postcode + huisnr)": "Buscar dirección vía PDOK (código postal + número de casa)",
  "Adres opzoeken via PDOK (straat + huisnr + plaats)": "Buscar dirección vía PDOK (calle + número de casa + localidad)",
  "Advertentie": "Anuncio",
  "Advertentie maken": "Crear anuncio",
  "Advertentie maken (AI)": "Crear anuncio (IA)",
  "Advertentie maken (AI) direct vanuit de onderdeelkaart, zonder eerst op te slaan en opnieuw te openen": "Crear anuncio (IA) directamente desde la ficha de pieza, sin tener que guardar y volver a abrir primero",
  "Advertentietekst": "Texto del anuncio",
  "Advertentietekst in opmerkingen gezet": "Texto del anuncio añadido a los comentarios",
  "Advies": "Asesoramiento",
  "Advies-vraagprijs": "Precio de venta recomendado",
  "Adviesprijs overgenomen": "Precio recomendado adoptado",
  "Adviesvraagprijs": "Precio de venta recomendado",
  "Afdrukken": "Imprimir",
  "Afdrukken / Opslaan als PDF": "Imprimir / Guardar como PDF",
  "Afgedrukt via MonteurCentraal": "Impreso a través de MonteurCentraal",
  "Afgeletterd": "Compensado",
  "Afgewezen door klant": "Rechazado por el cliente",
  "Afkomstig van": "Originario de",
  "Afkomstig van voertuig": "Originario del vehículo",
  "Afmelden": "Cerrar sesión",
  "Afschrift uploaden": "Subir extracto",
  "Afspraak": "Cita",
  "Afspraak aanvragen": "Solicitar cita",
  "Afspraak bewerken": "Editar cita",
  "Afspraak maken": "Crear cita",
  "Afspraak opgeslagen": "Cita guardada",
  "Afspraak verplaatst": "Cita movida",
  "Afspraak verwijderd": "Cita eliminada",
  "Afspraak verwijderen?": "¿Eliminar cita?",
  "Afspraakgegevens:": "Datos de la cita:",
  "Afspraken en werkagenda": "Citas y agenda de trabajo",
  "Afspraken vandaag": "Citas de hoy",
  "After payment, you will receive a cryptographically signed license key via email.": "After payment, you will receive a cryptographically signed license key via email.",
  "Afzendernaam (optioneel)": "Nombre del remitente (opcional)",
  "Akkoord": "Aceptar",
  "Akkoord & ondertekenen": "Aceptar y firmar",
  "Akkoord geven": "Dar el visto bueno",
  "Akkoord-link aangemaakt": "Enlace de aprobación creado",
  "Akkoord-link aanmaken": "Crear enlace de aprobación",
  "Al up-to-date": "Ya actualizado",
  "Albanië": "Albania",
  "Algemene Voorwaarden MonteurCentraal": "Términos y condiciones de MonteurCentraal",
  "Algemene instellingen": "Ajustes generales",
  "Algemene instellingen opgeslagen": "Ajustes generales guardados",
  "Algemene opmerkingen inname": "Comentarios generales de recepción",
  "Algemene voorwaarden": "Términos y condiciones",
  "All confirmations, reminders and invoices sent via the app.": "All confirmations, reminders and invoices sent via the app.",
  "All confirmations, reminders, and invoices sent via the app.": "All confirmations, reminders, and invoices sent via the app.",
  "Alle": "Todos",
  "Alle AI-functies (advertenties, foutcode-uitleg, offerte-assistent, foto-herkenning, taxatie, compatibiliteit, papieren scannen en diagnoserapporten) draaien op jouw eigen, gratis Google Gemini-sleutel — je betaalt zelf niets extra en alles blijft binnen je eigen Google-account.": "Todas las funciones de IA (anuncios, explicación de códigos de error, asistente de presupuestos, reconocimiento de fotos, tasación, compatibilidad, escaneo de documentos e informes de diagnóstico) funcionan con tu propia clave gratuita de Google Gemini; no pagarás nada extra y todo permanecerá dentro de tu cuenta de Google.",
  "Alle automatische journaalposten verwijderen en opnieuw opbouwen?": "¿Eliminar y reconstruir todos los asientos contables automáticos?",
  "Alle betalingen": "Todos los pagos",
  "Alle bevestigingen, herinneringen en facturen die via de app zijn verstuurd.": "Todas las confirmaciones, recordatorios y facturas enviados a través de la aplicación.",
  "Alle bruggen": "Todos los elevadores",
  "Alle categorieën": "Todas las categorías",
  "Alle door AI gegenereerde gegevens dienen altijd door de gebruiker te worden gecontroleerd voordat deze worden gebruikt. Gebruik van AI-functionaliteiten geschiedt volledig op eigen risico.": "Todos los datos generados por IA siempre deben ser verificados por el usuario antes de ser utilizados. El uso de las funcionalidades de IA se realiza bajo la entera responsabilidad del usuario.",
  "Alle gegevens die door de klant worden ingevoerd blijven eigendom van de klant. MonteurCentraal verkrijgt geen eigendomsrechten op klantgegevens.": "Todos los datos introducidos por el cliente siguen siendo propiedad del cliente. MonteurCentraal no adquiere ningún derecho de propiedad sobre los datos del cliente.",
  "Alle intellectuele eigendomsrechten met betrekking tot software, broncode, ontwerpen, databases, documentatie, logo’s en handelsnamen blijven eigendom van MonteurCentraal.": "Todos los derechos de propiedad intelectual relacionados con el software, el código fuente, los diseños, las bases de datos, la documentación, los logotipos y los nombres comerciales siguen siendo propiedad de MonteurCentraal.",
  "Alle keys zijn al vertaald": "Todas las claves ya están traducidas",
  "Alle medewerkers binnen": "Todos los empleados en",
  "Alle merken": "Todas las marcas",
  "Alle monteurs": "Todos los mecánicos",
  "Alle seizoenen": "Todas las temporadas",
  "Alle statussen": "Todos los estados",
  "Alle toekomstige updates inbegrepen": "Todas las futuras actualizaciones incluidas",
  "Alle voorraad is op peil.": "Stock al día.",
  "Alleen .json bestanden": "Solo archivos .json",
  "Alleen PDF-bestanden": "Solo archivos PDF",
  "Alleen lage voorraad": "Solo stock bajo",
  "Alleen met licentie": "Solo con licencia",
  "Alleen voor PRO/Enterprise plan": "Solo para el plan PRO/Enterprise",
  "Alles": "Todo",
  "Alles aanvinken": "Marcar todo",
  "Alles onder controle — geen openstaande acties.": "Todo bajo control: sin acciones pendientes.",
  "Alles ontvangen": "Todo recibido",
  "Alles selecteren": "Seleccionar todo",
  "Alles toevoegen": "Añadir todo",
  "Alles uitvinken": "Desmarcar todo",
  "Allow customers to request appointments themselves via a shareable link.": "Allow customers to request appointments themselves via a shareable link.",
  "Als": "Si",
  "Als dit e-mailadres bekend is, hebben we een reset-link gestuurd.": "Si esta dirección de correo electrónico es conocida, hemos enviado un enlace de restablecimiento.",
  "Altijd gratis · voor zzp & starters": "Siempre gratis · para autónomos y startups",
  "Analyse klaar — controleer voor opslaan": "Análisis completado — verificar antes de guardar",
  "Analyse mislukt": "Análisis fallido",
  "Andere locatie…": "Otra ubicación…",
  "Annuleren": "Cancelar",
  "Aparte \"Advertentie maken\"-tool: kenteken invullen en klaar": "Herramienta separada \"Crear anuncio\": introduzca la matrícula y listo",
  "App password": "Contraseña de aplicación",
  "Apparaat / browser": "Dispositivo / navegador",
  "Apparaat afgemeld": "Dispositivo cerrado",
  "Apparaatbeheer + activatielogboek per licentie (misbruikbeveiliging)": "Gestión de dispositivos + registro de activación por licencia (protección contra uso indebido)",
  "Apparaatlimiet bereikt": "Límite de dispositivos alcanzado",
  "Apparaten": "Dispositivos",
  "Apparaten die 90 dagen niet zijn gebruikt worden automatisch verwijderd.": "Los dispositivos que no se hayan utilizado durante 90 días se eliminarán automáticamente.",
  "Argentinië": "Argentina",
  "Armenië": "Armenia",
  "Artikelhistorie": "Historial de artículo",
  "Audit log-bewaartermijn": "Periodo de retención del registro de auditoría",
  "Australië": "Australia",
  "Auto": "Vehículo",
  "Auto bewerken": "Editar vehículo",
  "Auto gebracht": "Vehículo entregado",
  "Auto handel": "Comercio de vehículos",
  "Auto handel marge": "Margen comercio de vehículos",
  "Auto handel toegevoegd": "Comercio de vehículos añadido",
  "Auto opgeslagen": "Vehículo guardado",
  "Auto toevoegen": "Añadir vehículo",
  "Auto toevoegen (mock)": "Añadir vehículo (simulado)",
  "Auto verwijderd": "Vehículo eliminado",
  "Auto verwijderen?": "¿Eliminar vehículo?",
  "Auto-advertenties met één klik publiceren (concept / gepubliceerd / verwijderen)": "Publicar anuncios de vehículos con un clic (borrador / publicado / eliminar)",
  "Auto-backup aan": "Copia de seguridad automática activada",
  "Auto-backup off": "Copia de seguridad automática desactivada",
  "Auto-backup on": "Copia de seguridad automática activada",
  "Auto-backup uit": "Copia de seguridad automática desactivada",
  "Auto-handel": "Comercio de vehículos",
  "Auto-translate failed": "La traducción automática falló",
  "Auto-translation failed": "La traducción automática falló",
  "Auto-vertalen mislukt": "La traducción automática falló",
  "Autohandel marge": "Margen comercio de vehículos",
  "Automatically fill empty keys via AI": "Automatically fill empty keys via AI",
  "Automatische betalingsherinneringen": "Recordatorios de pago automáticos",
  "Automatische bevestigings- en herinneringsmails": "Correos electrónicos de confirmación y recordatorio automáticos",
  "Automatische nachtelijke back-up": "Copia de seguridad automática nocturna",
  "Automatische onderdelenlijst per type (scooter: kuipdelen/variomatic, aanhanger: as/dissel, caravan: keuken/koelkast…)": "Lista automática de piezas por tipo (scooter: carenado/variador, remolque: eje/lanza, caravana: cocina/nevera...)",
  "Autopapieren scannen met AI": "Escaneo de documentos de vehículos con IA",
  "Average per service": "Average per service",
  "BASIC limieten actief: max 50 klanten · 30 bonnen/maand · 1 gebruiker · geen cloud · geen auto-handel.": "Límites BASIC activos: máx. 50 clientes · 30 recibos/mes · 1 usuario · sin nube · sin comercio de vehículos.",
  "BETAALD": "PAGADO",
  "BPM / rest-BPM gecontroleerd (bij import)": "BPM / BPM restante comprobado (en importación)",
  "BTW": "IVA",
  "BTW nummer": "Número de IVA",
  "BTW voorbelasting (terug te vragen)": "IVA soportado (a recuperar)",
  "BTW-AANGIFTE": "DECLARACIÓN DE IVA",
  "BTW-aangifte": "Declaración de IVA",
  "BTW-aangifte & winst-/verliesrekening per kwartaal": "Declaración de IVA y cuenta de pérdidas y ganancias trimestral",
  "BTW-aangifte overzicht en winst- & verliesrekening per kwartaal of jaar": "Resumen de la declaración de IVA y cuenta de pérdidas y ganancias trimestral o anual",
  "BTW-aangifte overzicht en winst- & verliesrekening per periode": "Resumen de la declaración de IVA y cuenta de pérdidas y ganancias por periodo",
  "BTW-tarief": "Tipo de IVA",
  "Back-up": "Copia de seguridad",
  "Back-up bestand selecteren": "Seleccionar archivo de copia de seguridad",
  "Back-up gedownload": "Copia de seguridad descargada",
  "Back-up mislukt": "Copia de seguridad fallida",
  "Back-up nu naar cloud": "Copia de seguridad ahora en la nube",
  "Bagijnhof 33": "Bagijnhof 33",
  "Balans": "Balance",
  "Banden inslaan": "Entrada de neumáticos",
  "Banden uitgegeven": "Neumáticos salidos",
  "Banden uitgeven": "Dar salida a neumáticos",
  "Bandenhotel": "Hotel de neumáticos",
  "Bandenmaat": "Medida de neumático",
  "Bandenset bewerken": "Editar juego de neumáticos",
  "Bandenset verwijderen?": "¿Eliminar juego de neumáticos?",
  "Bank": "Banco",
  "Bankafschrift-import (MT940 / CAMT.053) met automatisch matchen aan facturen en kosten": "Importación de extractos bancarios (MT940 / CAMT.053) con conciliación automática con facturas y gastos",
  "Bankimport": "Importación bancaria",
  "Banner geüpload": "Banner subido",
  "Banner ingesteld ✓": "Banner configurado ✓",
  "Banner uploaden": "Subir banner",
  "Banner vervangen": "Reemplazar banner",
  "Banner verwijderd": "Banner eliminado",
  "Banner-afbeelding (bovenaan showroom)": "Imagen del banner (parte superior del showroom)",
  "Bedankt voor uw akkoord!": "¡Gracias por su aprobación!",
  "Bedankt voor uw betaling.": "Gracias por su pago.",
  "Bedankt voor uw vertrouwen in": "Gracias por su confianza en",
  "Bedankt voor uw vertrouwen in onze garage!": "¡Gracias por su confianza en nuestro taller!",
  "Bedrag": "Importe",
  "Bedrag (excl. BTW)": "Importe (sin IVA)",
  "Bedrag (€)": "Importe (€)",
  "Bedrag excl. BTW (€)": "Importe sin IVA (€)",
  "Bedrag is exclusief BTW.": "El importe no incluye IVA.",
  "Bedragen die met één klik als regel op een bon kunnen worden gezet.": "Importes que se pueden añadir con un solo clic como línea en un recibo.",
  "Bedrijfsinformatie": "Información de la empresa",
  "Bedrijfslogo op factuur": "Logotipo de la empresa en la factura",
  "Bedrijfsnaam": "Nombre de la empresa",
  "Begin met deze 3 stappen om je garage op te zetten:": "Empieza con estos 3 pasos para configurar tu taller:",
  "Begin met typen...": "Empieza a escribir...",
  "Begrijp OBD-/DTC-codes: oorzaken, onderdelen en arbeidstijd": "Entiende los códigos OBD/DTC: causas, piezas y tiempo de mano de obra",
  "Beheer gebruikte én nieuwe onderdelen, sloopauto's en advertenties vanuit één systeem.": "Gestiona piezas usadas y nuevas, vehículos para desguace y anuncios desde un solo sistema.",
  "Beheer locaties zoals Brug 1, Brug 2, Magazijn A of Schap 3. Ze verschijnen als keuzelijst bij onderdelen en in de werkplaatsplanning.": "Gestiona ubicaciones como Puente 1, Puente 2, Almacén A o Estantería 3. Aparecerán como lista desplegable para piezas y en la planificación del taller.",
  "Bekijk": "Ver",
  "Bekijk en klik \"Opslaan\" om te bewaren.": "Visualiza y haz clic en \"Guardar\" para almacenar.",
  "Bekijk onze occasions en onderdelen": "Ver nuestros vehículos de ocasión y piezas",
  "Bekijk onze occasions en onderdelen en neem gerust contact op.": "Ver nuestros vehículos de ocasión y piezas y no dudes en contactarnos.",
  "Bekijk op AutoScout24": "Ver en AutoScout24",
  "Bekijk op Gaspedaal": "Ver en Gaspedaal",
  "Bekijk op Marktplaats": "Ver en Marktplaats",
  "Bekijk showroom": "Ver exposición",
  "België": "Bélgica",
  "Bellen": "Llamar",
  "Benodigde onderdelen": "Piezas necesarias",
  "Bepaal marktprijs": "Determinar precio de mercado",
  "Bepaal waarde": "Determinar valor",
  "Beschikbaar bij klantvoertuigen, auto handel én de advertentiemaker": "Disponible para vehículos de clientes, compraventa de coches y el creador de anuncios",
  "Beschikbaarheid laden…": "Cargando disponibilidad…",
  "Beschikbare plannen": "Planes disponibles",
  "Beschrijf de klacht en klik op \"Maak offerte-voorstel\" voor AI-offerteregels.": "Describe el problema y haz clic en \"Crear propuesta de presupuesto\" para obtener líneas de presupuesto con IA.",
  "Beschrijf de klacht of het uit te voeren werk": "Describe el problema o el trabajo a realizar",
  "Beschrijving": "Descripción",
  "Bespaar elk kwartaal uren werk en stuur je boekhouder met 1 klik een compleet rapport.": "Ahorra horas de trabajo cada trimestre y envía un informe completo a tu contable con un solo clic.",
  "Bestaande klant": "Cliente existente",
  "Bestaande klant gevonden — wordt gekoppeld": "Cliente existente encontrado — se vinculará",
  "Bestaat al": "Ya existe",
  "Bestand ingelezen": "Archivo leído",
  "Beste": "Estimado",
  "Bestel": "Pedir",
  "Besteld": "Pedido",
  "Bestellen": "Hacer pedido",
  "Bestellen mislukt": "Error al pedir",
  "Bestellijst": "Lista de pedidos",
  "Bestelling": "Pedido",
  "Bestelling annuleren?": "¿Cancelar pedido?",
  "Bestelling geannuleerd": "Pedido cancelado",
  "Bestellingen": "Pedidos",
  "Bestellingen beheer": "Gestión de pedidos",
  "Betaal via PayPal": "Pagar con PayPal",
  "Betaal-/licentiegegevens:": "Datos de pago/licencia:",
  "Betaal-QR": "QR de pago",
  "Betaal-QR (SEPA) op de factuur — klant scant en betaalt met de bankapp, geen provider nodig": "QR de pago (SEPA) en la factura — el cliente escanea y paga con la app del banco, sin necesidad de proveedor",
  "Betaald": "Pagado",
  "Betaalgegevens worden binnenkort toegevoegd. Je ontvangt de instructies per e-mail.": "Los datos de pago se añadirán pronto. Recibirás las instrucciones por correo electrónico.",
  "Betaalinformatie": "Información de pago",
  "Betaaltermijn": "Plazo de pago",
  "Betaaltermijn (dagen)": "Plazo de pago (días)",
  "Betalen via bankoverschrijving of PayPal · Licentiekey automatisch per e-mail na ontvangst van je betaling": "Pagar mediante transferencia bancaria o PayPal · Clave de licencia automáticamente por correo electrónico tras la recepción de tu pago",
  "Betaling": "Pago",
  "Betaling bewerken": "Editar pago",
  "Betaling niet gevonden": "Pago no encontrado",
  "Betaling ontvangen": "Pago recibido",
  "Betaling ontvangen → licentie automatisch genereren + mailen": "Pago recibido → generar y enviar licencia automáticamente",
  "Betaling succesvol!": "¡Pago realizado con éxito!",
  "Betaling toegevoegd": "Pago añadido",
  "Betaling toevoegen": "Añadir pago",
  "Betaling van bestelling ontvangen? De licentie wordt direct gegenereerd en gemaild.": "¿Pago de pedido recibido? La licencia se generará y enviará por correo electrónico al instante.",
  "Betaling verwerken...": "Procesando pago...",
  "Betaling verwijderd": "Pago eliminado",
  "Betaling verwijderen?": "¿Eliminar pago?",
  "Betaling vindt plaats via de aangeboden betaalmethoden.": "El pago se realiza a través de los métodos de pago ofrecidos.",
  "Betalingen": "Pagos",
  "Betalingen van bon": "Pagos de recibo",
  "Betalingen, Auto handel, Planning, Meldingen (APK), Onderdelen, Rapportage, Documenten en Werkkaart": "Pagos, Compraventa de vehículos, Planificación, Avisos (ITV), Recambios, Informes, Documentos y Orden de trabajo",
  "Betalingen: (deel)betaling per factuur bewerken/verwijderen rechtstreeks vanuit \"Openstaande bonnen\"": "Pagos: editar/eliminar pagos (parciales) por factura directamente desde \"Recibos pendientes\"",
  "Betalingsbewijs / Kwitantie": "Comprobante de pago / Recibo",
  "Betalingsherinnering": "Recordatorio de pago",
  "Betalingsherinnering mailen": "Enviar recordatorio de pago por correo",
  "Betalingskenmerk": "Referencia de pago",
  "Betekenis": "Significado",
  "Bevestiging": "Confirmación",
  "Bevestiging verstuurd": "Confirmación enviada",
  "Bevindingen proefrit": "Observaciones de la prueba de conducción",
  "Bevindingen, gebruikte onderdelen, bijzonderheden…": "Observaciones, recambios usados, detalles…",
  "Bewaar": "Guardar",
  "Bewaar hier je eigen kortingscodes per shop. Ze verschijnen dan bij de knop hierboven.": "Guarda aquí tus propios códigos de descuento por tienda. Aparecerán junto al botón de arriba.",
  "Bewerkbaar controlescherm met betrouwbaarheids-indicatoren per veld": "Pantalla de control editable con indicadores de fiabilidad por campo",
  "Bewerken": "Editar",
  "Bezig": "En curso",
  "Bezig met laden": "Cargando",
  "Bezig met zoeken...": "Buscando...",
  "Bezig...": "Procesando...",
  "Bezig…": "Procesando…",
  "Bezoekers (views)": "Visitantes (vistas)",
  "Bezoekers kunnen zelf van taal wisselen via een duidelijke taalkeuze; een melding laat zien wanneer de taal automatisch is gekozen": "Los visitantes pueden cambiar el idioma por sí mismos mediante una clara selección de idioma; un aviso muestra cuándo se ha seleccionado el idioma automáticamente",
  "Bij uitblijven van betaling kan toegang tot de dienst worden beperkt of beëindigd.": "En caso de impago, el acceso al servicio puede ser restringido o terminado.",
  "Bijbestellen": "Reordenar",
  "Bijgewerkt": "Actualizado",
  "Bijna klaar — betaal je bestelling": "Casi listo — paga tu pedido",
  "Bijv. 06J115403Q": "Ej. 06J115403Q",
  "Bijv. 12-AB-34, Jan de Vries, of B-2025-0042...": "Ej. 12-AB-34, Jan de Vries, o B-2025-0042...",
  "Bijv. Brug 1": "Ej. Puente 1",
  "Bijv. Brug 3 of Buitenplaats": "Ej. Puente 3 o Exterior",
  "Bijv. Schap 3": "Ej. Estantería 3",
  "Bijwerken": "Actualizar",
  "Binnenkort beschikbaar": "Próximamente disponible",
  "Binnenkort: AI-waardebepaling, past-op-analyse en onderdeel-advertenties": "Próximamente: valoración por IA, análisis de compatibilidad y anuncios de recambios",
  "Bj": "Año",
  "Bladeren per categorie en voertuig, met koppeling naar je leveranciers": "Explorar por categoría y vehículo, con enlace a tus proveedores",
  "Boekhoud-suite: Debiteurenbeheer, Kosten/inkoopfacturen, automatische herinneringen, BTW & Winst, Grootboek en Balans": "Suite de contabilidad: Gestión de deudores, Facturas de gastos/compra, recordatorios automáticos, IVA y Beneficios, Libro mayor y Balance",
  "Boekhouding": "Contabilidad",
  "Boekhouding is al up-to-date": "La contabilidad ya está actualizada",
  "Boekhouding — BTW & Winst": "Contabilidad — IVA y Beneficios",
  "Boekhoudrapport": "Informe contable",
  "Boekingen": "Asientos",
  "Bon": "Recibo",
  "Bon aangemaakt": "Recibo creado",
  "Bon layout": "Diseño de recibo",
  "Bon layout: pas layout aan en bekijk het resultaat direct naast elkaar": "Diseño de recibo: ajusta el diseño y visualiza el resultado directamente uno al lado del otro",
  "Bon opgeslagen": "Recibo guardado",
  "Bon verwijderd": "Recibo eliminado",
  "Bon verwijderen?": "¿Eliminar recibo?",
  "Bonnen": "Recibos",
  "Bonnen & facturen met eigen logo, BTW/hobby-modus en print/PDF": "Recibos y facturas con logo propio, modo IVA/hobby e impresión/PDF",
  "Bonnen samenvatting": "Resumen de recibos",
  "Bonnummer": "Número de recibo",
  "Bosnië en Herzegovina": "Bosnia y Herzegovina",
  "Bouwjaar": "Año de fabricación",
  "Bouwjaar (nieuw → oud)": "Año de fabricación (nuevo → antiguo)",
  "Bouwjaar tot": "Año de fabricación hasta",
  "Bouwjaar van": "Año de fabricación desde",
  "Boven marktprijs — kan verkoop vertragen": "Por encima del precio de mercado — puede ralentizar la venta",
  "Brandstof": "Combustible",
  "Brazilië": "Brasil",
  "Break-even": "Punto de equilibrio",
  "Bruggen / werkplekken": "Elevadores / puestos de trabajo",
  "Bruggen / werkplekken toewijzen (instelbaar aantal) + monteur per klus": "Asignar elevadores / puestos de trabajo (número configurable) + mecánico por tarea",
  "Bruggen beheren": "Gestionar elevadores",
  "Bruggen opgeslagen": "Elevadores guardados",
  "Bv. 124500": "Ej. 124500",
  "Bv. Jan de Vries": "Ej. Jan de Vries",
  "Bv. Schap 3": "Ej. Estante 3",
  "Camera starten…": "Iniciar cámara…",
  "Capaciteitswaarschuwing bij dubbele boeking (zelfde brug of monteur)": "Advertencia de capacidad en caso de doble reserva (mismo elevador o mecánico)",
  "Categorie": "Categoría",
  "Categorie wijzigen": "Cambiar categoría",
  "Chassisnummer (VIN)": "Número de bastidor (VIN)",
  "Chassisnummer check (VIN)": "Comprobación del número de bastidor (VIN)",
  "Check je inbox": "Revisa tu bandeja de entrada",
  "Check je spam-map. De mail kan tot een minuut duren.": "Revisa tu carpeta de spam. El correo puede tardar hasta un minuto.",
  "Check mijn voorraad voor dit voertuig": "Consultar mi stock para este vehículo",
  "Checkout mislukt": "Pago fallido",
  "Choose the plan that fits your garage": "Choose the plan that fits your garage",
  "Choose the plan that suits your garage": "Choose the plan that suits your garage",
  "Claim opgeslagen": "Reclamación guardada",
  "Claim verwijderen?": "¿Eliminar reclamación?",
  "Cloud back-up gelukt": "Copia de seguridad en la nube realizada con éxito",
  "Cloud back-up mislukt": "Copia de seguridad en la nube fallida",
  "Cloud koppeling verbreken?": "¿Desconectar conexión a la nube?",
  "Cloud losgekoppeld": "Nube desconectada",
  "Cloud loskoppelen": "Desconectar la nube",
  "Cloud sync": "Sincronización en la nube",
  "Cloud sync vereist een actieve licentie. Ga naar het Licentie tabblad om te activeren.": "La sincronización en la nube requiere una licencia activa. Ve a la pestaña Licencia para activar.",
  "Cloud verbonden!": "¡Nube conectada!",
  "Cloud-synchronisatie van documenten (Dropbox & Google Drive)": "Sincronización de documentos en la nube (Dropbox y Google Drive)",
  "Code": "Código",
  "Code is verplicht": "El código es obligatorio",
  "Compatibel (\"past op\")": "Compatible (\"apto para\")",
  "Concurrentie (indicatie)": "Competencia (indicación)",
  "Conditie": "Condición",
  "Contact": "Contacto",
  "Contact:": "Contacto:",
  "Contactaanvragen": "Solicitudes de contacto",
  "Contactpersoon": "Persona de contacto",
  "Contant": "Efectivo",
  "Controleer voor opslaan": "Verificar antes de guardar",
  "Controlepunt": "Punto de control",
  "Costs per category": "Costs per category",
  "Create a first customer + vehicle via": "Create a first customer + vehicle via",
  "Create your first work order or invoice via": "Create your first work order or invoice via",
  "Created via Diagnosis": "Creado vía Diagnosis",
  "Credit": "Crédito",
  "Crediteren": "Acreditar",
  "Crediteren mislukt": "Fallo al acreditar",
  "Creditfactuur aangemaakt": "Factura de crédito creada",
  "Creditfactuur maken voor": "Crear factura de crédito para",
  "Creditfactuur met 1 klik (negatieve factuur, gekoppeld aan het origineel)": "Factura de crédito con 1 clic (factura negativa, vinculada a la original)",
  "Creditfactuur op": "Factura de crédito en",
  "Curaçao": "Curazao",
  "Custom": "Personalizado",
  "Customer and vehicle details (entered by garage):": "Customer and vehicle details (entered by garage):",
  "DEELS BETAALD": "PAGADO PARCIALMENTE",
  "DOT / bouwweek": "DOT / semana de fabricación",
  "Dag": "Día",
  "Dagen": "Días",
  "Dagen in voorraad": "Días en stock",
  "Dagplanning": "Planificación diaria",
  "Dagplanning afdrukken, gegroepeerd per brug": "Imprimir planificación diaria, agrupada por elevador",
  "Dashboard met omzet-KPI's, openstaande facturen, planning en voorraad-alerts": "Panel con KPI de ventas, facturas pendientes, planificación y alertas de stock",
  "Datum": "Fecha",
  "De AI bekijkt je foto's en herkent kenmerken (velgen, trekhaak, schade, staat) voor de advertentie en waardebepaling.": "La IA analiza tus fotos y reconoce características (llantas, gancho de remolque, daños, estado) para el anuncio y la valoración.",
  "De AI bekijkt je foto\\'s en herkent kenmerken (velgen, trekhaak, schade, staat) voor de advertentie en waardebepaling.": "La IA analiza tus fotos y reconoce características (llantas, gancho de remolque, daños, estado) para el anuncio y la valoración.",
  "De Groot Onderhoud": "Mantenimiento Mayor",
  "De RDW-kentekencheck en het kwartaalrapport naar mijn boekhouder werken vlekkeloos. Echt een aanrader.": "La verificación de matrícula RDW y el informe trimestral a mi contable funcionan a la perfección. Realmente recomendable.",
  "De basis: complete garage-software": "Lo básico: software de gestión de taller completo",
  "De eerste foto is de hoofdfoto. Klik op de ster om een andere foto als hoofdfoto in te stellen.": "La primera foto es la principal. Haz clic en la estrella para establecer otra foto como principal.",
  "De exacte inhoud van de dienst kan op ieder moment worden aangepast, uitgebreid of gewijzigd.": "El contenido exacto del servicio puede ser ajustado, ampliado o modificado en cualquier momento.",
  "De klant blijft volledig verantwoordelijk voor ingevoerde gegevens, documenten, afbeeldingen, voertuiginformatie, klantinformatie en boekhoudkundige gegevens.": "El cliente es totalmente responsable de los datos introducidos, documentos, imágenes, información del vehículo, información del cliente y datos contables.",
  "De klant blijft zelf verantwoordelijk voor het regelmatig maken en controleren van back-ups. MonteurCentraal is niet aansprakelijk voor verlies van gegevens, ongeacht de oorzaak.": "El cliente sigue siendo responsable de realizar y verificar copias de seguridad regularmente. MonteurCentraal no se hace responsable de la pérdida de datos, independientemente de la causa.",
  "De klant is verantwoordelijk voor alle activiteiten die plaatsvinden onder het eigen account.": "El cliente es responsable de todas las actividades que se realicen bajo su propia cuenta.",
  "De klant is verantwoordelijk voor het geheimhouden van inloggegevens.": "El cliente es responsable de mantener la confidencialidad de los datos de inicio de sesión.",
  "De klant kan het gebruik van de dienst op ieder moment beëindigen.": "El cliente puede finalizar el uso del servicio en cualquier momento.",
  "De klant verkrijgt uitsluitend een beperkt gebruiksrecht.": "El cliente obtiene únicamente un derecho de uso limitado.",
  "De klant vrijwaart MonteurCentraal tegen alle aanspraken van derden die voortvloeien uit het gebruik van de dienst, ingevoerde gegevens, gegenereerde documenten, advertenties, facturen, boekhoudkundige gegevens, klantgegevens of voertuiggegevens.": "El cliente exime a MonteurCentraal de toda responsabilidad frente a reclamaciones de terceros derivadas del uso del servicio, datos introducidos, documentos generados, anuncios, facturas, datos contables, datos del cliente o datos del vehículo.",
  "De online afspraken-pagina vult mijn agenda vanzelf. Klanten boeken nu 's avonds zelf, scheelt enorm veel bellen.": "La página de citas online llena mi agenda automáticamente. Los clientes ahora reservan por la noche, lo que ahorra muchísimas llamadas.",
  "De som van alle aandelen zou idealiter 100% moeten zijn.": "La suma de todas las partes debería ser idealmente del 100%.",
  "De som van alle winstaandelen is": "La suma de todas las participaciones en beneficios es",
  "Debet": "Débito",
  "Debiteurenbeheer": "Gestión de deudores",
  "Debiteurenbeheer met ouderdomsanalyse (aging)": "Gestión de deudores con análisis de antigüedad (aging)",
  "Deel": "Compartir",
  "Deel deze link met je klanten zodat zij zelf afspraken kunnen aanvragen. Beheer diensten en openingstijden onder": "Comparte este enlace con tus clientes para que puedan solicitar citas ellos mismos. Gestiona servicios y horarios de apertura en",
  "Deel via WhatsApp": "Compartir por WhatsApp",
  "Deelbare boekingslink voor je website & social media": "Enlace de reserva compartible para tu sitio web y redes sociales",
  "Deelbare boekingslink, diensten + duur, openingstijden en slot-instellingen": "Enlace de reserva compartible, servicios + duración, horarios de apertura y ajustes de franjas horarias",
  "Deelfactuur": "Factura parcial",
  "Deelfactuur / termijn + aanbetaling en kilometerstand op de factuur": "Factura parcial / a plazos + pago inicial y kilometraje en la factura",
  "Deelfactuur aangemaakt": "Factura parcial creada",
  "Deelfactuur maken": "Crear factura parcial",
  "Deelfactuur mislukt": "Factura parcial fallida",
  "Deelontvangst geboekt": "Pago parcial registrado",
  "Deeplinks": "Enlaces directos",
  "Deeplinks kopiëren": "Copiar enlaces directos",
  "Defect / voor onderdelen": "Defectuoso / para piezas",
  "Delen via WhatsApp + exporteren als PDF": "Compartir por WhatsApp + exportar como PDF",
  "Demontage": "Desmontaje",
  "Demontagedatum": "Fecha de desmontaje",
  "Detail": "Detalle",
  "Deze algemene voorwaarden zijn van toepassing op ieder gebruik van de software, website, diensten en functionaliteiten van MonteurCentraal.": "Estas condiciones generales se aplican a cualquier uso del software, sitio web, servicios y funcionalidades de MonteurCentraal.",
  "Deze beperking geldt niet voor aansprakelijkheid die volgens Nederlands recht niet mag worden uitgesloten.": "Esta limitación no se aplica a la responsabilidad que no pueda excluirse según la legislación neerlandesa.",
  "Deze bon is opgesteld in hobby-/particulier-modus. Er wordt geen BTW in rekening gebracht.": "Este recibo se ha emitido en modo aficionado/particular. No se cobra IVA.",
  "Deze instellingen worden gebruikt op alle nieuwe bonnen, offertes en facturen van": "Estos ajustes se utilizarán en todos los nuevos recibos, presupuestos y facturas de",
  "Deze klant heeft geen e-mailadres": "Este cliente no tiene dirección de correo electrónico",
  "Deze maand": "Este mes",
  "Deze voorwaarden gelden voor alle gebruikers van MonteurCentraal. Indien een bepaling ongeldig blijkt te zijn, blijven de overige bepalingen volledig van kracht.": "Estas condiciones son aplicables a todos los usuarios de MonteurCentraal. Si una disposición resulta ser inválida, las demás disposiciones seguirán siendo plenamente válidas.",
  "Deze week": "Esta semana",
  "Diagnose definitief vastleggen...": "Registrar diagnóstico definitivamente...",
  "Diagnose opgeslagen": "Diagnóstico guardado",
  "Diagnosestappen": "Pasos del diagnóstico",
  "Dicht": "Cerrado",
  "Dienst": "Servicio",
  "Dienst toevoegen": "Añadir servicio",
  "Dienst:": "Servicio:",
  "Diensten & duur": "Servicios y duración",
  "Diensten met eigen duur (APK, onderhoud, banden…)": "Servicios con duración propia (ITV, mantenimiento, neumáticos…)",
  "Digitale werkorder": "Orden de trabajo digital",
  "Direct vanuit de advertentie publiceren in je showroom": "Publicar directamente desde el anuncio en tu showroom",
  "Distributieriem recent vervangen": "Correa de distribución sustituida recientemente",
  "Distributieriem vervangen": "Correa de distribución sustituida",
  "Distributieriem vervangen bij 200.000 km": "Correa de distribución sustituida a los 200.000 km",
  "Dit duurt enkele seconden": "Esto tardará unos segundos",
  "Dit is een voorbeeld. De weergave kan afwijken van het echte platform.": "Esto es un ejemplo. La visualización puede diferir de la plataforma real.",
  "Dit is mock-data zonder echt bestand. Upload nieuwe documenten voor echte downloads.": "Datos de prueba sin archivo real. Sube nuevos documentos para descargas reales.",
  "Dit jaar": "Este año",
  "Dit kwartaal": "Este trimestre",
  "Dit voertuig bestaat al — er wordt geen dubbele aangemaakt": "Este vehículo ya existe — no se creará un duplicado",
  "Dit zijn garages zonder actieve betaalde licentie — potentiële upgrade-leads. Klik op een e-mailadres om contact op te nemen.": "Estos son talleres sin licencia de pago activa — posibles leads de actualización. Haz clic en una dirección de correo electrónico para contactar.",
  "Document": "Documento",
  "Document verwijderd": "Documento eliminado",
  "Document verwijderen?": "¿Eliminar documento?",
  "Documenten": "Documentos",
  "Documenten: upload PDF/foto, sync naar cloud bij actieve licentie": "Documentos: sube PDF/foto, sincroniza a la nube con licencia activa",
  "Documenttitel": "Título del documento",
  "Donker": "Oscuro",
  "Donor-sloopauto koppelen vanuit de onderdeelkaart — vult automatisch \"afkomstig van\", kenteken, merk en bouwjaar": "Vincular vehículo donante/desguace desde la ficha de pieza — rellena automáticamente \"procedente de\", matrícula, marca y año de fabricación",
  "Donorvoertuig": "Vehículo donante",
  "Door": "Por",
  "Door een account aan te maken of gebruik te maken van de dienst verklaart de gebruiker akkoord te gaan met deze voorwaarden.": "Al crear una cuenta o utilizar el servicio, el usuario acepta estas condiciones.",
  "Door te ondertekenen gaat u akkoord met de werkzaamheden. Datum, tijd en apparaatgegevens worden vastgelegd.": "Al firmar, acepta los trabajos realizados. Se registrarán la fecha, la hora y los datos del dispositivo.",
  "Doorgaan met invoeren": "Continuar introduciendo",
  "Doorgaan naar app": "Continuar a la aplicación",
  "Download back-up": "Descargar copia de seguridad",
  "Download een complete JSON snapshot van alle data (klanten, voertuigen, bonnen, planning, voorraad, betalingen, etc). Bewaar dit bestand op een veilige plek (Dropbox / Google Drive / externe schijf).": "Descargue un snapshot JSON completo de todos los datos (clientes, vehículos, recibos, planificación, stock, pagos, etc.). Guarde este archivo en un lugar seguro (Dropbox / Google Drive / disco externo).",
  "Download foto\\'s": "Descargar fotos",
  "Download mislukt": "Descarga fallida",
  "Drukgroep en druklager worden vaak samen met een koppeling vervangen.": "El plato de presión y el cojinete de empuje se suelen sustituir junto con el embrague.",
  "Dubbel boekhouden — saldi per grootboekrekening, automatisch geboekt": "Contabilidad por partida doble — saldos por cuenta del libro mayor, registrados automáticamente",
  "Dubbel boekhouden — saldi per grootboekrekening, automatisch geboekt uit je facturen, betalingen en kosten": "Contabilidad por partida doble — saldos por cuenta del libro mayor, registrados automáticamente a partir de tus facturas, pagos y gastos",
  "Dubbelklik om te bewerken": "Doble clic para editar",
  "Duur": "Duración",
  "Duur (minuten)": "Duración (minutos)",
  "E-mail": "Correo electrónico",
  "E-mail (mock)": "Correo electrónico (simulado)",
  "E-mail / gebruikersnaam": "Correo electrónico / nombre de usuario",
  "E-mail eigenaar": "Correo electrónico del propietario",
  "E-mail mislukt": "Error de envío de correo electrónico",
  "E-mail niet geconfigureerd": "Correo electrónico no configurado",
  "E-mail verstuurd": "Correo electrónico enviado",
  "E-mailactivatie bij registratie + wachtwoord-reset (Resend)": "Activación de correo electrónico al registrarse + restablecimiento de contraseña (Reenviar)",
  "E-mailadres boekhouder": "Dirección de correo electrónico del contable",
  "E-mailherinnering voor APK rechtstreeks naar de klant": "Recordatorio por correo electrónico de la ITV directamente al cliente",
  "E.g. 12-AB-34, Jan de Vries, or B-2025-0042...": "Ej. 12-AB-34, Jan de Vries, o B-2025-0042...",
  "Each customer will receive a maximum of 1 email per level (consolidating all outstanding invoices). Customers without an email address will be skipped.": "Each customer will receive a maximum of 1 email per level (consolidating all outstanding invoices). Customers without an email address will be skipped.",
  "Editor": "Editor",
  "Een eigen boekingspagina die 24/7 doorwerkt — ook als jij onder een auto ligt.": "Una página de reservas propia que funciona 24/7 — incluso cuando estás debajo de un coche.",
  "Een licentie geeft uitsluitend een gebruiksrecht. De software wordt niet verkocht.": "Una licencia concede únicamente un derecho de uso. El software no se vende.",
  "Een licentie wordt gebonden aan jouw garage bij activatie - hergebruik door een andere garage wordt geblokkeerd.": "Una licencia se vincula a tu taller al activarla - se bloquea la reutilización por otro taller.",
  "Eerlijke vermelding van schade/aandachtspunten + sterke/verbeterpunten": "Mención honesta de daños/puntos a tener en cuenta + puntos fuertes/a mejorar",
  "Eerste activatie": "Primera activación",
  "Eigen app-icoon en offline-melding bij geen verbinding": "Icono de aplicación propio y notificación sin conexión",
  "Eigen kortingscodes": "Códigos de descuento propios",
  "Eigen link: monteurcentraal.com/showroom/jouw-garage": "Enlace propio: monteurcentraal.com/showroom/tu-taller",
  "Eigen onderdeel toevoegen…": "Añadir pieza propia…",
  "Eigen publieke verkooppagina: monteurcentraal.com/showroom/jouw-garage": "Página de venta pública propia: monteurcentraal.com/showroom/tu-taller",
  "Eigenaar": "Propietario",
  "Eindelijk alles op één plek. Facturen, planning én boekhouding. Bespaart me elke week uren administratie.": "Por fin todo en un solo lugar. Facturas, planificación y contabilidad. Me ahorra horas de administración cada semana.",
  "Elke klant ontvangt per niveau maximaal 1 e-mail (gebundeld over alle openstaande facturen). Klanten zonder e-mailadres worden overgeslagen.": "Cada cliente recibirá un máximo de 1 correo electrónico por nivel (consolidando todas las facturas pendientes). Los clientes sin dirección de correo electrónico serán omitidos.",
  "Enter at least license plate or make/model": "Enter at least license plate or make/model",
  "Enter city and street via postcode + house number": "Introducir ciudad y calle a través de código postal + número de casa",
  "Enter postcode via street + city": "Introducir código postal a través de calle + ciudad",
  "Enter postcode via street + house number + city": "Introducir código postal a través de calle + número de casa + ciudad",
  "Enthousiast": "Entusiasmado",
  "Er ging iets mis. Probeer het later opnieuw.": "Algo salió mal. Inténtelo de nuevo más tarde.",
  "Er ging iets mis. Probeer het opnieuw.": "Algo salió mal. Inténtelo de nuevo.",
  "Er ging iets mis:": "Algo salió mal:",
  "Er is geen lopend werk.": "No hay ningún trabajo en curso.",
  "Er staan al credentials opgeslagen voor dit account.": "Ya hay credenciales guardadas para esta cuenta.",
  "Ethiopië": "Etiopía",
  "Even geduld, we controleren je betaling": "Un momento, estamos verificando su pago",
  "Eventuele juridische kosten en schade voortvloeiend uit dergelijke aanspraken komen voor rekening van de klant.": "Cualquier costo legal y daño derivado de tales reclamaciones correrá por cuenta del cliente.",
  "Excl. BTW": "Excl. IVA",
  "Export boekhouder": "Exportación para el contable",
  "Export gestart": "Exportación iniciada",
  "Export naar Excel (mock)": "Exportar a Excel (simulado)",
  "Export voor de boekhouder (CSV met alle facturen & creditfacturen)": "Exportación para el contable (CSV con todas las facturas y abonos)",
  "Exporteer een afschrift uit je bankieromgeving (ING/Rabobank/ABN AMRO) als MT940 (.sta/.txt) of CAMT.053 (.xml) en sleep het hier in.": "Exporte un extracto de su entorno bancario (ING/Rabobank/ABN AMRO) como MT940 (.sta/.txt) o CAMT.053 (.xml) y arrástrelo aquí.",
  "Exporteren (CSV)": "Exportar (CSV)",
  "Exporteren (PDF)": "Exportar (PDF)",
  "Extra info (optioneel)": "Información adicional (opcional)",
  "Eén klik en je auto staat online te koop": "Un clic y su coche está a la venta online",
  "Facebook staat automatisch plaatsen niet toe. Met deze knop kopiëren we de tekst, downloaden we je foto's en openen we Facebook Marketplace — daar plak je de tekst en sleep je de foto's erin.": "Facebook no permite la publicación automática. Con este botón, copiamos el texto, descargamos sus fotos y abrimos Facebook Marketplace; allí, pegue el texto y arrastre las fotos.",
  "Facebook staat automatisch plaatsen niet toe. Met deze knop kopiëren we de tekst, downloaden we je foto\\'s en openen we Facebook Marketplace — daar plak je de tekst en sleep je de foto\\'s erin.": "Facebook no permite la publicación automática. Con este botón, copiamos el texto, descargamos sus fotos y abrimos Facebook Marketplace; allí, pegue el texto y arrastre las fotos.",
  "Facturatie en licentiebeheer (uitvoering overeenkomst / wettelijke plicht).": "Facturación y gestión de licencias (ejecución de contrato / obligación legal).",
  "Facturen met eigen logo": "Facturas con logo propio",
  "Factuur": "Factura",
  "Factuur aan": "Factura a",
  "Factuur aanmaken": "Crear factura",
  "Factuurnr.": "N.º factura",
  "Factuurnummer": "Número de factura",
  "Factuurnummers per jaar (F-2026-0001 …) met automatische reset per jaar": "Números de factura por año (F-2026-0001 …) con reinicio automático anual",
  "Faeröer": "Islas Feroe",
  "Februari–Mei 2026": "Febrero–Mayo 2026",
  "Fetch make/model/year via chassis number": "Obtener marca/modelo/año a través del número de chasis",
  "Fill in via postcode": "Rellenar con código postal",
  "Financiële en operationele rapporten": "Informes financieros y operativos",
  "Find postcode via street + city": "Buscar código postal a través de calle + ciudad",
  "Flip-calculatie": "Cálculo de reventa",
  "Fooi": "Propina",
  "Fooi (€)": "Propina (€)",
  "Fooi moet tussen 0 en het bedrag liggen": "La propina debe estar entre 0 y el importe total",
  "Foto's": "Fotos",
  "Foto's toegevoegd — analyseren met AI…": "Fotos añadidas — analizando con IA…",
  "Foto's uploaden voor waardebepaling": "Subir fotos para valoración",
  "Foto's uploaden → AI herkent het onderdeel en vult automatisch naam, categorie, merk, nummers, conditie en prijs in": "Subir fotos → la IA reconoce la pieza y rellena automáticamente el nombre, categoría, marca, números, estado y precio",
  "Foto-analyse, winstberekening, verkoopscore, verwachte verkooptijd en concurrentie": "Análisis de fotos, cálculo de ganancias, puntuación de venta, tiempo de venta esperado y competencia",
  "Foto-analyse: AI herkent velgen, trekhaak, schade en staat": "Análisis de fotos: la IA reconoce llantas, enganche de remolque, daños y estado",
  "Foto\\'s": "Fotos",
  "Foto\\'s (max 6) — AI herkent opties & schade": "Fotos (máx. 6) — la IA reconoce opciones y daños",
  "Foto\\'s gedownload": "Fotos descargadas",
  "Foto\\'s toegevoegd — analyseren met AI…": "Fotos añadidas — analizando con IA…",
  "Foto\\'s uploaden": "Subir fotos",
  "Foto\\'s uploaden voor waardebepaling": "Subir fotos para valoración",
  "Fotoanalyse mislukt": "Análisis de fotos fallido",
  "Foutcode(s)": "Código(s) de error",
  "Foutcodes": "Códigos de error",
  "Foutcodes (DTC's) automatisch herkend en uitgelegd": "Códigos de error (DTC's) reconocidos y explicados automáticamente",
  "Fraude- en misbruikpreventie (gerechtvaardigd belang).": "Prevención de fraude y abuso (interés legítimo).",
  "Functie": "Función",
  "Functies en versies van MonteurCentraal": "Funciones y versiones de MonteurCentraal",
  "Ga naar": "Ir a",
  "Garage": "Taller",
  "Garage Account Details:": "Detalles de la cuenta del taller:",
  "Garage El Aoufi": "Taller El Aoufi",
  "Garage Janssen": "Taller Janssen",
  "Garage details saved": "Detalles del taller guardados",
  "Garage info": "Información del taller",
  "Garage info saved": "Información del taller guardada",
  "Garage informed by email": "Taller informado por correo electrónico",
  "Garage is per e-mail geïnformeerd": "El taller ha sido informado por correo electrónico",
  "Garage management": "Gestión de taller",
  "Garage management for modern workshops": "Gestión de taller para talleres modernos",
  "Garage management voor moderne werkplaatsen": "Gestión de taller para talleres modernos",
  "Garage name": "Nombre del taller",
  "Garage name required": "Nombre del taller obligatorio",
  "Garagegegevens opgeslagen": "Datos del taller guardados",
  "Garagenaam": "Nombre del taller",
  "Garagenaam verplicht": "Nombre del taller obligatorio",
  "Garages met online boeken vullen hun agenda gemiddeld voller — zonder extra werk.": "Los talleres con reservas online, de media, completan más su agenda — sin trabajo extra.",
  "Garantie (maanden)": "Garantía (meses)",
  "Garantie (niet gefactureerd)": "Garantía (no facturada)",
  "Garantieclaim bewerken": "Editar reclamación de garantía",
  "Garantieclaims": "Reclamaciones de garantía",
  "Geactiveerd op": "Activado el",
  "Geactiveerd!": "¡Activado!",
  "Geannuleerd": "Cancelado",
  "Gearchiveerd": "Archivado",
  "Gebaseerd op km & onderhoud": "Basado en km y mantenimiento",
  "Gebruik adviesprijs als vraagprijs": "Usar precio recomendado como precio de venta",
  "Gebruik deze tekst (OK)": "Usar este texto (Aceptar)",
  "Gebruiker": "Usuario",
  "Gebruiks- en apparaatgegevens:": "Datos de uso y dispositivo:",
  "Gebruikte marktwaarde": "Valor de mercado aplicado",
  "Geef een geldige taalcode (bv. de)": "Introduce un código de idioma válido (ej. de)",
  "Geef een geldige taalcode (bv. de, fr, es)": "Introduce un código de idioma válido (ej. de, fr, es)",
  "Geen": "Ninguno",
  "Geen (Nederlands) kenteken? Scan de autopapieren — ook buitenlands (bv. Duits) — en de AI vult de gegevens in.": "¿No tienes matrícula (neerlandesa)? Escanea los documentos del coche — incluso extranjeros (ej. alemán) — y la IA rellenará los datos.",
  "Geen APK's vervallen binnenkort.": "Ninguna ITV caduca pronto.",
  "Geen BTW (hobby/particulier)": "Sin IVA (aficionado/particular)",
  "Geen BTW van toepassing (hobby/particulier)": "IVA no aplicable (hobby/particular)",
  "Geen NL-kenteken? Scan de (buitenlandse) autopapieren met AI.": "¿No tienes matrícula neerlandesa? Escanea los papeles del coche (extranjero) con IA.",
  "Geen RDW-gegevens gevonden": "No se han encontrado datos de RDW",
  "Geen RDW-gegevens gevonden voor dit kenteken": "No se han encontrado datos de RDW para esta matrícula",
  "Geen actieve licentie — BASIC mode (gratis)": "Sin licencia activa — modo BASIC (gratis)",
  "Geen activa": "Sin activos",
  "Geen activa geboekt": "No se han registrado activos",
  "Geen activiteit voor dit filter.": "Ninguna actividad para este filtro.",
  "Geen afspraken op deze dag.": "No hay citas para este día.",
  "Geen afspraken vandaag.": "Sin citas hoy.",
  "Geen artikelen gevonden voor": "No se han encontrado artículos para",
  "Geen auto geselecteerd": "Ningún coche seleccionado",
  "Geen beschikbare tijden op deze dag. Kies een andere datum.": "No hay horarios disponibles para este día. Elige otra fecha.",
  "Geen bon geselecteerd": "Ningún recibo seleccionado",
  "Geen bonnen gevonden.": "No se han encontrado recibos.",
  "Geen camera? Upload hieronder een foto van de code.": "¿No tienes cámara? Sube una foto del código a continuación.",
  "Geen code": "Sin código",
  "Geen code gevonden in de foto. Kies een scherpe foto van de QR-/streepjescode.": "No se ha encontrado ningún código en la foto. Elige una foto nítida del código QR/de barras.",
  "Geen data": "Sin datos",
  "Geen documenten gevonden.": "No se han encontrado documentos.",
  "Geen e-mail verstuurd": "No se ha enviado ningún correo electrónico",
  "Geen e-mailadres bekend": "No se conoce la dirección de correo electrónico",
  "Geen enkele AI-data wordt meer zonder jouw bevestiging weggeschreven": "Ningún dato de IA se guardará sin tu confirmación.",
  "Geen extra voertuigen gevonden": "No se han encontrado vehículos adicionales",
  "Geen foto's om te downloaden": "No hay fotos para descargar",
  "Geen foto\\'s om te downloaden": "No hay fotos para descargar",
  "Geen foutcodes": "Sin códigos de error",
  "Geen gratis accounts gevonden.": "No se han encontrado cuentas gratuitas.",
  "Geen historie - prijs is nog niet aangepast.": "Sin historial - el precio aún no se ha ajustado.",
  "Geen huisnummer gevonden in adresveld": "No se ha encontrado número de casa en el campo de dirección",
  "Geen huisnummer in adres": "Sin número de casa en la dirección",
  "Geen kenteken? Upload een foto van de autopapieren (ook buitenlands, bv. Duits) — de AI vult merk, model, bouwjaar enz. in.": "¿No tienes matrícula? Sube una foto de los papeles del coche (también extranjeros, por ejemplo, alemanes) — la IA rellenará la marca, el modelo, el año de fabricación, etc.",
  "Geen keys gevonden voor": "No se han encontrado claves para",
  "Geen klant gekoppeld": "Ningún cliente asociado",
  "Geen klant geselecteerd": "Ningún cliente seleccionado",
  "Geen klanten gevonden.": "No se han encontrado clientes.",
  "Geen licentie?": "¿Sin licencia?",
  "Geen logo": "Sin logo",
  "Geen mail?": "¿No hay correo?",
  "Geen monteur": "Ningún mecánico",
  "Geen omschrijving": "Sin descripción",
  "Geen omzet in deze periode": "No hay ingresos en este período",
  "Geen onderdeel gevonden met code": "No se ha encontrado ninguna pieza con el código",
  "Geen onderdelen gevonden.": "No se han encontrado piezas.",
  "Geen openstaande facturen.": "Sin facturas pendientes.",
  "Geen openstaande facturen. Alle debiteuren hebben betaald!": "Sin facturas pendientes. ¡Todos los deudores han pagado!",
  "Geen openstaande facturen. Alle debiteuren hebben betaald! 🎉": "Sin facturas pendientes. ¡Todos los deudores han pagado! 🎉",
  "Geen passende onderdelen in voorraad gevonden": "No se han encontrado piezas adecuadas en stock",
  "Geen passende onderdelen in voorraad.": "No hay piezas adecuadas en stock.",
  "Geen regels.": "Sin reglas.",
  "Geen resultaat. Probeer opnieuw te genereren.": "No se obtuvo ningún resultado. Intente generarlo de nuevo.",
  "Geen resultaten": "Sin resultados",
  "Geen resultaten gevonden voor": "No se encontraron resultados para",
  "Geen resultaten voor deze filters.": "Sin resultados para estos filtros.",
  "Geen specificaties": "Sin especificaciones",
  "Geen teamleden.": "Sin miembros de equipo.",
  "Geen toegang": "Acceso denegado",
  "Geen verborgen kosten. Upgrade of downgrade op elk moment via je licentie key.": "Sin costes ocultos. Actualice o baje de categoría en cualquier momento a través de su clave de licencia.",
  "Geen vervallen herinneringen om te versturen": "No hay recordatorios vencidos para enviar",
  "Geen voertuig gekoppeld": "Ningún vehículo vinculado",
  "Geen voertuigdata": "Sin datos del vehículo",
  "Geen voertuigen": "Sin vehículos",
  "Geen voertuigen geregistreerd. Klik 'Voertuig toevoegen' hierboven.": "No hay vehículos registrados. Haga clic en 'Añadir vehículo' arriba.",
  "Geen voertuigen gevonden.": "No se encontraron vehículos.",
  "Geen voorschotten gevonden": "No se encontraron anticipos.",
  "Geen voorschotten in deze categorie.": "No hay anticipos en esta categoría.",
  "Geen webcam? Maak/kies een foto van de QR- of streepjescode.": "¿No tiene webcam? Tome/elija una foto del código QR o de barras.",
  "Geen werkplek": "Sin puesto de trabajo",
  "Gefactureerd": "Facturado",
  "Gegevens": "Datos",
  "Gegevens ingelezen": "Datos importados",
  "Gegevens: garagegegevens en factuurinformatie centraal beheren": "Datos: gestione de forma centralizada los datos del taller y la información de facturación.",
  "Gekopieerd": "Copiado",
  "Gekopieerd naar klembord": "Copiado al portapapeles",
  "Gekopieerd!": "¡Copiado!",
  "Gekoppeld aan": "Vinculado a",
  "Gekoppelde bon": "Recibo vinculado",
  "Geldig tot": "Válido hasta",
  "Gelieve het openstaande bedrag binnen 14 dagen over te maken naar IBAN": "Por favor, transfiera el importe pendiente en un plazo de 14 días a la cuenta IBAN",
  "Geluiden, trillingen, remweg, sturen…": "Sonidos, vibraciones, distancia de frenado, dirección…",
  "Gem. dagen open": "Días abiertos (media)",
  "Gem. factuurwaarde": "Valor medio de factura",
  "Gemiddeld": "Promedio",
  "Gemiddeld per beurt": "Promedio por servicio",
  "Gemiddelde vraagprijs": "Precio de venta promedio",
  "Gemini-sleutel opgeslagen en getest ✓": "Clave Gemini guardada y probada ✓",
  "Gemini-sleutel verwijderen? AI-functies werken daarna niet meer.": "¿Eliminar clave Gemini? Las funciones de IA dejarán de funcionar después.",
  "Genereer": "Generar",
  "Genereer eerst de advertentie": "Genere el anuncio primero",
  "Genereer met AI een verkoopadvertentie voor losse onderdelen (Marktplaats, Facebook en forum)": "Genere con IA un anuncio de venta para piezas sueltas (Marktplaats, Facebook y foro)",
  "Genereer onderdelen": "Generar piezas",
  "Genereer onderdelenlijst": "Generar lista de piezas",
  "Genereren mislukt": "Error al generar",
  "Geopend": "Abierto",
  "Geopend?": "¿Abierto?",
  "Georgië": "Georgia",
  "Gepubliceerd": "Publicado",
  "Gepubliceerd in showroom!": "¡Publicado en la sala de exposición!",
  "Geregistreerde betalingen en openstaande facturen": "Pagos registrados y facturas pendientes",
  "Gereserveerd": "Reservado",
  "Gescand": "Escaneado",
  "Geschatte arbeidstijd": "Tiempo de trabajo estimado",
  "Geschatte duur": "Duración estimada",
  "Geschatte staat": "Estado estimado",
  "Geselecteerde onderdelen markeren als verkocht?": "¿Marcar las piezas seleccionadas como vendidas?",
  "Geselecteerde onderdelen verwijderen?": "¿Eliminar las piezas seleccionadas?",
  "Gesloten": "Cerrado",
  "Gevonden": "Encontrado",
  "Gevonden:": "Encontrado:",
  "Geëxporteerd": "Exportado",
  "Geüpload": "Subido",
  "Geüploade documenten worden automatisch gesynchroniseerd naar je cloud.": "Los documentos subidos se sincronizarán automáticamente con tu nube.",
  "Gmail tip:": "Consejo de Gmail:",
  "Goedkoop": "Económico",
  "Gratis": "Gratis",
  "Gratis accounts": "Cuentas gratuitas",
  "Gratis instapplan": "Plan de entrada gratuito",
  "Gratis pakketten, proefperiodes en promoties kunnen op ieder moment worden gewijzigd, beperkt of beëindigd.": "Los paquetes gratuitos, períodos de prueba y promociones pueden ser modificados, limitados o cancelados en cualquier momento.",
  "Gratis variant - upgrade voor onbeperkt gebruik en cloud sync.": "Versión gratuita - actualiza para uso ilimitado y sincronización en la nube.",
  "Grootboek": "Libro mayor",
  "Grootte": "Tamaño",
  "Grote beurt + remblokken voor": "Revisión mayor + pastillas de freno delanteras",
  "HOOFD": "PRINCIPAL",
  "Haal RDW-gegevens op": "Obtener datos del RDW",
  "Haal merk/model/APK op via RDW": "Obtener marca/modelo/ITV a través del RDW",
  "Haal merk/model/bouwjaar op via chassisnummer": "Obtener marca/modelo/año de fabricación a través del número de chasis",
  "Hallo, ik heb interesse in:": "Hola, me interesa:",
  "Handel in voorraad": "Stock comercial",
  "Handel verkocht": "Vehículos comerciales vendidos",
  "Handel: flip-calculatie per auto (kostprijs, netto marge, ROI% en dagen in voorraad) + afvinkbare RDW-titelchecklist": "Comercio: cálculo de reventa por coche (precio de coste, margen neto, % ROI y días en stock) + lista de verificación de títulos RDW con casilla de verificación",
  "Handelsvoorraad en verkochte voertuigen": "Stock comercial y vehículos vendidos",
  "Handelvoorraad": "Stock comercial",
  "Handtekening": "Firma",
  "Haïti": "Haití",
  "Heb je al een account? Klik op \"Inloggen\" boven.": "¿Ya tienes una cuenta? Haz clic en \"Iniciar sesión\" arriba.",
  "Heel jaar": "Todo el año",
  "Helaas": "Lamentablemente",
  "Herhalen": "Repetir",
  "Herinnering": "Recordatorio",
  "Herinnering sturen": "Enviar recordatorio",
  "Herinnering verstuurd": "Recordatorio enviado",
  "Herinnering verstuurd naar": "Recordatorio enviado a",
  "Herinneringen nu versturen": "Enviar recordatorios ahora",
  "Herinneringen versturen na (dagen sinds factuurdatum):": "Enviar recordatorios después de (días desde la fecha de factura):",
  "Herstellen": "Restaurar",
  "Het delen van accounts, licenties of toegangsgegevens met derden is niet toegestaan, tenzij dit uitdrukkelijk is toegestaan binnen het gekozen pakket.": "No está permitido compartir cuentas, licencias o datos de acceso con terceros, a menos que esté expresamente permitido dentro del paquete elegido.",
  "Het is niet toegestaan beveiligingen te omzeilen.": "No está permitido eludir las medidas de seguridad.",
  "Het is niet toegestaan de dienst te misbruiken of schadelijke software te verspreiden.": "No está permitido hacer un uso indebido del servicio o distribuir software malicioso.",
  "Het is niet toegestaan de software te reverse-engineeren.": "No está permitido aplicar ingeniería inversa al software.",
  "Het is niet toegestaan onrechtmatige gegevens op te slaan of rechten van derden te schenden.": "No está permitido almacenar datos ilegales o infringir los derechos de terceros.",
  "Het leveren en beveiligen van de dienst (uitvoering overeenkomst).": "La prestación y seguridad del servicio (ejecución del contrato).",
  "Het saldo = (winst% × totale omzet) + openstaande voorschotten. Als een voorschot verrekend wordt, gaat het van \"open\" naar \"verrekend\" en valt het uit het saldo.": "El saldo = (% de beneficio × facturación total) + anticipos pendientes. Cuando un anticipo se compensa, pasa de \"abierto\" a \"compensado\" y deja de formar parte del saldo.",
  "Het versturen van afspraak-, herinnerings- en servicemails (uitvoering overeenkomst).": "El envío de correos electrónicos de citas, recordatorios y servicio (ejecución del contrato).",
  "Hobby modus": "Modo aficionado",
  "Hobby modus - geen BTW van toepassing": "Modo aficionado - IVA no aplicable",
  "Hoe werkt activatie?": "¿Cómo funciona la activación?",
  "Hoe werkt het?": "¿Cómo funciona?",
  "Hoewel MonteurCentraal maatregelen neemt om gegevensverlies te voorkomen, wordt geen garantie gegeven dat gegevens nooit verloren gaan.": "Aunque MonteurCentraal toma medidas para prevenir la pérdida de datos, no se garantiza que estos nunca se pierdan.",
  "Honderden monteurs werken dagelijks met MonteurCentraal": "Cientos de mecánicos trabajan a diario con MonteurCentraal",
  "Hoofd": "Principal",
  "Hoofdvoertuig": "Vehículo principal",
  "Hoog": "Alto",
  "Hostingprovider": "Proveedor de hosting",
  "Huidig wachtwoord": "Contraseña actual",
  "Huisnummer": "Número",
  "IBAN": "IBAN",
  "IP-adres": "Dirección IP",
  "IP-adres, browser/apparaat, activiteitstijdstippen (voor beveiliging en het activatielogboek van je licentie).": "Dirección IP, navegador/dispositivo, horas de actividad (para seguridad y el registro de activación de tu licencia).",
  "Ik heb al een licentiekey →": "Ya tengo una clave de licencia →",
  "Importeer een MT940- of CAMT.053-afschrift en letter automatisch af tegen facturen en kosten": "Importa un extracto MT940 o CAMT.053 y concilia automáticamente con facturas y gastos.",
  "Importeer een bankafschrift (MT940 of CAMT.053) en letter automatisch af tegen openstaande facturen en kosten.": "Importa un extracto bancario (MT940 o CAMT.053) y concilia automáticamente con facturas y gastos pendientes.",
  "In balans": "En equilibrio",
  "In uitvoering": "En curso",
  "In voorraad": "En stock",
  "In voorraad — past op": "En stock — compatible con",
  "Incl. BTW": "IVA incluido",
  "Indicatief overzicht op basis van je facturen en kosten. Raadpleeg je boekhouder voor de definitieve aangifte.": "Resumen indicativo basado en tus facturas y gastos. Consulta a tu contable para la declaración final.",
  "Indicatief overzicht op basis van je facturen, betalingen en kosten. Raadpleeg je boekhouder voor de definitieve aangifte en jaarrekening.": "Resumen indicativo basado en tus facturas, pagos y gastos. Consulta a tu contable para la declaración final y las cuentas anuales.",
  "Indicatieve balans op basis van automatisch gegenereerde journaalposten. Voor de officiële jaarrekening: raadpleeg je boekhouder.": "Balance indicativo basado en asientos contables generados automáticamente. Para las cuentas anuales oficiales: consulta a tu contable.",
  "Indicatieve marktprijs": "Precio de mercado indicativo",
  "Indicatieve marktprijs, verkoopkans, verwachte winst en sterke/verbeterpunten": "Precio de mercado indicativo, oportunidad de venta, beneficio esperado y puntos fuertes/a mejorar",
  "Indonesië": "Indonesia",
  "Ingebouwd": "Integrado",
  "Ingekocht op": "Comprado el",
  "Ingetrokken": "Anulado",
  "Inkoop": "Compras",
  "Inkoop, handel & extra AI-tools": "Compras, comercio y herramientas de IA adicionales",
  "Inkoopbron / leverancier": "Fuente de compra / proveedor",
  "Inkoopbron/leverancier, retourstatus en garantie per onderdeel": "Fuente de compra/proveedor, estado de devolución y garantía por pieza",
  "Inkoopdatum": "Fecha de compra",
  "Inkooporder": "Orden de compra",
  "Inkooporder (concept) aangemaakt": "Orden de compra (borrador) creada",
  "Inkooporder ontvangen → vrije regels worden automatisch als nieuw voorraad-artikel aangemaakt (met OEM-nr en verkoopadvies)": "Orden de compra recibida → las líneas libres se crean automáticamente como un nuevo artículo en stock (con n.º OEM y precio de venta recomendado)",
  "Inkooporder verwijderen?": "¿Eliminar orden de compra?",
  "Inkooporders": "Órdenes de compra",
  "Inkoopprijs": "Precio de compra",
  "Inlezen mislukt": "Error al cargar",
  "Inloggen": "Iniciar sesión",
  "Inloggen mislukt": "Error al iniciar sesión",
  "Inruil voor handel A3": "Permuta para comercio A3",
  "Inschakelen": "Habilitar",
  "Installeer": "Instalar",
  "Installeren": "Instalar",
  "Instellen": "Configurar",
  "Instellingen": "Ajustes",
  "Instellingen opgeslagen": "Ajustes guardados",
  "Instellingen → Licentie": "Ajustes → Licencia",
  "Instellingen: licentie, cloud, team, SMTP en back-up op 1 plek": "Ajustes: licencia, nube, equipo, SMTP y copia de seguridad en un solo lugar",
  "Intern (niet gefactureerd)": "Interno (no facturado)",
  "Interval": "Intervalo",
  "Interval (km)": "Intervalo (km)",
  "Interval (maanden)": "Intervalo (meses)",
  "Interval starttijden (min)": "Intervalo de horas de inicio (min)",
  "Intrekken": "Retirar",
  "Invloed op waarde": "Impacto en el valor",
  "Is er een proefperiode?": "¿Hay un periodo de prueba?",
  "Israël": "Israel",
  "Italië": "Italia",
  "JOUW LICENTIEKEY:": "TU CLAVE DE LICENCIA:",
  "Ja": "Sí",
  "Ja. De maandpakketten zijn maandelijks opzegbaar. Bij een jaarpakket betaal je eenmalig en heb je twee maanden gratis ten opzichte van maandelijks.": "Sí. Los planes mensuales se pueden cancelar en cualquier momento. Con un plan anual, pagas una sola vez y obtienes dos meses gratis en comparación con el pago mensual.",
  "Ja. Je kunt op meerdere apparaten inloggen — Pro tot 10 actieve apparaten, Enterprise/Lifetime tot 50. Je beheert je apparaten zelf in de instellingen.": "Sí. Puedes iniciar sesión en varios dispositivos — Pro hasta 10 dispositivos activos, Enterprise/Lifetime hasta 50. Gestionas tus dispositivos en los ajustes.",
  "Jan de Vries": "Jan de Vries",
  "Januari–Februari 2026": "Enero-Febrero 2026",
  "Je bent ingelogd, een moment...": "Has iniciado sesión, un momento...",
  "Je gegevens zijn van jou en worden per garage strikt gescheiden opgeslagen (AVG-proof). Met Pro of hoger kun je automatisch back-uppen naar Dropbox of Google Drive. Zie ook onze privacyverklaring.": "Tus datos son tuyos y se almacenan de forma estrictamente separada por taller (cumplimiento RGPD). Con Pro o superior, puedes hacer copias de seguridad automáticamente en Dropbox o Google Drive. Consulta también nuestra política de privacidad.",
  "Je hebt nog niet-opgeslagen wijzigingen. Weet je zeker dat je dit venster wilt verlaten?": "Tienes cambios sin guardar. ¿Estás seguro de que quieres salir de esta ventana?",
  "Je hebt recht op inzage, correctie, verwijdering, beperking en overdraagbaarheid van je persoonsgegevens, en het recht bezwaar te maken. Neem hiervoor contact op via": "Tienes derecho a acceder, rectificar, suprimir, limitar y portar tus datos personales, y el derecho a oponerte. Para ello, ponte en contacto a través de",
  "Je kunt Pro één maand proberen voor een tientje. Een proefperiode kan eenmalig per e-mailadres worden gebruikt.": "Puedes probar Pro durante un mes por diez euros. Un periodo de prueba solo puede utilizarse una vez por dirección de correo electrónico.",
  "Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.": "También puedes presentar una reclamación ante la Agencia Española de Protección de Datos.",
  "Je licentie is verlopen — BASIC mode (gratis)": "Tu licencia ha caducado — modo BÁSICO (gratuito)",
  "Je licentie staat maximaal": "Tu licencia permite un máximo de",
  "Je licentie verloopt binnenkort. Verleng op tijd om onderbreking te voorkomen.": "Tu licencia caduca pronto. Renueva a tiempo para evitar interrupciones.",
  "Je ontvangt na betaling een cryptografisch ondertekende licentiekey via e-mail.": "Después del pago, recibirás una clave de licencia criptográficamente firmada por correo electrónico.",
  "Je publieke verkooppagina": "Tu página de ventas pública",
  "Je publieke verkooppagina met je occasions en onderdelen. Publiceer auto's/onderdelen onder": "Tu página de ventas pública con tus vehículos de ocasión y piezas. Publica coches/piezas en",
  "Je publieke verkooppagina met je occasions en onderdelen. Publiceer auto\\'s/onderdelen onder": "Tu página de ventas pública con tus vehículos de ocasión y piezas. Publica coches/piezas en",
  "Jordanië": "Jordania",
  "Journaalposten": "Asientos de diario",
  "Jouw boekingslink": "Tu enlace de reserva",
  "Jouw gegevens": "Tus datos",
  "Jouw huidige plan": "Tu plan actual",
  "Jouw plan": "Tu plan",
  "Jouw prijs": "Tu precio",
  "Juni 2026": "Junio 2026",
  "KM": "KM",
  "KM stand": "Lectura de KM",
  "Kaapverdië": "Cabo Verde",
  "Kan beter": "Podría ser mejor",
  "Kan camera niet starten": "No se puede iniciar la cámara",
  "Kan straat + huisnummer niet lezen uit \"": "No se puede leer calle + número de casa de \"",
  "Kan straat + huisnummer niet uit \"": "No se puede leer calle + número de casa de \"",
  "Kenmerk": "Referencia",
  "Kenteken": "Matrícula",
  "Kenteken (optioneel):": "Matrícula (opcional):",
  "Kenteken + tot 6 foto's → AI herkent opties en schade en bepaalt de marktwaarde in één stap": "Matrícula + hasta 6 fotos → la IA reconoce opciones y daños y determina el valor de mercado en un solo paso",
  "Kenteken invullen → AI maakt de advertentie, waardebepaling en foto-analyse.": "Introducir matrícula → la IA crea el anuncio, la valoración y el análisis de fotos.",
  "Kenteken is verplicht": "La matrícula es obligatoria",
  "Kenteken niet gevonden": "Matrícula no encontrada",
  "Kenteken niet gevonden bij RDW": "Matrícula no encontrada en RDW",
  "Kenteken opzoeken": "Buscar matrícula",
  "Kentekens": "Matrículas",
  "Kies": "Elegir",
  "Kies bestand": "Elegir archivo",
  "Kies datum & tijd": "Elegir fecha y hora",
  "Kies een betaling om te verwijderen": "Seleccionar un pago para eliminar",
  "Kies een bon": "Elegir un recibo",
  "Kies een klant": "Elegir un cliente",
  "Kies een kostenpost om te verwijderen": "Seleccionar una partida de gasto para eliminar",
  "Kies een leverancier": "Elegir un proveedor",
  "Kies een sterk wachtwoord van minimaal 6 tekens.": "Elige una contraseña segura de al menos 6 caracteres.",
  "Kies een voertuig": "Elegir un vehículo",
  "Kies een voertuig, typ het onderdeel en vergelijk de prijzen in 4 webshops": "Elige un vehículo, escribe la pieza y compara los precios en 4 tiendas online",
  "Kies het plan dat bij jouw garage past": "Elige el plan que mejor se adapte a tu taller",
  "Kies het plan dat past bij jouw garage": "Elige el plan que se adapte a tu taller",
  "Kies kenteken": "Elegir matrícula",
  "Kies klant": "Elegir cliente",
  "Kies leverancier": "Elegir proveedor",
  "Kies locatie": "Elegir ubicación",
  "Kies of typ…": "Elegir o escribir…",
  "Kies of vul een waarde in": "Elegir o introducir un valor",
  "Kies onderdeel uit voorraad": "Elegir pieza de stock",
  "Kilometerstand": "Kilometraje",
  "Kirgizië": "Kirguistán",
  "Klaar om te plaatsen": "Listo para publicar",
  "Klaar om te plakken op Facebook": "Listo para pegar en Facebook",
  "Klaar voor Facebook Marketplace": "Listo para Facebook Marketplace",
  "Klaar voor Marktplaats": "Listo para Marktplaats",
  "Klaar voor ophalen": "Listo para recoger",
  "Klaarzetten voor Facebook Marketplace": "Preparar para Facebook Marketplace",
  "Klaarzetten voor Marktplaats": "Preparar para Marktplaats",
  "Klacht (optioneel)": "Reclamación (opcional)",
  "Klacht / uit te voeren werk": "Reclamación / trabajo a realizar",
  "Klant": "Cliente",
  "Klant (optioneel):": "Cliente (opcional):",
  "Klant + voertuig automatisch aangemaakt of gekoppeld": "Cliente + vehículo creado o vinculado automáticamente",
  "Klant aanmaken (F1)": "Crear cliente (F1)",
  "Klant akkoord": "Cliente conforme",
  "Klant bewerken": "Editar cliente",
  "Klant bijgewerkt": "Cliente actualizado",
  "Klant heeft geen e-mailadres": "El cliente no tiene correo electrónico",
  "Klant opgehaald": "Cliente recuperado",
  "Klant opgeslagen": "Cliente guardado",
  "Klant terugbellen voor afspraak": "Volver a llamar al cliente para cita",
  "Klant verwijderd": "Cliente eliminado",
  "Klant verwijderen?": "¿Eliminar cliente?",
  "Klant- en voertuiggegevens (ingevoerd door de garage):": "Datos del cliente y del vehículo (introducidos por el taller):",
  "Klant:": "Cliente:",
  "Klanten": "Clientes",
  "Klanten kunnen nu afspraken aanvragen.": "Los clientes ahora pueden solicitar citas.",
  "Klanten, voertuigen & voertuighistorie met RDW-kentekencheck en VIN-lookup (NHTSA)": "Clientes, vehículos e historial del vehículo con verificación de matrícula RDW y búsqueda de VIN (NHTSA)",
  "Klantenbeheer met voertuigen en historie": "Gestión de clientes con vehículos e historial",
  "Klantnummer": "Número de cliente",
  "Kleinmateriaal": "Materiales menores",
  "Kleinmateriaal toevoegen": "Añadir materiales menores",
  "Kleur": "Color",
  "Klik om betalingen te bekijken/bewerken": "Haz clic para ver/editar pagos",
  "Klik om status te wijzigen": "Haz clic para cambiar estado",
  "Klik om status te wisselen": "Haz clic para cambiar el estado",
  "Klik om te verbinden": "Haz clic para conectar",
  "Klik op \"Betaling ontvangen\" zodra het bedrag (met het juiste kenmerk) op je rekening of PayPal staat. De licentiekey wordt dan automatisch gegenereerd en naar de klant gemaild.": "Haz clic en \"Pago recibido\" en cuanto el importe (con la referencia correcta) esté en tu cuenta o PayPal. La clave de licencia se generará automáticamente y se enviará por correo electrónico al cliente.",
  "Klik op \"Betaling ontvangen\" zodra het bedrag met het juiste kenmerk op je rekening of PayPal staat. De licentiekey wordt dan automatisch gegenereerd en naar de klant gemaild.": "Haz clic en \"Pago recibido\" en cuanto el importe con la referencia correcta esté en tu cuenta o PayPal. La clave de licencia se generará automáticamente y se enviará por correo electrónico al cliente.",
  "Klik op \"Opnieuw genereren\" om de foto's te analyseren.": "Haz clic en \"Volver a generar\" para analizar las fotos.",
  "Klik op \"Opnieuw genereren\" om de foto\\'s te analyseren.": "Haz clic en \"Volver a generar\" para analizar las fotos.",
  "Klik op 'Create API key' (volledig gratis) en kopieer de volledige sleutel — deze begint met AQ. of AIza…": "Haz clic en 'Create API key' (completamente gratis) y copia la clave completa — esta empieza con AQ. o AIza…",
  "Klik op Opslaan om te bewaren.": "Haz clic en Guardar.",
  "Klik op de knop in de mail om je account te activeren.": "Haz clic en el botón del correo electrónico para activar tu cuenta.",
  "Klik voor details": "Haz clic para ver detalles",
  "Klik voor mutaties": "Haz clic para ver cambios",
  "Km bij laatste onderhoud": "Km en el último mantenimiento",
  "Km bij proefrit": "Km en la prueba de conducción",
  "Km-stand": "Kilometraje",
  "Knoppen voor WhatsApp, bellen, e-mail en afspraak maken": "Botones para WhatsApp, llamar, correo electrónico y programar cita",
  "Komt in": "Entra en",
  "Kon activiteit niet laden": "No se pudo cargar la actividad",
  "Kon data niet laden": "No se pudieron cargar los datos",
  "Kon de boekingspagina niet laden.": "No se pudo cargar la página de reservas.",
  "Kon gratis accounts niet laden": "No se pudieron cargar las cuentas gratuitas",
  "Kon het onderdeel niet goed herkennen — vul handmatig aan": "No se pudo reconocer correctamente la pieza — rellena manualmente",
  "Kon verrekenen niet laden": "No se pudo cargar la conciliación",
  "Kopieer": "Copiar",
  "Kopieer alles": "Copiar todo",
  "Kopieer hele advertentie": "Copiar anuncio completo",
  "Kopieer key": "Copiar clave",
  "Kopieer link": "Copiar enlace",
  "Kopiëren": "Copiar",
  "Koppel aan werkbon": "Asociar a orden de trabajo",
  "Koppel sloopauto": "Asociar vehículo para desguace",
  "Koppelen aan": "Asociar a",
  "Koppeling": "Vinculación",
  "Kort": "Corto",
  "Korte samenvatting voor de klant": "Breve resumen para el cliente",
  "Korting": "Descuento",
  "Kortingscode opgeslagen": "Código de descuento guardado",
  "Kortingscode verwijderen?": "¿Eliminar código de descuento?",
  "Kosten": "Gastos",
  "Kosten & inkoopfacturen met automatische BTW": "Gastos y facturas de compra con IVA automático",
  "Kosten (excl. BTW)": "Gastos (IVA excl.)",
  "Kosten / Inkoopfacturen": "Gastos / Facturas de compra",
  "Kosten / vervangen": "Gastos / Sustituir",
  "Kosten per categorie": "Gastos por categoría",
  "Kosten €": "Gastos €",
  "Kostenpost automatisch aangemaakt in Boekhouden": "Partida de gastos creada automáticamente en Contabilidad",
  "Kostenpost bewerken": "Editar partida de gastos",
  "Kostenpost toegevoegd": "Partida de gastos añadida",
  "Kostenpost toevoegen": "Añadir partida de gastos",
  "Kostenpost verwijderd": "Partida de gastos eliminada",
  "Kostenpost verwijderen?": "¿Eliminar partida de gastos?",
  "Kostprijs": "Precio de coste",
  "Kroatië": "Croacia",
  "KvK nummer": "N.º de la Cámara de Comercio",
  "Kwitantie": "Recibo",
  "Laag": "Bajo",
  "Laat klanten zelf afspraken aanvragen via een deelbare link.": "Permite que los clientes soliciten citas ellos mismos a través de un enlace compartible.",
  "Laatst automatisch verstuurd voor": "Último envío automático para",
  "Laatst bijgewerkt:": "Última actualización:",
  "Laatst gefactureerd": "Última facturación",
  "Laatst gezien": "Visto por última vez",
  "Laatste activiteit": "Última actividad",
  "Laatste bezoek": "Última visita",
  "Laatste cloud back-up:": "Última copia de seguridad en la nube:",
  "Laatste onderhoud": "Último mantenimiento",
  "Laatste run": "Última ejecución",
  "Label afdrukken": "Imprimir etiqueta",
  "Laden mislukt": "Fallo al cargar",
  "Laden...": "Cargando...",
  "Laden…": "Cargando…",
  "Lage voorraad": "Stock bajo",
  "Landcode (wordt automatisch herkend bij +31, 0049, etc.)": "Código de país (reconocido automáticamente para +31, 0049, etc.)",
  "Lange tijd niet gezien": "No visto en mucho tiempo",
  "Layout opgeslagen": "Diseño guardado",
  "Let op:": "Atención:",
  "Let op: een VIN bevat geen kleur, kenteken of APK-datum. Bij Europese auto's kan het model beperkt gedecodeerd worden.": "Atención: un VIN no incluye color, matrícula ni fecha de ITV. En coches europeos, el modelo puede ser decodificado de forma limitada.",
  "Leverancier": "Proveedor",
  "Leverancier bewerken": "Editar proveedor",
  "Leverancier opgeslagen": "Proveedor guardado",
  "Leverancier verwijderd": "Proveedor eliminado",
  "Leverancier verwijderen?": "¿Eliminar proveedor?",
  "Leveranciers": "Proveedores",
  "Libië": "Libia",
  "Licentie": "Licencia",
  "Licentie deactiveren": "Desactivar licencia",
  "Licentie deactiveren? Cloud functies worden uitgeschakeld.": "¿Desactivar licencia? Las funciones en la nube se deshabilitarán.",
  "Licentie geactiveerd! Cloud functies zijn nu beschikbaar.": "¡Licencia activada! Funciones en la nube disponibles.",
  "Licentie gedeactiveerd": "Licencia desactivada",
  "Licentie hersteld": "Licencia restaurada",
  "Licentie herstellen en weer geldig maken?": "¿Restaurar y validar la licencia de nuevo?",
  "Licentie ingetrokken": "Licencia revocada",
  "Licentie status": "Estado de la licencia",
  "Licentie vereist": "Licencia requerida",
  "Licentie vereist. Activeer eerst een PRO of ENTERPRISE licentie bij": "Licencia requerida. Activa primero una licencia PRO o ENTERPRISE en",
  "Licentie verstuurd voor": "Licencia enviada para",
  "Licentie, cloud, team en back-up beheren": "Gestionar licencia, nube, equipo y copia de seguridad",
  "Licentie:": "Licencia:",
  "Licentiekey invoeren": "Introducir clave de licencia",
  "Licenties worden cryptografisch ondertekend door MonteurCentraal en zijn niet te vervalsen.": "Las licencias son criptográficamente firmadas por MonteurCentraal y no pueden ser falsificadas.",
  "Licenties worden geactiveerd nadat betaling is ontvangen.": "Las licencias se activan una vez recibido el pago.",
  "Licenties zijn niet overdraagbaar zonder schriftelijke toestemming van MonteurCentraal.": "Las licencias no son transferibles sin el permiso por escrito de MonteurCentraal.",
  "Licenties, plannen & cloud": "Licencias, planes y nube",
  "Licht": "Claro",
  "Lijstweergave": "Vista de lista",
  "Linda de Groot": "Linda de Groot",
  "Link gekopieerd": "Enlace copiado",
  "Live preview": "Vista previa en vivo",
  "Locatie": "Ubicación",
  "Locatie (bv. voorbumper L)": "Ubicación (ej. parachoques delantero izq.)",
  "Locatie in magazijn": "Ubicación en almacén",
  "Locatie is verplicht": "La ubicación es obligatoria",
  "Locatie wijzigen": "Cambiar ubicación",
  "Log in of maak een account aan op": "Inicia sesión o crea una cuenta en",
  "Logisch voor bouwjaar": "Lógico para el año de fabricación",
  "Logo geüpload": "Logo subido",
  "Logo op de factuur is beschikbaar in <b>PRO</b> en <b>ENTERPRISE</b>. Activeer een licentie via <b>Instellingen → Plannen</b> om je eigen logo bovenaan offertes en facturen te tonen.": "El logo en la factura está disponible en <b>PRO</b> y <b>ENTERPRISE</b>. Activa una licencia a través de <b>Ajustes → Planes</b> para mostrar tu propio logo en la parte superior de los presupuestos y facturas.",
  "Logo op de factuur is beschikbaar in PRO en ENTERPRISE.": "El logo en la factura está disponible en PRO y ENTERPRISE.",
  "Logo te groot (max 2 MB)": "Logo demasiado grande (máx. 2 MB)",
  "Logo tekst": "Texto del logo",
  "Logo uploaden": "Subir logo",
  "Logo vervangen": "Reemplazar logo",
  "Logo verwijderd": "Logo eliminado",
  "Logo verwijderen": "Eliminar logo",
  "Logo verwijderen?": "¿Eliminar logo?",
  "Look up address via PDOK (postcode + house no.)": "Buscar dirección vía PDOK (código postal + número de casa)",
  "Look up address via PDOK (street + house no. + city)": "Buscar dirección vía PDOK (calle + número de casa + ciudad)",
  "MC-PRO-... (lange cryptografisch ondertekende key)": "MC-PRO-... (clave larga criptográficamente firmada)",
  "Maak advertentie": "Crear anuncio",
  "Maak een deelfactuur (termijn/aanbetaling) voor": "Crear una factura parcial (plazo/anticipo) para",
  "Maak een eerste klant + voertuig aan via": "Crea un primer cliente + vehículo a través de",
  "Maak een publieke link aan zodat de klant op zijn telefoon de werkzaamheden kan goedkeuren en digitaal ondertekenen.": "Crea un enlace público para que el cliente pueda aprobar el trabajo y firmar digitalmente desde su teléfono.",
  "Maak hoofdfoto": "Establecer como foto principal",
  "Maak hoofdvoertuig": "Establecer como vehículo principal",
  "Maak inkooporder": "Crear orden de compra",
  "Maak je eerste werkbon of factuur via": "Crea tu primera orden de trabajo o factura a través de",
  "Maak offerte-voorstel": "Crear propuesta de presupuesto",
  "Maak verkoopadvertentie": "Crear anuncio de venta",
  "Magazijnlabel": "Etiqueta de almacén",
  "Mail": "Correo",
  "Mail log": "Registro de correo",
  "Make / Model": "Marca / Modelo",
  "Maleisië": "Malasia",
  "Map openen": "Abrir carpeta",
  "Marge": "Margen",
  "Markeer als verrekend": "Marcar como conciliado",
  "Markeer een voertuig (auto, scooter, motor, aanhanger…) en genereer automatisch een onderdelenlijst": "Selecciona un vehículo (coche, scooter, moto, remolque…) y genera automáticamente una lista de piezas",
  "Markeer verkocht": "Marcar como vendido",
  "Markering": "Marcado",
  "Marktconform": "Acorde con el mercado",
  "Marktwaarde gebruikt": "Valor de mercado usado",
  "Mary-Jane van der Berg": "Mary-Jane van der Berg",
  "Match": "Coincidencia",
  "Mauritanië": "Mauritania",
  "Max bonnen/mnd: ": "Máx. recibos/mes:",
  "Max klanten": "Máx. clientes",
  "Max teamleden": "Máx. miembros del equipo",
  "Max. afspraken per tijdslot": "Máx. citas por franja horaria",
  "Max. appointments per time slot": "Máx. citas por franja horaria",
  "Medewerker": "Empleado",
  "Medewerker toegevoegd": "Empleado añadido",
  "Medewerker uitnodigen": "Invitar a empleado",
  "Meer foto's toevoegen": "Añadir más fotos",
  "Meer foto\\'s toevoegen": "Añadir más fotos",
  "Meer zichtbaarheid en leads — zonder technische kennis.": "Más visibilidad y leads — sin conocimientos técnicos.",
  "Meertalig & internationaal bereik": "Multilingüe y alcance internacional",
  "Meertaligheid, online afspraken & boekhouding": "Multilingüismo, citas online y contabilidad",
  "Meest bekeken auto": "Coche más visto",
  "Meest bekeken onderdeel": "Pieza más vista",
  "Meest verkocht": "Más vendido",
  "Melding": "Notificación",
  "Meldingen instellen": "Configurar notificaciones",
  "Meldingen nu opnieuw genereren": "Generar notificaciones de nuevo ahora",
  "Meldingen verversen": "Actualizar notificaciones",
  "Meldingen worden automatisch elke nacht gegenereerd op basis van APK-datum, openstaande bonnen en geplande afspraken. Klik hieronder om ze handmatig nu te verversen.": "Las notificaciones se generan automáticamente cada noche según la fecha de la ITV, los recibos pendientes y las citas programadas. Haz clic a continuación para actualizarlas manualmente ahora.",
  "Meldingen: open relevante klant, planning of document direct vanuit de lijst": "Notificaciones: abre el cliente, la programación o el documento relevante directamente desde la lista",
  "Merk": "Marca",
  "Merk / Model": "Marca / Modelo",
  "Met postcode + huisnummer vullen we straat en plaats in": "Con código postal + número de casa rellenamos calle y localidad",
  "Met straat + huisnummer + plaats vinden we de postcode": "Con calle + número de casa + localidad encontramos el código postal",
  "Met vriendelijke groet": "Atentamente",
  "Methode": "Método",
  "Mijn SMTP instellingen": "Mis ajustes SMTP",
  "Milieutoeslag": "Recargo medioambiental",
  "Milieutoeslag toevoegen": "Añadir recargo medioambiental",
  "Min": "Mín.",
  "Min voorraad": "Stock mínimo",
  "Min.": "Mín.",
  "Min. voorraad": "Stock mín.",
  "Minimum voorraad met \"bijbestellen\"-waarschuwing + boekhoudkundige voorraadwaarde": "Stock mínimo con aviso de \"reordenar\" + valor contable del stock",
  "Mislukt": "Fallido",
  "Mister Auto": "Mister Auto",
  "Mobiele app & installeerbaar (PWA)": "Aplicación móvil e instalable (PWA)",
  "Model": "Modelo",
  "Model / Type": "Modelo / Tipo",
  "Mogelijk (naam komt overeen)": "Posible (el nombre coincide)",
  "Mogelijk gemaakt door": "Con tecnología de",
  "Mogelijke OEM-alternatieven": "Posibles alternativas OEM",
  "Moldavië": "Moldavia",
  "Mongolië": "Mongolia",
  "Montage remblokken voor": "Montaje pastillas de freno delanteras",
  "Monteur": "Mecánico",
  "MonteurCentraal (hierna \"wij\" of \"MonteurCentraal\") levert software waarmee autobedrijven hun administratie, planning en facturatie beheren.": "MonteurCentraal (en adelante, \"nosotros\" o \"MonteurCentraal\") proporciona software para que los talleres de automóviles gestionen su administración, planificación y facturación.",
  "MonteurCentraal Demo Garage": "Taller de demostración MonteurCentraal",
  "MonteurCentraal behoudt zich het recht voor proefaccounts te weigeren of te beëindigen bij vermoedens van misbruik.": "MonteurCentraal se reserva el derecho de rechazar o cancelar cuentas de prueba ante sospechas de abuso.",
  "MonteurCentraal biedt software voor onder andere klantenbeheer, voertuigbeheer, werkbonnen, offertes, facturen, boekhouding, planning, online afspraken, voorraadbeheer, onderdelenbeheer, handelauto’s, rapportages, cloudopslag en AI-functionaliteiten.": "MonteurCentraal ofrece software para, entre otros, gestión de clientes, gestión de vehículos, órdenes de trabajo, presupuestos, facturas, contabilidad, planificación, citas online, gestión de stock, gestión de piezas, vehículos de comercio, informes, almacenamiento en la nube y funcionalidades de IA.",
  "MonteurCentraal hecht veel waarde aan de bescherming van persoonsgegevens. In deze privacyverklaring leggen we uit welke gegevens we verwerken, waarom, en welke rechten je hebt. Wij verwerken persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).": "MonteurCentraal valora mucho la protección de los datos personales. En esta declaración de privacidad explicamos qué datos procesamos, por qué y qué derechos tiene. Procesamos datos personales de acuerdo con el Reglamento General de Protección de Datos (RGPD).",
  "MonteurCentraal is niet aansprakelijk voor indirecte schade, gevolgschade, omzetverlies, winstderving, bedrijfsschade, verlies van klanten, verlies van gegevens, fiscale schade, naheffingen, boetes, gemiste afspraken, onjuiste berekeningen, onjuiste AI-resultaten, onjuiste voertuiggegevens, onjuiste kentekengegevens, fouten van externe diensten of gebruikersfouten.": "MonteurCentraal no se hace responsable de daños indirectos, daños consecuenciales, pérdida de facturación, pérdida de beneficios, daños comerciales, pérdida de clientes, pérdida de datos, daños fiscales, recargos, multas, citas perdidas, cálculos incorrectos, resultados de IA incorrectos, datos de vehículos incorrectos, datos de matrículas incorrectos, errores de servicios externos o errores del usuario.",
  "MonteurCentraal is niet aansprakelijk voor tekortkomingen veroorzaakt door overmacht, waaronder internetstoringen, stroomuitval, cyberaanvallen, DDoS-aanvallen, storingen bij cloudproviders, storingen bij AI-diensten, storingen bij betaalproviders, overheidsmaatregelen, natuurrampen, oorlog of arbeidsconflicten.": "MonteurCentraal no se hace responsable de deficiencias causadas por fuerza mayor, incluyendo interrupciones de internet, cortes de energía, ciberataques, ataques DDoS, interrupciones en proveedores de la nube, interrupciones en servicios de IA, interrupciones en proveedores de pago, medidas gubernamentales, desastres naturales, guerra o conflictos laborales.",
  "MonteurCentraal is niet verantwoordelijk voor fouten, vertragingen, wijzigingen of storingen bij dergelijke externe partijen.": "MonteurCentraal no es responsable de errores, retrasos, modificaciones o interrupciones en dichas partes externas.",
  "MonteurCentraal is nu installeerbaar als app op telefoon, tablet en pc (\"Zet op beginscherm\")": "MonteurCentraal ahora se puede instalar como aplicación en teléfonos, tabletas y PC (\"Añadir a pantalla de inicio\")",
  "MonteurCentraal kan accounts opschorten of beëindigen bij wanbetaling, fraude, misbruik, overtreding van deze voorwaarden of beveiligingsrisico’s.": "MonteurCentraal puede suspender o cancelar cuentas en caso de impago, fraude, abuso, incumplimiento de estas condiciones o riesgos de seguridad.",
  "MonteurCentraal kan gebruikmaken van AI-functionaliteiten, waaronder advertentiegeneratie, documentherkenning, kentekenbewijsherkenning, voertuigherkenning, onderdelenherkenning, tekstgeneratie, analyses en suggesties.": "MonteurCentraal puede utilizar funcionalidades de IA, incluyendo generación de anuncios, reconocimiento de documentos, reconocimiento de permisos de circulación, reconocimiento de vehículos, reconocimiento de piezas, generación de texto, análisis y sugerencias.",
  "MonteurCentraal kan gegevens ophalen of verwerken via externe diensten zoals RDW, PDOK, Dropbox, Google Drive, e-mailproviders, AI-diensten, hostingproviders en betaaldiensten.": "MonteurCentraal puede recuperar o procesar datos a través de servicios externos como RDW, PDOK, Dropbox, Google Drive, proveedores de correo electrónico, servicios de IA, proveedores de alojamiento y servicios de pago.",
  "MonteurCentraal levert de dienst op basis van een inspanningsverplichting.": "MonteurCentraal presta el servicio en base a una obligación de medios.",
  "MonteurCentraal mag accounts blokkeren of verwijderen bij misbruik, fraude, spam, beveiligingsrisico’s of overtreding van deze voorwaarden.": "MonteurCentraal puede bloquear o eliminar cuentas en caso de abuso, fraude, spam, riesgos de seguridad o incumplimiento de estas condiciones.",
  "MonteurCentraal mag deze voorwaarden op ieder moment wijzigen. De meest actuele versie wordt gepubliceerd op de website.": "MonteurCentraal puede modificar estas condiciones en cualquier momento. La versión más actualizada se publicará en el sitio web.",
  "MonteurCentraal mag technische maatregelen treffen ter bescherming van licenties, gebruikersaantallen en apparaten.": "MonteurCentraal puede tomar medidas técnicas para proteger licencias, número de usuarios y dispositivos.",
  "MonteurCentraal may retrieve or process data via external services such as RDW, PDOK, Dropbox, Google Drive, email providers, AI services, hosting providers, and payment services.": "MonteurCentraal may retrieve or process data via external services such as RDW, PDOK, Dropbox, Google Drive, email providers, AI services, hosting providers, and payment services.",
  "MonteurCentraal streeft naar een zo hoog mogelijke beschikbaarheid, maar geeft geen garantie op foutloze werking, continue beschikbaarheid of afwezigheid van storingen.": "MonteurCentraal se esfuerza por lograr la máxima disponibilidad posible, pero no garantiza un funcionamiento sin errores, una disponibilidad continua o la ausencia de interrupciones.",
  "MonteurCentraal:": "MonteurCentraal:",
  "Monteursnotities (intern)": "Notas del mecánico (internas)",
  "Motor": "Motor",
  "Motor / inhoud": "Motor / cilindrada",
  "Multi-tenant: elk garagebedrijf volledig gescheiden, multi-user met eigen rollen": "Multi-inquilino: cada taller completamente separado, multiusuario con roles propios",
  "N.v.t.": "N/A",
  "Na je betaling ontvang je automatisch een licentiekey per e-mail. Log in, ga naar Instellingen → Licentie, plak de key en klik op activeren. Je bent meteen klaar.": "Tras tu pago, recibirás automáticamente una clave de licencia por correo electrónico. Inicia sesión, ve a Ajustes → Licencia, pega la clave y haz clic en activar. Estarás listo de inmediato.",
  "Na korting": "Después del descuento",
  "Naam": "Nombre",
  "Naam (in eigen taal)": "Nombre (en idioma propio)",
  "Naam is verplicht": "El nombre es obligatorio",
  "Naam van de dienst": "Nombre del servicio",
  "Naar bon": "Ir a recibo",
  "Naar inloggen →": "Ir a iniciar sesión →",
  "Nachtelijk": "Nocturno",
  "Namibië": "Namibia",
  "Nee": "No",
  "Negeren": "Ignorar",
  "Netto marge": "Margen neto",
  "New: \"Share\" button in the showroom — share your used cars in one tap via WhatsApp or copy the link": "Nuevo: botón «Compartir» en el showroom — comparte tus vehículos de ocasión con un toque a través de WhatsApp o copia el enlace",
  "Niemand": "Nadie",
  "Niet akkoord": "No aceptado",
  "Niet geactiveerd": "No activado",
  "Niet geconfigureerd": "No configurado",
  "Niet gestart": "No iniciado",
  "Niet in balans — werk de boekhouding bij": "Desequilibrado — actualiza la contabilidad",
  "Niet ingesteld": "No configurado",
  "Nieuw document": "Nuevo documento",
  "Nieuw inkoop": "Nueva compra",
  "Nieuw onderdeel": "Nueva pieza",
  "Nieuw onderdeel aanmaken met code": "Crear nueva pieza con código",
  "Nieuw verkoop": "Nueva venta",
  "Nieuw voertuig": "Nuevo vehículo",
  "Nieuw voorschot": "Nuevo anticipo",
  "Nieuw wachtwoord": "Nueva contraseña",
  "Nieuw wachtwoord instellen": "Establecer nueva contraseña",
  "Nieuw: \"Deel\"-knop in de showroom — deel je occasions in één tik via WhatsApp of kopieer de link": "Nuevo: botón «Compartir» en el showroom — comparte tus vehículos de ocasión con un toque a través de WhatsApp o copia el enlace",
  "Nieuw: AI Foutcode-uitleg (OBD/DTC → oorzaken, onderdelen, arbeidstijd)": "Nuevo: Explicación de códigos de error por IA (OBD/DTC → causas, piezas, tiempo de mano de obra)",
  "Nieuw: AI Offerte-assistent (klacht → kant-en-klare offerteregels met richtprijzen)": "Nuevo: Asistente de presupuestos por IA (avería → líneas de presupuesto listas para usar con precios de referencia)",
  "Nieuw: knop \"Plaats op Facebook\" — kopieert titel + tekst, downloadt je foto's en opent Facebook Marketplace (veilig plakken, geen API-risico)": "Nuevo: botón «Publicar en Facebook» — copia título + texto, descarga tus fotos y abre Facebook Marketplace (pegado seguro, sin riesgo de API)",
  "Nieuwe APK": "Nueva ITV",
  "Nieuwe afspraak": "Nueva cita",
  "Nieuwe auto": "Coche nuevo",
  "Nieuwe banden": "Neumáticos nuevos",
  "Nieuwe bon": "Nuevo recibo",
  "Nieuwe claim": "Nueva reclamación",
  "Nieuwe diagnose": "Nueva diagnosis",
  "Nieuwe factuur": "Nueva factura",
  "Nieuwe garantieclaim": "Nueva reclamación de garantía",
  "Nieuwe handel auto": "Nuevo vehículo de compraventa",
  "Nieuwe inkooporder": "Nuevo pedido de compra",
  "Nieuwe klant": "Nuevo cliente",
  "Nieuwe klant aanmaken": "Crear nuevo cliente",
  "Nieuwe klant wordt aangemaakt": "Se está creando un nuevo cliente",
  "Nieuwe leverancier": "Nuevo proveedor",
  "Nieuwe melding": "Nueva notificación",
  "Nieuwe module \"APK & Onderhoud\" met APK-vervalwaarschuwingen (verlopen / binnenkort) per voertuig": "Nuevo módulo «ITV y Mantenimiento» con avisos de vencimiento de ITV (caducado / próximamente) por vehículo",
  "Nieuwe online aanvragen": "Nuevas solicitudes online",
  "Nieuwe planning": "Nueva planificación",
  "Nieuwe remmen": "Frenos nuevos",
  "Nieuwe taal toevoegen": "Añadir nuevo idioma",
  "Nieuwe werkbon": "Nueva orden de trabajo",
  "Nieuwe werkorder": "Nueva orden de trabajo",
  "Nieuwprijs": "Precio nuevo",
  "No hidden costs. Upgrade or downgrade anytime via your license key.": "Sin costes ocultos. Actualiza o degrada en cualquier momento a través de tu clave de licencia.",
  "No license plate? Upload a photo of the vehicle documents (also foreign, e.g. German) — the AI will fill in make, model, year of manufacture, etc.": "¿Sin matrícula? Sube una foto de los documentos del vehículo (también extranjeros, p. ej., alemanes) — la IA rellenará la marca, el modelo, el año de fabricación, etc.",
  "Nog geen": "Aún no",
  "Nog geen account? Klik op \"Account aanmaken\" boven.": "¿Aún no tienes cuenta? Haz clic en \"Crear cuenta\" arriba.",
  "Nog geen activaties op deze licentie.": "Aún no hay activaciones en esta licencia.",
  "Nog geen activiteit geregistreerd.": "Aún no hay actividad registrada.",
  "Nog geen alternatieve nummers": "Aún no hay números alternativos",
  "Nog geen bandensets opgeslagen": "Aún no hay juegos de neumáticos guardados",
  "Nog geen bestellingen.": "Aún no hay pedidos.",
  "Nog geen betalingen geregistreerd voor deze bon.": "Aún no hay pagos registrados para este recibo.",
  "Nog geen bonnen geregistreerd voor dit voertuig.": "Aún no hay recibos registrados para este vehículo.",
  "Nog geen bonnen.": "Sin recibos.",
  "Nog geen cloud gekoppeld. Ga naar": "Aún no hay una nube vinculada. Ve a",
  "Nog geen controlepunten": "Aún no hay puntos de control",
  "Nog geen e-mails verstuurd.": "Aún no se han enviado correos electrónicos.",
  "Nog geen garantieclaims.": "Aún no hay reclamaciones de garantía.",
  "Nog geen gebeurtenissen": "Aún no hay eventos",
  "Nog geen geregistreerde apparaten.": "Aún no hay dispositivos registrados.",
  "Nog geen herinneringen verstuurd.": "Aún no se han enviado recordatorios.",
  "Nog geen inkooporders.": "Aún no hay órdenes de compra.",
  "Nog geen journaalposten. Klik op \"Bijwerken\" om automatisch te boeken uit je facturen, betalingen en kosten.": "Aún no hay asientos contables. Haz clic en \"Actualizar\" para contabilizar automáticamente a partir de tus facturas, pagos y costes.",
  "Nog geen klant-omzet geregistreerd.": "Sin ventas registradas.",
  "Nog geen kortingscodes opgeslagen.": "Aún no hay códigos de descuento guardados.",
  "Nog geen kosten geregistreerd. Klik op \"Kostenpost toevoegen\" om je eerste inkoopfactuur in te voeren.": "Aún no hay costes registrados. Haz clic en \"Añadir partida de gastos\" para introducir tu primera factura de compra.",
  "Nog geen kostenposten. Klik": "Aún no hay partidas de gastos. Haz clic",
  "Nog geen kostenposten. Klik + Toevoegen om bijvoorbeeld een vervangen onderdeel of voorgeschoten kosten te registreren.": "Aún no hay partidas de gastos. Haz clic en + Añadir para registrar, por ejemplo, una pieza de repuesto o costes anticipados.",
  "Nog geen leveranciers. Voeg je eerste leverancier toe.": "Aún no hay proveedores. Añade tu primer proveedor.",
  "Nog geen licentie? Bekijk onze pakketten": "¿Aún no tienes licencia? Consulta nuestros paquetes",
  "Nog geen locaties toegevoegd.": "Aún no hay ubicaciones añadidas.",
  "Nog geen omzet geregistreerd.": "Aún no hay ingresos registrados.",
  "Nog geen omzet geregistreerd. Maak je eerste factuur of werkbon aan om hier de grafiek te zien.": "Aún no hay ingresos registrados. Crea tu primera factura o orden de trabajo para ver el gráfico aquí.",
  "Nog geen omzet geregistreerd. Zodra je facturen of werkbonnen aanmaakt verschijnt hier de grafiek.": "Aún no hay ingresos registrados. Una vez que crees facturas u órdenes de trabajo, aparecerá el gráfico aquí.",
  "Nog geen onderdelen. Voeg er een toe of genereer ze vanuit een sloopauto.": "Aún no hay piezas. Añade una o genéralas a partir de un coche desguazado.",
  "Nog geen regels.": "Aún no hay entradas.",
  "Nog geen showroom-link. Publiceer eerst een auto of onderdeel in je showroom — daarna verschijnt hier je persoonlijke link.": "Aún no hay enlace de sala de exposición. Publica primero un coche o una pieza en tu sala de exposición — después, tu enlace personal aparecerá aquí.",
  "Nog geen sloopauto's toegevoegd.": "Aún no se han añadido coches desguazados.",
  "Nog geen sloopauto\\'s toegevoegd.": "Aún no se han añadido coches desguazados.",
  "Nog geen terugroepacties. Voeg een recall toe; het systeem markeert automatisch de getroffen voertuigen in je klantenbestand.": "Aún no hay campañas de retirada. Añade una campaña de retirada; el sistema marcará automáticamente los vehículos afectados en tu base de datos de clientes.",
  "Nog geen verkochte onderdelen.": "Aún no hay piezas vendidas.",
  "Nog geen verkopen geregistreerd.": "Aún no hay ventas registradas.",
  "Nog geen werkplekken": "Aún no hay puestos de trabajo",
  "Nog niets gepubliceerd. Maak een advertentie en klik op \"Publiceer in showroom\".": "Aún no hay nada publicado. Crea un anuncio y haz clic en \"Publicar en sala de exposición\".",
  "Nog nodig voor break-even": "Aún necesario para el punto de equilibrio",
  "Nog te betalen": "Pendiente de pago",
  "Nog te voldoen": "Pendiente de pago",
  "Noord-Macedonië": "Macedonia del Norte",
  "Note: a VIN does not contain colour, license plate or MOT date. For European cars the model may be only partially decoded.": "Nota: un VIN no contiene color, matrícula ni fecha de ITV. Para los coches europeos, el modelo puede ser decodificado solo parcialmente.",
  "Notitie": "Nota",
  "Nu verlengen →": "Renovar ahora →",
  "Nummer": "Número",
  "O-2025-0079 voor Jan de Vries": "O-2025-0079 para Jan de Vries",
  "OAuth start mislukt": "Fallo al iniciar OAuth",
  "OEM": "OEM",
  "OEM cross-reference (alternatieve nummers)": "Referencia cruzada OEM (números alternativos)",
  "OEM nummer": "Número OEM",
  "OFFERTE": "PRESUPUESTO",
  "OK": "OK",
  "OPENSTAAND": "PENDIENTE",
  "Occasion- en onderdeel-detailpagina met WhatsApp, bellen, e-mail en afspraak": "Página de detalles de vehículos de ocasión y piezas con WhatsApp, llamada, correo electrónico y cita",
  "Occasions": "Vehículos de ocasión",
  "Occasions én onderdelen met foto's, specs en AI-tekst": "Vehículos de ocasión y piezas con fotos, especificaciones y texto generado por IA",
  "Oekraïne": "Ucrania",
  "Of vul handmatig in": "O introduzca manualmente",
  "Offerte": "Presupuesto",
  "Offertes": "Presupuestos",
  "Offertes, werkbonnen en facturen": "Presupuestos, órdenes de trabajo y facturas",
  "Offline": "Sin conexión",
  "Offline - wijzigingen worden lokaal bewaard": "Sin conexión - los cambios se guardarán localmente",
  "Offline gehaald": "Desconectado",
  "Offline halen": "Desconectar",
  "Om de hoeveel minuten een afspraak kan starten (bijv. 30).": "Cada cuántos minutos puede comenzar una cita (ej. 30).",
  "Omgezet naar": "Convertido a",
  "Omschrijving": "Descripción",
  "Omschrijving (bijv. 10% korting)": "Descripción (ej. 10% de descuento)",
  "Omschrijving / vervangen": "Descripción / reemplazar",
  "Omschrijving is verplicht": "La descripción es obligatoria",
  "Omzet (excl. BTW)": "Facturación (sin IVA)",
  "Omzet (excl.)": "Facturación (excl.)",
  "Omzet deze maand": "Facturación este mes",
  "Omzet dit jaar": "Facturación este año",
  "Omzet per maand (€) - laatste 12 mnd": "Facturación mensual (€) - últimos 12 meses",
  "Omzet vandaag": "Facturación hoy",
  "Omzetten mislukt": "Conversión fallida",
  "Onbekend": "Desconocido",
  "Onbekend apparaat": "Dispositivo desconocido",
  "Onbekende klant": "Cliente desconocido",
  "Onbeperkt": "Ilimitado",
  "Onbetaalde facturen": "Facturas impagadas",
  "Once your payment is received, you will automatically receive your license key via email at": "Once your payment is received, you will automatically receive your license key via email at",
  "Onder marktprijs — snelle verkoop": "Por debajo del precio de mercado — venta rápida",
  "Onder minimum": "Por debajo del mínimo",
  "Onderdeel": "Pieza",
  "Onderdeel bewerken": "Editar pieza",
  "Onderdeel binnengekomen": "Pieza recibida",
  "Onderdeel gevonden": "Pieza encontrada",
  "Onderdeel herkend — gegevens ingevuld": "Pieza reconocida — datos completados",
  "Onderdeel niet in deze lijst": "La pieza no está en esta lista",
  "Onderdeel opgeslagen": "Pieza guardada",
  "Onderdeel toevoegen": "Añadir pieza",
  "Onderdeel uit voorraad": "Pieza del stock",
  "Onderdeel verkopen": "Vender pieza",
  "Onderdeel verwijderd": "Pieza eliminada",
  "Onderdeel verwijderen?": "¿Eliminar pieza?",
  "Onderdeel-advertenties (AI)": "Anuncios de piezas (IA)",
  "Onderdeelnaam": "Nombre de pieza",
  "Onderdeelnr": "N.º de pieza",
  "Onderdeelnummer": "Número de pieza",
  "Onderdelen": "Piezas",
  "Onderdelen / kosten": "Piezas / costes",
  "Onderdelen besteld": "Piezas pedidas",
  "Onderdelen gegenereerd": "Piezas generadas",
  "Onderdelen genereren": "Generar piezas",
  "Onderdelen publiceren vanuit de voorraad": "Publicar piezas desde el stock",
  "Onderdelen-catalogus": "Catálogo de piezas",
  "Onderdelen: import uit bonnen, bewerk voorraad en filter direct in dit scherm": "Piezas: importa de recibos, edita el stock y filtra directamente en esta pantalla",
  "Onderdelenhandel": "Recambios",
  "Onderdelenhandel Pro": "Recambios Pro",
  "Onderdelenhandel — beheer, waardeer en verkoop onderdelen": "Recambios — gestiona, valora y vende piezas",
  "Onderdelenkaart met OEM/nummer, conditie, locatie, prijzen en foto's": "Ficha de pieza con OEM/número, estado, ubicación, precios y fotos",
  "Onderhoud": "Mantenimiento",
  "Onderhoudshistorie": "Historial de mantenimiento",
  "Onderhoudsinterval": "Intervalo de mantenimiento",
  "Onderhoudsinterval per auto (maanden + km) met automatische berekening van de volgende beurt": "Intervalo de mantenimiento por coche (meses + km) con cálculo automático de la próxima revisión",
  "Onderhoudswerkzaamheden mogen zonder voorafgaande aankondiging worden uitgevoerd.": "Los trabajos de mantenimiento pueden realizarse sin previo aviso.",
  "Onderwerp": "Asunto",
  "Ongeldig JSON-bestand": "Archivo JSON no válido",
  "Ongeldig bedrag": "Importe no válido",
  "Online": "Online",
  "Online aanvraag": "Solicitud online",
  "Online afspraken": "Citas online",
  "Online afspraken zijn niet (meer) beschikbaar voor deze garage.": "Las citas online no están (o ya no están) disponibles para este taller.",
  "Online afspraken — boekingslink": "Citas online — enlace de reserva",
  "Online afspraken: publieke boekingspagina (monteurcentraal.com/afspraak/jouw-garage) met diensten, tijdsloten en RDW-check": "Citas online: página de reserva pública (monteurcentraal.com/afspraak/tu-taller) con servicios, franjas horarias y comprobación RDW",
  "Online booking is not (or no longer) available for this garage.": "Online booking is not (or no longer) available for this garage.",
  "Online gezet": "Publicado online",
  "Online in showroom — klik om offline te halen": "Online en el showroom — haz clic para retirar offline",
  "Online zetten": "Publicar online",
  "Ontgrendel de volledige boekhouding": "Desbloquea la contabilidad completa",
  "Ontvangen": "Recibido",
  "Ontvangen betalingen": "Pagos recibidos",
  "Ontvangst bevestigen": "Confirmar recepción",
  "Ontvangst boeken": "Registrar recepción",
  "Op deze voorwaarden is uitsluitend Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.": "A estas condiciones se aplica exclusivamente la legislación neerlandesa. Los litigios se someterán al tribunal competente de los Países Bajos.",
  "Op voorraad": "En stock",
  "Open": "Abierto",
  "Open alle 4": "Abrir los 4",
  "Open documenten van": "Documentos abiertos de",
  "Open facturen": "Facturas abiertas",
  "Open in Bonnen": "Abrir en Recibos",
  "Open klant": "Abrir cliente",
  "Open planning": "Abrir planificación",
  "Open voorschot": "Abrir anticipo",
  "Open werk en lopende reparaties": "Abrir trabajo y reparaciones en curso",
  "Open werkorders": "Abrir órdenes de trabajo",
  "Openen": "Abrir",
  "Openingstijden": "Horario",
  "Openstaand": "Pendiente",
  "Openstaand bedrag": "Importe pendiente",
  "Openstaande bonnen": "Recibos pendientes",
  "Openstaande facturen, ouderdomsanalyse (aging) en betalingsherinneringen": "Facturas pendientes, análisis de antigüedad (aging) y recordatorios de pago",
  "Openstaande facturen, ouderdomsanalyse (aging) en betalingsherinneringen versturen": "Enviar facturas pendientes, análisis de antigüedad (aging) y recordatorios de pago",
  "Openstaande orders": "Pedidos pendientes",
  "Opgehaald": "Recuperado",
  "Opgeslagen": "Guardado",
  "Opgeslagen als concept": "Guardado como borrador",
  "Opgesteld": "Elaborado",
  "Opmerkingen": "Observaciones",
  "Opnieuw genereren": "Regenerar",
  "Opnieuw opbouwen": "Reconstruir",
  "Opnieuw opgebouwd": "Reconstruido",
  "Opnieuw versturen": "Reenviar",
  "Opnieuw versturen mislukt": "Error al reenviar",
  "Oproep-tekst (CTA)": "Texto de llamada a la acción (CTA)",
  "Opslaan": "Guardar",
  "Opslaan & werkbon maken": "Guardar y crear orden de trabajo",
  "Opslaan als concept": "Guardar como borrador",
  "Opslaan mislukt": "Error al guardar",
  "Opslaglocatie": "Ubicación de almacenamiento",
  "Optie 1 — Bankoverschrijving": "Opción 1 — Transferencia bancaria",
  "Optie 2 — PayPal": "Opción 2 — PayPal",
  "Opzoeken": "Consultar",
  "Order annuleren?": "¿Cancelar pedido?",
  "Order besteld": "Pedido realizado",
  "Order opgeslagen": "Pedido guardado",
  "Orders": "Pedidos",
  "Origineel rapport bewaard bij de documenten": "Informe original guardado con los documentos",
  "Oud inkoop": "Compras antiguas",
  "Oud verkoop": "Ventas antiguas",
  "Ouderdomsanalyse (aging)": "Análisis de antigüedad (aging)",
  "Oudste": "Más antiguo",
  "Over ons": "Sobre nosotros",
  "Overview of your garage": "Overview of your garage",
  "Overzicht van uw garage": "Resumen de su taller",
  "PDF": "PDF",
  "PDF beheer en cloud-synchronisatie": "Gestión de PDF y sincronización en la nube",
  "PDOK lookup mislukt": "Error en la búsqueda de PDOK",
  "PNG of JPG, max 2 MB. Wordt links bovenaan getoond op je bonnen (vervangt de tekstlogo).": "PNG o JPG, máx. 2 MB. Se mostrará en la parte superior izquierda de tus recibos (reemplaza el logotipo de texto).",
  "PNG, JPG, SVG, WebP · max 2 MB": "PNG, JPG, SVG, WebP · máx. 2 MB",
  "POPULAIR": "POPULAR",
  "Pagina": "Página",
  "Pakket": "Paquete",
  "Pas de opmaak van offertes en facturen aan": "Personaliza el formato de presupuestos y facturas",
  "Pas de uitstraling van je publieke showroom én boekingspagina aan. Je logo stel je in onder Bon layout.": "Personaliza el aspecto de tu showroom público y página de reservas. Puedes configurar tu logo en el diseño de recibo.",
  "Passiva (schulden & vermogen)": "Pasivo (deudas y patrimonio)",
  "Past ook op": "También compatible con",
  "Past op": "Compatible con",
  "Past op voertuigen": "Compatible con vehículos",
  "Past-op lijst (merk/model/bouwjaar) en OEM cross-reference (alternatieve nummers)": "Lista de compatibilidad (marca/modelo/año de fabricación) y referencia cruzada OEM (números alternativos)",
  "Paste this into the License tab to activate your plan immediately. The license will be tied to your garage and cannot be reused by others.": "Paste this into the License tab to activate your plan immediately. The license will be tied to your garage and cannot be reused by others.",
  "Pay via PayPal": "Pay via PayPal",
  "Pay via bank transfer or PayPal · License key automatically emailed after payment is received": "Pay via bank transfer or PayPal · License key automatically emailed after payment is received",
  "Per page": "Per page",
  "Per pagina": "Por página",
  "Percentage (%)": "Porcentaje (%)",
  "Perfect voor slopers, onderdelenhandelaren en hobbygarages.": "Perfecto para desguaces, distribuidores de piezas y talleres de aficionados.",
  "Periode": "Período",
  "Persoon": "Persona",
  "Plaats": "Localidad",
  "Plaats op Facebook": "Publicar en Facebook",
  "Plaats uw handtekening.": "Firme aquí.",
  "Plak de key en klik": "Pega la clave y haz clic",
  "Plak de sleutel hieronder en klik op Opslaan. We testen hem meteen voordat we hem (versleuteld) bewaren.": "Pega la clave a continuación y haz clic en Guardar. La probaremos de inmediato antes de guardarla (cifrada).",
  "Plak de tekst en voeg de foto's toe.": "Pega el texto y añade las fotos.",
  "Plak de tekst en voeg de foto\\'s toe.": "Pega el texto y añade las fotos.",
  "Plak deze in het Licentie tabblad om je plan direct te activeren. De licentie wordt gebonden aan jouw garage en kan niet hergebruikt worden door anderen.": "Pégala en la pestaña Licencia para activar tu plan de inmediato. La licencia quedará vinculada a tu taller y no podrá ser reutilizada por otros.",
  "Plan": "Plan",
  "Plan afspraak": "Programar cita",
  "Plan seizoenswissel": "Programar cambio de temporada",
  "Planning vandaag": "Programación de hoy",
  "Pluspunten & onderhoud": "Ventajas y mantenimiento",
  "Pluspunten & onderhoud (distributieriem, nieuwe APK/banden/remmen, sleutels, onderhoudshistorie) worden in de tekst verwerkt": "Las ventajas y el mantenimiento (correa de distribución, nueva ITV/neumáticos/frenos, llaves, historial de mantenimiento) se incluirán en el texto",
  "Pop-up geblokkeerd": "Ventana emergente bloqueada",
  "Popup geblokkeerd - sta popups toe voor deze site": "Ventana emergente bloqueada - permite ventanas emergentes para este sitio",
  "Postcode": "Código postal",
  "Postcode (1011 AA)": "Código postal (1011 AA)",
  "Postcode / Plaats": "Código postal / Localidad",
  "Preview Marktplaats": "Vista previa de Marketplace",
  "Pricing-tiers (Basic / Pro / Enterprise / Lifetime) met onkraakbare cryptografische licenties": "Pricing-tiers (Basic / Pro / Enterprise / Lifetime) con licencias criptográficas inquebrantables",
  "Prijs": "Precio",
  "Prijs (€)": "Precio (€)",
  "Prijs hoog → laag": "Precio alto → bajo",
  "Prijs laag → hoog": "Precio bajo → alto",
  "Prijsadvies mislukt": "Sugerencia de precio fallida",
  "Prijsanalyse": "Análisis de precios",
  "Prijshistorie": "Historial de precios",
  "Prijsvergelijk onderdelen": "Comparación de precios de piezas",
  "Prijswijzigingen kunnen op ieder moment worden doorgevoerd voor toekomstige periodes.": "Los cambios de precios pueden implementarse en cualquier momento para períodos futuros.",
  "Prijzen staan vermeld op de website.": "Los precios están indicados en el sitio web.",
  "Print PDF": "Print PDF",
  "Printed via MonteurCentraal": "Impreso a través de MonteurCentraal",
  "Prioriteit": "Prioridad",
  "Privacyverklaring": "Política de privacidad",
  "Proefrit gemaakt": "Prueba de conducción realizada",
  "Professionele facturatie": "Facturación profesional",
  "Profiel": "Perfil",
  "Profieldiepte (mm)": "Profundidad del dibujo (mm)",
  "Profit distribution per team member": "Profit distribution per team member",
  "Profit share per team member + advance costs": "Profit share per team member + advance costs",
  "Provide a valid language code (e.g. de)": "Provide a valid language code (e.g. de)",
  "Publiceer": "Publicar",
  "Publiceer auto's en onderdelen met één klik naar je eigen verkooppagina — geen webshop of hosting nodig.": "Publica coches y piezas con un solo clic en tu propia página de ventas — no se necesita tienda online ni alojamiento.",
  "Publiceer in showroom": "Publicar en exposición",
  "Publiceren mislukt": "Error al publicar",
  "Publieke Showroom": "Exposición pública",
  "Publieke akkoord-link": "Enlace de aprobación público",
  "Publieke showroom": "Exposición pública",
  "Publieke showroom & boekingspagina herkennen automatisch de taal van je bezoeker (Nederlands, Engels, Duits) en tonen de site meteen in de juiste taal": "El showroom público y la página de reservas reconocen automáticamente el idioma de tu visitante (neerlandés, inglés, alemán) y muestran el sitio inmediatamente en el idioma correcto",
  "QR-label": "Etiqueta QR",
  "QR-magazijnlabels per onderdeel (afdrukken) + onderdeel terugvinden via camera-scan": "Etiquetas QR de almacén por pieza (impresión) + encontrar pieza mediante escaneo de cámara",
  "RDW check": "Comprobación RDW",
  "RDW gevonden": "RDW encontrado",
  "RDW kenteken check": "Comprobación de matrícula RDW",
  "RDW lookup mislukt": "Búsqueda RDW fallida",
  "RDW mislukt": "RDW falló",
  "RDW ophalen": "Obtener RDW",
  "RDW opzoeken": "Buscar RDW",
  "RDW-data + APK automatisch in de tekst, indicatieve marktprijs & vraagprijs-meter": "Datos RDW + ITV automáticamente en el texto, precio de mercado indicativo y medidor de precio de venta",
  "RDW-data inbegrepen — APK-datum staat automatisch in de tekst": "Datos RDW incluidos — la fecha de ITV se muestra automáticamente en el texto",
  "RDW-kentekencheck al ingebouwd in het formulier": "Comprobación de matrícula RDW ya integrada en el formulario",
  "RDW-titelchecklist": "Lista de verificación de títulos RDW",
  "Rapport (PDF)": "Informe (PDF)",
  "Rapport geëxporteerd": "Informe exportado",
  "Rapport naar boekhouder": "Informe al contable",
  "Rapport verstuurd": "Informe enviado",
  "Rapportage: kies periode, filters en exporteer daarna de uitkomst": "Informes: elige período, filtros y luego exporta el resultado",
  "Reactie ontvangen": "Respuesta recibida",
  "Recalls": "Llamadas a revisión",
  "Recent onderhoud verhoogt de marktwaarde met": "Mantenimiento reciente aumenta el valor de mercado en",
  "Recent onderhouden": "Con mantenimiento reciente",
  "Recente activiteit": "Actividad reciente",
  "Reden intrekking:": "Motivo de la revocación:",
  "Reden voor het intrekken van licentie": "Motivo de la revocación de la licencia",
  "Reeds akkoord gegeven door": "Ya aprobado por",
  "Reeds betaald": "Ya pagado",
  "Referentie": "Referencia",
  "Regel toevoegen": "Añadir línea",
  "Regels": "Líneas",
  "Registratie mislukt": "Error en el registro",
  "Registreer je uitgaven en inkoopfacturen voor je boekhouding en BTW-aangifte": "Registra tus gastos y facturas de compra para tu contabilidad y declaración de IVA",
  "Registreer uitgaven en inkoopfacturen voor je boekhouding en BTW-aangifte": "Registra gastos y facturas de compra para tu contabilidad y declaración de IVA",
  "Registreren": "Registrarse",
  "Rekening": "Cuenta",
  "Remblokken voor (set)": "Pastillas de freno delanteras (juego)",
  "Remblokken voor Volkswagen Golf": "Pastillas de freno para Volkswagen Golf",
  "Reparatie-historie": "Historial de reparaciones",
  "Reparaties": "Reparaciones",
  "Reservering klant Bakker tot 15-07": "Reserva cliente Bakker hasta el 15-07",
  "Reset": "Restablecer",
  "Reset mislukt": "Restablecimiento fallido",
  "Reset-link versturen": "Enviar enlace de restablecimiento",
  "Reset-mail verstuurd": "Correo de restablecimiento enviado",
  "Resultaat": "Resultado",
  "Resultaat (winst/verlies)": "Resultado (beneficio/pérdida)",
  "Resultaat boekjaar": "Resultado del ejercicio",
  "Retourstatus": "Estado de devolución",
  "Retrieve make/model/MOT via RDW": "Obtener marca/modelo/ITV a través de RDW",
  "Retrieve make/model/year via VIN": "Obtener marca/modelo/año a través de VIN",
  "Revenue per month (€) - last 12 mo": "Ingresos mensuales (€) - últimos 12 meses",
  "Richt de camera op een QR- of streepjescode": "Apunte la cámara a un código QR o de barras",
  "Richtprijs": "Precio orientativo",
  "Roemenië": "Rumanía",
  "Rol": "Rol",
  "SMTP opgeslagen": "SMTP guardado",
  "SMTP test mislukt": "Error en la prueba SMTP",
  "Saint Kitts en Nevis": "San Cristóbal y Nieves",
  "Saldo": "Saldo",
  "Saldo te ontvangen": "Saldo pendiente de cobro",
  "Samenvatting": "Resumen",
  "Sao Tomé en Principe": "Santo Tomé y Príncipe",
  "Saoedi-Arabië": "Arabia Saudí",
  "Save your custom discount codes per shop here. They will appear next to the button above.": "Guarde aquí sus códigos de descuento personalizados por tienda. Aparecerán junto al botón de arriba.",
  "Scan autopapieren (AI)": "Escanear documentos del coche (IA)",
  "Scan deze code met \"Scannen\" om dit onderdeel direct terug te vinden.": "Escanee este código con \"Escanear\" para encontrar este componente directamente.",
  "Scan met je bankapp om": "Escanee con su aplicación bancaria para",
  "Scan onderdeel": "Escanear pieza",
  "Scan papieren": "Escanear documentos",
  "Scan papieren (AI)": "Escanear documentos (IA)",
  "Scannen": "Escanear",
  "Schade": "Daño",
  "Schadepunt": "Punto de daño",
  "Schadepunten / aandachtspunten": "Puntos de daño / Puntos de atención",
  "Search by make, model...": "Buscar por marca, modelo...",
  "Search by part, make, model, OEM no...": "Buscar por pieza, marca, modelo, n.º OEM...",
  "Search license plate, make or model...": "Buscar matrícula, marca o modelo...",
  "Seizoen": "Temporada",
  "Selecteer een bon.": "Seleccione un recibo.",
  "Selecteer een klant.": "Seleccione un cliente.",
  "Selecteer een voertuig.": "Seleccione un vehículo.",
  "Selecteer eerst een afspraak": "Seleccione primero una cita",
  "Selecteer eerst een betaling": "Seleccione primero un pago",
  "Selecteer eerst een bon": "Selecciona primero un recibo",
  "Selecteer eerst een klant": "Selecciona primero un cliente",
  "Selecteer minstens 1 koppeling": "Selecciona al menos 1 vínculo",
  "Selecteer minstens 1 onderdeel": "Selecciona al menos 1 pieza",
  "Selectie wissen": "Borrar selección",
  "Service & onderhoud": "Servicio y mantenimiento",
  "Servië": "Serbia",
  "Share via WhatsApp": "Compartir vía WhatsApp",
  "Showroom": "Showroom",
  "Showroom niet gevonden.": "Showroom no encontrado.",
  "Showroom — publieke link": "Showroom — enlace público",
  "Showroom-link automatisch onder advertenties zetten": "Poner el enlace del showroom automáticamente debajo de los anuncios",
  "Showroom-link nu ook terug te vinden in Instellingen → Algemeen": "Enlace del showroom ahora también disponible en Ajustes → General",
  "Showroom-stijl (kleuren, thema & banner)": "Estilo del showroom (colores, tema y banner)",
  "Showroom-stijl opgeslagen": "Estilo del showroom guardado",
  "Sla eerst de afspraak op": "Guarda primero la cita",
  "Sla het onderdeel eerst op": "Guarda primero la pieza",
  "Slapend": "Inactivo",
  "Sleep de PDF erin — klaar in seconden": "Arrastra el PDF aquí — listo en segundos",
  "Sleep je diagnoserapport hierheen": "Arrastra tu informe de diagnóstico aquí",
  "Sleepbare kalender: versleep een afspraak naar een ander tijdslot": "Calendario arrastrable: arrastra una cita a otra franja horaria",
  "Sleutel instellen": "Establecer clave",
  "Sleutel verwijderd": "Clave eliminada",
  "Slimme onderdelen-invoer met AI": "Entrada inteligente de piezas con IA",
  "Slimme suggesties": "Sugerencias inteligentes",
  "Sloop/demontage voor alle voertuigtypes: auto, scooter, motor, aanhanger, caravan en meer": "Desguace/desmontaje para todo tipo de vehículos: coche, scooter, moto, remolque, caravana y más",
  "Sloopauto gekoppeld": "Vehículo para desguace vinculado",
  "Sloopauto markeren → automatisch een complete onderdelenlijst genereren": "Marcar vehículo para desguace → generar automáticamente una lista completa de piezas",
  "Sloopauto markeren → automatisch een onderdelenlijst genereren": "Marcar vehículo para desguace → generar automáticamente una lista de piezas",
  "Sloopauto verwijderen?": "¿Eliminar vehículo para desguace?",
  "Sloopvoertuig bewerken": "Editar vehículo para desguace",
  "Sloopvoertuig bijgewerkt": "Vehículo para desguace actualizado",
  "Sloopvoertuig toegevoegd": "Vehículo para desguace añadido",
  "Sloopvoertuig toevoegen": "Añadir vehículo para desguace",
  "Sloopvoertuigen": "Vehículos para desguace",
  "Sloopvoertuigen & beveiliging": "Vehículos para desguace y seguridad",
  "Sloopwaarde": "Valor de desguace",
  "Slot-instellingen": "Configuración de franjas horarias",
  "Slots automatisch berekend op jouw openingstijden": "Franjas horarias calculadas automáticamente según tu horario de apertura",
  "Slovenië": "Eslovenia",
  "Sluiten": "Cerrar",
  "Snel verkopen": "Venta rápida",
  "Snel zoeken op kenteken, OEM, nummer, merk of model": "Búsqueda rápida por matrícula, OEM, número, marca o modelo",
  "Snelle acties: klanten, bonnen, planning en RDW direct vanaf het dashboard": "Acciones rápidas: clientes, recibos, planificación y RDW directamente desde el panel de control",
  "Snelle-verkoopprijs": "Precio de venta rápido",
  "Som winstaandelen": "Suma de participaciones en beneficios",
  "Somalië": "Somalia",
  "Sophie van den Berg": "Sophie van den Berg",
  "Sorteren": "Ordenar",
  "Specificaties": "Especificaciones",
  "Sta pop-ups toe om het kwitantie-document te openen": "Permite las ventanas emergentes para abrir el documento de recibo",
  "Staat": "Estado",
  "Staat live op je showroom": "Está publicado en tu sala de exposición",
  "Standaard": "Predeterminado",
  "Standaard BTW%": "IVA % predeterminado",
  "Standaard artikelcodes": "Códigos de artículo predeterminados",
  "Standaard hersteld": "Predeterminado restaurado",
  "Standaardlijst": "Lista predeterminada",
  "Standaardlijst hersteld": "Lista predeterminada restaurada",
  "Start": "Iniciar",
  "Start werkorder": "Iniciar orden de trabajo",
  "Start with these 3 steps to set up your garage:": "Comienza con estos 3 pasos para configurar tu taller:",
  "Statistieken: bezoekers, meest bekeken, contactaanvragen, WhatsApp-kliks, verkocht": "Estadísticas: visitantes, más vistos, solicitudes de contacto, clics de WhatsApp, vendidos",
  "Status": "Estado",
  "Status bijgewerkt": "Estado actualizado",
  "Status update mislukt": "Error al actualizar el estado",
  "Stel automatische herinneringen in en bekijk verstuurde herinneringen": "Configura recordatorios automáticos y consulta los recordatorios enviados",
  "Stel de categorie in voor alle geselecteerde onderdelen.": "Establece la categoría para todas las piezas seleccionadas.",
  "Stel de magazijnlocatie in voor alle geselecteerde onderdelen.": "Establece la ubicación de almacén para todas las piezas seleccionadas.",
  "Stel een vraagprijs in": "Establece un precio de venta",
  "Stel eerst je gratis Google Gemini API-sleutel in om de AI-functies te gebruiken.": "Primero, configura tu clave API gratuita de Google Gemini para usar las funciones de IA.",
  "Stel in wanneer klanten automatisch een herinnering ontvangen voor openstaande facturen": "Configura cuándo los clientes reciben automáticamente un recordatorio por facturas pendientes",
  "Sterke punten": "Puntos fuertes",
  "Stijl": "Estilo",
  "Stijl opslaan": "Guardar estilo",
  "Stop met handmatig BTW uitrekenen in Excel. Laat MonteurCentraal het zware werk doen.": "Deja de calcular el IVA manualmente en Excel. Deja que MonteurCentraal haga el trabajo pesado.",
  "Straat + nr": "Calle + n.º",
  "Streepjes-/QR-code scannen: naast de camera kun je nu ook een foto van de code uploaden (handig zonder webcam)": "Escanear código de barras/QR: además de la cámara, ahora también puedes subir una foto del código (útil sin cámara web)",
  "Stukprijs": "Precio unitario",
  "Stuur direct een complete back-up naar je gekoppelde cloud (Dropbox / Google Drive). Het bestand verschijnt in je": "Envía una copia de seguridad completa directamente a tu nube vinculada (Dropbox / Google Drive). El archivo aparecerá en tu",
  "Stuur herinnering": "Enviar recordatorio",
  "Stuur nu (Q": "Enviar ahora (Q",
  "Subtotaal": "Subtotal",
  "Suggestieregels opgeslagen": "Reglas de sugerencia guardadas",
  "Suggesties": "Sugerencias",
  "Synchronisatie mislukt voor": "Sincronización fallida para",
  "Synchroniseren...": "Sincronizando...",
  "Syrië": "Siria",
  "T.n.v.": "A nombre de",
  "Taal": "Idioma",
  "Taal aanmaken": "Crear idioma",
  "Taal toevoegen": "Añadir idioma",
  "Taal verwijderd": "Idioma eliminado",
  "Taal verwijderen?": "¿Eliminar idioma?",
  "Taalcode (ISO 639-1)": "Código de idioma (ISO 639-1)",
  "Talen beheer": "Gestión de idiomas",
  "Tarief": "Tarifa",
  "Te betalen aan Belastingdienst": "A pagar a la Agencia Tributaria",
  "Te koop": "En venta",
  "Te laat (> 30 dagen)": "Vencido (> 30 días)",
  "Team / Medewerkers": "Equipo / Empleados",
  "Teken hier uw handtekening": "Firme aquí",
  "Tekst": "Texto",
  "Tekst gekopieerd": "Texto copiado",
  "Tekst opgeslagen": "Texto guardado",
  "Telefoon": "Teléfono",
  "Tenaamstelling": "Titularidad",
  "Tenaamstelling nieuwe eigenaar bij verkoop": "Titularidad del nuevo propietario en caso de venta",
  "Terug": "Atrás",
  "Terug naar MonteurCentraal": "Volver a MonteurCentraal",
  "Terug naar dashboard": "Volver al panel",
  "Terug naar de standaardlijst? Je eigen aanpassingen vervallen.": "¿Volver a la lista predeterminada? Tus cambios personalizados se perderán.",
  "Terug naar inloggen": "Volver a iniciar sesión",
  "Terug op voorraad": "De vuelta en stock",
  "Terug te ontvangen": "Pendiente de recibir",
  "Terugbel": "Devolver llamada",
  "Terugbellen voor APK": "Llamar para ITV",
  "Terugroepactie": "Llamada a revisión",
  "Terugroepactie toegevoegd": "Llamada a revisión añadida",
  "Terugroepactie toevoegen": "Añadir llamada a revisión",
  "Terugroepactie verwijderen?": "¿Eliminar llamada a revisión?",
  "Terugroepacties": "Llamadas a revisión",
  "Terugroepacties / recalls registreren; het systeem markeert automatisch de getroffen voertuigen": "Registrar llamadas a revisión / recalls; el sistema marcará automáticamente los vehículos afectados",
  "Test verzenden": "Enviar prueba",
  "Testbericht verzonden naar": "Mensaje de prueba enviado a",
  "Thank you for your trust in our garage!": "Thank you for your trust in our garage!",
  "Thema": "Tema",
  "Tijd": "Hora",
  "Tijdelijk wachtwoord (min 6)": "Contraseña temporal (mín. 6)",
  "Tijdinschatting per klus en werkstatus (wacht op onderdelen / bezig / klaar / opgehaald)": "Estimación de tiempo por tarea y estado del trabajo (esperando piezas / en curso / listo / recogido)",
  "Tip-tekst": "Texto de sugerencia",
  "Tip: Complete address + vehicle later via the Customers page.": "Tip: Complete address + vehicle later via the Customers page.",
  "Tip: No postal code? Enter street + house number and select city below (type \"Med\" for Medemblik). Then click \"Fill postal code via street + city\".": "Tip: No postal code? Enter street + house number and select city below (type \"Med\" for Medemblik). Then click \"Fill postal code via street + city\".",
  "Tip: Select a vehicle to search by make/model/year. Prices are shown live in the webshop (opens in a new tab).": "Tip: Select a vehicle to search by make/model/year. Prices are shown live in the webshop (opens in a new tab).",
  "Tip: gebruik rechtermuisklik op de lijst voor snelle auto-acties": "Consejo: usa el clic derecho en la lista para acciones rápidas del vehículo",
  "Tip: heb je geen postcode? Vul straat + huisnr in en kies plaats hieronder (typ \"Med\" voor Medemblik). Klik dan op \"Vul postcode via straat + plaats\".": "Consejo: ¿No tienes código postal? Introduce la calle + número de casa y selecciona la ciudad a continuación (escribe \"Med\" para Medemblik). Luego haz clic en \"Rellenar código postal por calle + ciudad\".",
  "Tip: kies een voertuig zodat merk/model/bouwjaar wordt meegezocht. Prijzen worden live in de webshop getoond (openen in een nieuw tabblad).": "Consejo: selecciona un vehículo para buscar por marca/modelo/año de fabricación. Los precios se muestran en vivo en la tienda online (se abre en una nueva pestaña).",
  "Tip: laat een veld leeg om de Nederlandse fallback te gebruiken. Geel = nog niet opgeslagen.": "Consejo: deja un campo vacío para usar el valor de respaldo holandés. Amarillo = no guardado aún.",
  "Tip: sleep een afspraak naar een ander tijdslot om te verplaatsen.": "Consejo: arrastra una cita a otra franja horaria para moverla.",
  "Tip: voeg foto's toe zodat de AI opties en schade automatisch herkent.": "Consejo: añade fotos para que la IA reconozca automáticamente las opciones y los daños.",
  "Tip: voeg foto\\'s toe zodat de AI opties en schade automatisch herkent.": "Consejo: añade fotos para que la IA reconozca automáticamente las opciones y los daños.",
  "Tip: vul later adres + voertuig aan via de Klanten pagina.": "Consejo: completa la dirección + el vehículo más tarde a través de la página de Clientes.",
  "Titel": "Título",
  "Titel + tekst staan op je klembord; foto\\'s zijn gedownload. Plak ze in Facebook Marketplace.": "Título + texto están en tu portapapeles; las fotos han sido descargadas. Pégalas en Facebook Marketplace.",
  "Titel en merk zijn verplicht": "Título y marca son obligatorios",
  "Toegevoegd": "Añadido",
  "Toegevoegd aan \"Past op\"": "Añadido a \"Compatible con\"",
  "Toekomstige + recente afspraken": "Citas futuras + recientes",
  "Toepassen": "Aplicar",
  "Toepassen op onderdeel": "Aplicar a pieza",
  "Toevoegen": "Añadir",
  "Toevoegen mislukt": "Error al añadir",
  "Toon journaal": "Ver diario",
  "Top verkochte voertuigen": "Vehículos más vendidos",
  "Topklant dit jaar": "Mejor cliente este año",
  "Totaal": "Total",
  "Totaal activa": "Total activos",
  "Totaal credit": "Total crédito",
  "Totaal debet": "Total débito",
  "Totaal fooi": "Total propina",
  "Totaal incl. BTW": "Total incl. IVA",
  "Totaal indicatie (excl. BTW)": "Total estimado (excl. IVA)",
  "Totaal inkoopwaarde": "Valor total de compra",
  "Totaal kosten (incl. BTW)": "Costes totales (incl. IVA)",
  "Totaal kosten:": "Costes totales:",
  "Totaal omzet": "Facturación total",
  "Totaal ontvangen": "Total recibido",
  "Totaal ontvangen betalingen": "Total de pagos recibidos",
  "Totaal openstaand": "Total pendiente",
  "Totaal passiva": "Total pasivos",
  "Totale omzet": "Facturación total",
  "Totale omzet (lifetime)": "Facturación total (acumulada)",
  "Totale opbrengsten": "Ingresos totales",
  "Trefwoorden": "Palabras clave",
  "Trinidad en Tobago": "Trinidad y Tobago",
  "Tsjechië": "República Checa",
  "Tunesië": "Túnez",
  "Typ +31, 0049, +44, of 06… — landcode wordt automatisch herkend na uit-tikken": "Escriba +31, 0049, +44, o 06… — el código de país se reconocerá automáticamente al finalizar la entrada",
  "Typ eerst een onderdeel": "Escriba primero un artículo",
  "Typ nooit meer 3 keer dezelfde advertentie — verkoop je voorraad sneller.": "No publique nunca más de 3 veces el mismo anuncio — venda su stock más rápido.",
  "Type": "Tipo",
  "Type (kras/deuk/roest)": "Tipo (arañazo/abolladura/óxido)",
  "Type document (Factuur / Offerte / Werkbon / Foto / Contract / etc):": "Tipo de documento (Factura / Presupuesto / Orden de trabajo / Foto / Contrato / etc.):",
  "Type voertuig": "Tipo de vehículo",
  "Uit": "Desactivado",
  "Uitgebreider fotobeheer met hoofdfoto-keuze": "Gestión de fotos avanzada con selección de foto principal",
  "Uitleg in begrijpelijke taal voor jouw klant": "Explicación en lenguaje comprensible para tu cliente",
  "Uitnodigen": "Invitar",
  "Uitschakelen": "Desactivar",
  "Uitvoering": "Versión",
  "Upgrade naar PRO": "Actualizar a PRO",
  "Upgrade naar PRO of ENTERPRISE voor onbeperkt gebruik + cloud sync.": "Actualice a PRO o ENTERPRISE para uso ilimitado + sincronización en la nube.",
  "Upload": "Subir",
  "Upload een Autel-diagnoserapport en laat AI er direct een werkbon van maken — met uitleg in gewoon Nederlands.": "Suba un informe de diagnóstico Autel y deje que la IA cree una orden de trabajo al instante — con una explicación en español sencillo.",
  "Upload een diagnoserapport (PDF) — AI maakt automatisch klant, voertuig en werkbon met uitleg": "Suba un informe de diagnóstico (PDF) — la IA crea automáticamente cliente, vehículo y orden de trabajo con explicación",
  "Upload een diagnoserapport (PDF) — AI maakt een voorstel dat je eerst controleert vóór het opslaan": "Suba un informe de diagnóstico (PDF) — la IA crea una propuesta que debe revisar antes de guardar",
  "Upload een diagnoserapport (PDF) → AI maakt klant, voertuig en werkbon met uitleg": "Suba un informe de diagnóstico (PDF) → la IA crea cliente, vehículo y orden de trabajo con explicación",
  "Upload een eerder gedownload back-up bestand om je data terug te zetten.": "Suba un archivo de copia de seguridad descargado previamente para restaurar sus datos.",
  "Upload eerst minimaal één foto": "Suba al menos una foto primero",
  "Upload foto van code": "Subir foto del código",
  "Upload logo": "Subir logo",
  "Upload mislukt": "Fallo al subir",
  "Uploaden": "Subiendo",
  "Urenregel": "Línea de horas",
  "Uurtarief arbeid (€)": "Tarifa horaria de mano de obra (€)",
  "Uw naam": "Tu nombre",
  "VERVALLEN": "CADUCADO",
  "VIN": "VIN",
  "VIN check": "Comprobación de VIN",
  "VIN lookup mislukt": "Fallo en la búsqueda de VIN",
  "Vast (€)": "Fijo (€)",
  "Vaste klant, brengt zijn vrouw's auto ook": "Cliente habitual, también trae el coche de su mujer",
  "Veelgestelde vragen": "Preguntas frecuentes",
  "Verander een onleesbaar diagnoserapport in een actiegerichte werkbon — zonder typewerk.": "Convierte un informe de diagnóstico ilegible en una orden de trabajo procesable, sin teclear nada.",
  "Verander je wachtwoord direct zonder e-mail reset.": "Cambia tu contraseña al instante sin necesidad de un restablecimiento por correo electrónico.",
  "Verander je wachtwoord direct zonder e-mail reset. Je blijft ingelogd op alle apparaten.": "Cambia tu contraseña al instante sin necesidad de un restablecimiento por correo electrónico. Permanecerás conectado en todos los dispositivos.",
  "Verberg journaal": "Ocultar diario",
  "Verbergen": "Ocultar",
  "Verbeterde beveiliging: versleutelde SMTP-wachtwoorden en strengere toegang": "Seguridad mejorada: contraseñas SMTP cifradas y acceso más estricto",
  "Verbeterpunten": "Puntos de mejora",
  "Verbind": "Conectar",
  "Verbind je cloud-account om documenten en foto's automatisch op te slaan in jouw cloud-storage. Dit maakt multi-device toegang mogelijk.": "Conecta tu cuenta en la nube para guardar automáticamente documentos y fotos en tu almacenamiento en la nube. Esto permite el acceso desde múltiples dispositivos.",
  "Verbonden met": "Conectado a",
  "Vergeet niet": "No olvides",
  "Vergelijk in webshops": "Comparar en tiendas online",
  "Vergelijk onderdeelprijzen in 4 webshops op basis van voertuig + onderdeel": "Compara precios de piezas en 4 tiendas online según vehículo + pieza",
  "Vergelijk op Marktplaats": "Comparar en Marktplaats",
  "Vergelijk prijzen (Google)": "Comparar precios (Google)",
  "Verklaar foutcode": "Explicar código de error",
  "Verkocht": "Vendido",
  "Verkocht 28-06 aan dhr. Janssen": "Vendido el 28-06 al Sr. Janssen",
  "Verkocht deze maand": "Vendido este mes",
  "Verkocht op": "Vendido el",
  "Verkocht!": "¡Vendido!",
  "Verkoop": "Venta",
  "Verkoop & factuur": "Venta y factura",
  "Verkoopadvertentie": "Anuncio de venta",
  "Verkoopadvertentie voor Marktplaats, AutoScout24 en Facebook in 4 stijlen": "Anuncio de venta para Marktplaats, AutoScout24 y Facebook en 4 estilos",
  "Verkoophistorie": "Historial de ventas",
  "Verkoopkans": "Oportunidad de venta",
  "Verkoopprijs": "Precio de venta",
  "Verkoopprijs (€)": "Precio de venta (€)",
  "Verkoopscore, verwachte verkooptijd en concurrentie-indicatie": "Puntuación de venta, tiempo de venta esperado e indicación de competencia",
  "Verkooptijd": "Tiempo de venta",
  "Verleng / koop licentie →": "Renovar / comprar licencia →",
  "Verleng licentie →": "Renovar licencia →",
  "Vermeld bij je betaling altijd dit kenmerk:": "Indica siempre esta referencia en tu pago:",
  "Vermeld het kenmerk": "Indica la referencia",
  "Verplaatsen mislukt": "Fallo al mover",
  "Verrekend": "Compensado",
  "Verschuldigde BTW (over omzet)": "IVA adeudado (sobre ventas)",
  "Versturen mislukt": "Error al enviar",
  "Verstuur automatisch elk kwartaal het rapport van het afgelopen kwartaal": "Enviar automáticamente cada trimestre el informe del trimestre anterior",
  "Verstuur automatisch herinneringen": "Enviar automáticamente recordatorios",
  "Verstuurd": "Enviado",
  "Verstuurde herinneringen": "Recordatorios enviados",
  "Vertalen": "Traducir",
  "Vertalingen": "Traducciones",
  "Vertalingen laden...": "Cargando traducciones...",
  "Vervaldatum": "Fecha de vencimiento",
  "Vervangen": "Reemplazar",
  "Vervangen onderdelen / kosten": "Piezas reemplazadas / costes",
  "Vervangen onderdelen / materialen": "Piezas reemplazadas / materiales",
  "Verversen": "Actualizar",
  "Verversen mislukt": "Error al actualizar",
  "Verwachte marge": "Margen esperado",
  "Verwachte waarde": "Valor esperado",
  "Verwachte winst": "Beneficio esperado",
  "Verwerken mislukt": "Error al procesar",
  "Verwijder": "Eliminar",
  "Verwijder kostenpost": "Eliminar partida de gasto",
  "Verwijder uit showroom": "Eliminar del showroom",
  "Verwijderd": "Eliminado",
  "Verwijderd uit showroom": "Eliminado del showroom",
  "Verwijderen": "Eliminar",
  "Verwijderen mislukt": "Error al eliminar",
  "Verwijderen uit showroom?": "¿Eliminar del showroom?",
  "Verzendkosten (€)": "Gastos de envío (€)",
  "Via postcode": "Por código postal",
  "Via straat": "Por calle",
  "Via street": "Via street",
  "Views": "Views",
  "Vink aan wat je wilt aanmaken": "Selecciona lo que deseas crear",
  "Vlag": "Bandera",
  "Vlag emoji": "Emoji de bandera",
  "Voeg een voertuig toe zónder kenteken: maak een foto van de autopapieren": "Añadir un vehículo sin matrícula: haz una foto de la documentación del vehículo",
  "Voeg eerst een leverancier toe onder Inkoop.": "Primero añade un proveedor en Compras.",
  "Voeg eerst teamleden toe": "Primero añade miembros del equipo",
  "Voeg foto's toe — de AI herkent de staat en kenmerken. Genereer opnieuw na het uploaden.": "Añade fotos — la IA reconoce el estado y las características. Genera de nuevo después de subir.",
  "Voeg foto\\'s toe — de AI herkent de staat en kenmerken. Genereer opnieuw na het uploaden.": "Añade fotos — la IA reconoce el estado y las características. Genera de nuevo después de subir.",
  "Voeg merken/modellen toe waar dit onderdeel op past.": "Añade marcas/modelos compatibles con esta pieza.",
  "Voeg minstens 1 regel toe": "Añade al menos 1 línea",
  "Voeg onderdelen toe met de + knop.": "Añade piezas con el botón +.",
  "Voeg regels toe via de knop hierboven.": "Añade líneas mediante el botón superior.",
  "Voeg regels toe via de knoppen hierboven.": "Añade líneas mediante los botones superiores.",
  "Voeg zoveel talen toe als je wilt (Duits, Frans, Spaans, Pools, ...) en vertaal de UI zelf. Wijzigingen zijn direct zichtbaar zonder herladen.": "Añade tantos idiomas como quieras (Alemán, Francés, Español, Polaco, ...) y traduce la UI tú mismo. Los cambios son visibles al instante sin necesidad de recargar.",
  "Voegt je showroom-link + onderstaande tekst toe aan AI-advertenties voor Facebook en Forum. Niet op Marktplaats — externe links zijn daar niet toegestaan.": "Añade tu enlace al showroom + el texto siguiente a los anuncios de IA para Facebook y Forum. No en Marktplaats — los enlaces externos no están permitidos allí.",
  "Voer de admin-sleutel in om bestellingen te beheren.": "Introduce la clave de administrador para gestionar pedidos.",
  "Voer een geldig e-mailadres in": "Introduce una dirección de correo electrónico válida",
  "Voer een licentiekey in": "Introduce una clave de licencia",
  "Voer je Gemini API-sleutel in": "Introduce tu clave API de Gemini",
  "Voertuig": "Vehículo",
  "Voertuig (optioneel)": "Vehículo (opcional)",
  "Voertuig / APK": "Vehículo / ITV",
  "Voertuig gevonden": "Vehículo encontrado",
  "Voertuig opgeslagen": "Vehículo guardado",
  "Voertuig toevoegen": "Añadir vehículo",
  "Voertuig verwijderd": "Vehículo eliminado",
  "Voertuig verwijderen?": "¿Eliminar vehículo?",
  "Voertuig vrijgesteld van APK": "Vehículo exento de ITV",
  "Voertuigconditie": "Estado del vehículo",
  "Voertuigen": "Vehículos",
  "Voertuiggegevens": "Datos del vehículo",
  "Voertuigtype": "Tipo de vehículo",
  "Voertuigwaarschuwingen": "Alertas de vehículo",
  "Voettekst": "Pie de página",
  "Volgende": "Siguiente",
  "Volgende APK": "Próxima ITV",
  "Volgende beurt": "Próxima revisión",
  "Volgens onze administratie staat het volgende bedrag nog open:": "Según nuestros registros, queda pendiente el siguiente importe:",
  "Volledig instelbare meertaligheid met AI-vertaling (Google Gemini) — vertaal de hele app naar elke taal": "Multilingüismo totalmente configurable con traducción por IA (Google Gemini) — traduce toda la app a cualquier idioma",
  "Volledig mobiele weergave: schuif-menu (hamburger), overzichtelijke kaarten in plaats van brede tabellen en grote knoppen": "Vista móvil completa: menú deslizante (hamburguesa), tarjetas claras en lugar de tablas amplias y botones grandes",
  "Volledig ontvangen — voorraad bijgewerkt": "Recibido completamente — stock actualizado",
  "Volledige Engelse interface: schakel de hele app met één klik om naar het Engels — direct en vloeiend, zonder wachten": "Interfaz completa en inglés: cambia toda la aplicación al inglés con un solo clic — instantáneo y fluido, sin esperas",
  "Voor altijd (geen vervaldatum)": "Para siempre (sin fecha de caducidad)",
  "Voor de gegevens die een aangesloten garage in MonteurCentraal invoert (zoals klant- en voertuiggegevens) is de garage de verwerkingsverantwoordelijke en treedt MonteurCentraal op als verwerker. Wij verwerken die gegevens uitsluitend in opdracht van de garage en voor het leveren van de dienst. Voor de gegevens van de garage zelf (account, facturatie, licentie) zijn wij verwerkingsverantwoordelijke.": "Para los datos que un taller afiliado introduce en MonteurCentraal (como datos de clientes y vehículos), el taller es el responsable del tratamiento y MonteurCentraal actúa como encargado del tratamiento. Procesamos esos datos exclusivamente por encargo del taller y para la prestación del servicio. Para los datos del propio taller (cuenta, facturación, licencia), somos responsables del tratamiento.",
  "Voor hobbyisten / niet-BTW-plichtige sleutelaars. Alle nieuwe bonnen worden zonder BTW gemaakt, op de factuur staat \"Geen BTW van toepassing\". Schakel uit om weer normaal te factureren.": "Para aficionados / mecánicos no sujetos a IVA. Todos los nuevos recibos se crean sin IVA; en la factura se indica \"IVA no aplicable\". Desactiva para volver a facturar normalmente.",
  "Voor zover aansprakelijkheid wettelijk niet kan worden uitgesloten, is de totale aansprakelijkheid beperkt tot het laagste van het bedrag dat de klant gedurende de twaalf maanden voorafgaand aan de gebeurtenis heeft betaald of €500.": "En la medida en que la responsabilidad no pueda ser excluida legalmente, la responsabilidad total se limita a la menor de las cantidades que el cliente haya pagado durante los doce meses previos al evento o 500 €.",
  "Voor- en achternaam": "Nombre y apellidos",
  "Voorbelasting (over inkopen)": "IVA soportado (en compras)",
  "Voorgeschoten (open)": "Anticipado (abierto)",
  "Voorgeschoten bedrag": "Importe anticipado",
  "Voorgeschoten door": "Anticipado por",
  "Voorgestelde offerteregels": "Líneas de presupuesto sugeridas",
  "Voorkeur voor afspraak in ochtend": "Preferencia de cita por la mañana",
  "Voorraad": "Stock",
  "Voorraad / Min": "Stock / Mín.",
  "Voorraad, inkoop- en verkoopprijzen": "Stock, precios de compra y venta",
  "Voorraad-alerts (onder minimum)": "Alertas de stock (por debajo del mínimo)",
  "Voorraadbeheer voor gebruikte & nieuwe onderdelen (onderdelenkaart + foto's)": "Gestión de stock para piezas usadas y nuevas (ficha de pieza + fotos)",
  "Voorraadwaarde": "Valor del stock",
  "Voorraadwaarde (inkoop)": "Valor del stock (compra)",
  "Voorraadwaarde, verwachte waarde en verkochte onderdelen in één oogopslag": "Valor del stock, valor esperado y piezas vendidas de un vistazo",
  "Voorschot toegevoegd": "Anticipo añadido",
  "Voorschot verwijderen?": "¿Eliminar anticipo?",
  "Voorschotten": "Anticipos",
  "Voorstel": "Sugerencia",
  "Voortgezet gebruik van de dienst geldt als aanvaarding van de gewijzigde voorwaarden.": "El uso continuado del servicio se considerará como aceptación de las condiciones modificadas.",
  "Voorwaarden": "Términos y condiciones",
  "Vorige": "Anterior",
  "Vraag": "Pregunta",
  "Vraagprijs": "Precio de venta",
  "Vraagprijs bijgewerkt": "Precio de venta actualizado",
  "Vraagprijs-meter": "Medidor de precio de venta",
  "Vragen over deze voorwaarden kunnen worden gestuurd naar": "Las preguntas sobre estos términos pueden enviarse a",
  "Vrije regel": "Línea libre",
  "Vrijwaringsbewijs aan koper / overschrijving": "Justificante de baja para el comprador / transferencia",
  "Vrijwaringsbewijs ontvangen bij inkoop": "Justificante de baja recibido en la compra",
  "Vul beide wachtwoorden in": "Introduce ambas contraseñas",
  "Vul de klantnaam in": "Introduce el nombre del cliente",
  "Vul e-mail en wachtwoord (min 6) in": "Introduce el email y la contraseña (mín. 6 caracteres)",
  "Vul een bedrag in": "Introduce un importe",
  "Vul een code in": "Introduce un código",
  "Vul een foutcode in en klik op \"Verklaar foutcode\" voor een AI-uitleg.": "Introduce un código de error y haz clic en \"Explicar código de error\" para una explicación de IA.",
  "Vul een geldig IBAN in om de betaal-QR te genereren.": "Introduce un IBAN válido para generar el código QR de pago.",
  "Vul een geldig bedrag (excl. BTW) in": "Introduce un importe válido (IVA no incl.)",
  "Vul een kenteken in": "Introduce una matrícula",
  "Vul een kenteken in en AI schrijft direct een verkoopklare advertentie — voor Marktplaats, AutoScout24 én Facebook.": "Introduce una matrícula y la IA redactará al instante un anuncio listo para vender — para Marktplaats, AutoScout24 y Facebook.",
  "Vul een leverancier in": "Introduce un proveedor",
  "Vul een omschrijving in": "Introduce una descripción",
  "Vul een onderdeel in en klik op \"Bepaal waarde\" voor een AI-schatting.": "Introduce una pieza y haz clic en \"Determinar valor\" para una estimación de IA.",
  "Vul een onderdeelnaam in": "Introduce el nombre de una pieza",
  "Vul een titel in": "Introduce un título",
  "Vul een voertuig in en kies een categorie.": "Introduce un vehículo y elige una categoría.",
  "Vul eerst een kenteken in": "Introduce primero una matrícula",
  "Vul eerst een onderdeelnaam in": "Introduce primero el nombre de una pieza",
  "Vul eerst een voertuig in (kenteken of merk)": "Introduce primero un vehículo (matrícula o marca)",
  "Vul eerst het chassisnummer in": "Introduce primero el número de bastidor",
  "Vul eerst het kenteken in": "Introduce primero la matrícula",
  "Vul eerst kenteken in": "Introduce primero la matrícula",
  "Vul eerst postcode + huisnr in": "Introduce primero el código postal + número de vivienda",
  "Vul eerst postcode en huisnummer in (huisnummer in adresveld)": "Introduce primero el código postal y el número de vivienda (número de vivienda en el campo de dirección)",
  "Vul eerst straat + huisnr in (bv. \"Bagijnhof 33\")": "Introduce primero calle + número (ej. \"Bagijnhof 33\")",
  "Vul eerst straat + huisnummer in (bv. \"Bagijnhof 33\")": "Introduce primero la calle + número de vivienda (ej. \"Bagijnhof 33\")",
  "Vul huidig en nieuw wachtwoord in": "Introduce la contraseña actual y la nueva",
  "Vul in hoeveel er in totaal ontvangen is. Gekoppelde artikelen worden verhoogd; vrije regels worden automatisch als nieuw voorraad-artikel aangemaakt.": "Introduce la cantidad total recibida. Los artículos vinculados se aumentarán; las líneas libres se crearán automáticamente como nuevos artículos de stock.",
  "Vul in via postcode": "Introduce por código postal",
  "Vul je e-mail credentials in om facturen en herinneringen vanuit jouw eigen e-mailadres te versturen.": "Introduce tus credenciales de email para enviar facturas y recordatorios desde tu propia dirección de email.",
  "Vul je e-mail in": "Introduce tu email",
  "Vul je e-mailadres in": "Introduce tu dirección de email",
  "Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord in te stellen.": "Introduce tu dirección de email. Te enviaremos un enlace para establecer una nueva contraseña.",
  "Vul kenteken of merk in": "Introduce la matrícula o la marca",
  "Vul lege keys automatisch via AI": "Rellena automáticamente las claves vacías con IA",
  "Vul minimaal een foutcode in (bv. P0300)": "Introduce al menos un código de error (ej. P0300)",
  "Vul minimaal kenteken of merk/model in": "Introduce al menos la matrícula o la marca/modelo",
  "Vul ook plaats in (autocomplete helpt)": "Introduce también la localidad (la función de autocompletar ayuda)",
  "Vul plaats en straat in via postcode + huisnr": "Introduce la localidad y la calle a través del código postal + número de vivienda",
  "Vul postcode in via straat + huisnr + plaats": "Introduce el código postal a través de la calle + número de vivienda + localidad",
  "Vul postcode via straat + plaats": "Introduce el código postal a través de la calle + localidad",
  "Vul uw naam in.": "Introduce su nombre.",
  "W-2025-0232 voor Ahmed El Amrani": "Orden de trabajo W-2025-0232 para Ahmed El Amrani",
  "WERKBON": "ORDEN DE TRABAJO",
  "WINST & VERLIES": "GANANCIAS Y PÉRDIDAS",
  "Waarde onderweg": "Valor en tránsito",
  "Waardebepaling": "Valoración",
  "Waarschijnlijke oorzaken": "Posibles causas",
  "Wacht op akkoord": "Esperando aprobación",
  "Wacht op betaling": "Esperando pago",
  "Wacht op onderdelen": "Esperando piezas",
  "Wachtwoord": "Contraseña",
  "Wachtwoord gewijzigd": "Contraseña cambiada",
  "Wachtwoord gewijzigd!": "¡Contraseña cambiada!",
  "Wachtwoord herhalen": "Repetir contraseña",
  "Wachtwoord minimaal 6 tekens": "La contraseña debe tener al menos 6 caracteres",
  "Wachtwoord opslaan": "Guardar contraseña",
  "Wachtwoord resetten": "Restablecer contraseña",
  "Wachtwoord vergeten?": "¿Olvidaste tu contraseña?",
  "Wachtwoord wijzigen": "Cambiar contraseña",
  "Wachtwoorden komen niet overeen": "Las contraseñas no coinciden",
  "Wanneer een bonregel een van de trefwoorden bevat, toont de bon-editor eenmalig een tip. Trefwoorden en suggesties scheid je met komma\\'s; álle trefwoorden moeten voorkomen.": "Cuando una línea de un recibo contiene alguna de las palabras clave, el editor de recibos mostrará un consejo una sola vez. Separa las palabras clave y las sugerencias con comas; todas las palabras clave deben aparecer.",
  "Wat garages over ons zeggen": "Lo que los talleres dicen de nosotros",
  "Wat gebeurt er met mijn gegevens?": "¿Qué ocurre con mis datos?",
  "Wat is er aan de auto gedaan?": "¿Qué se ha hecho en el coche?",
  "Wat is nieuw": "Novedades",
  "Wat voor werk wil je inplannen?": "¿Qué tipo de trabajo quieres programar?",
  "Wat's nieuw": "Novedades",
  "We bewaren gegevens niet langer dan nodig. Facturatiegegevens bewaren we conform de wettelijke fiscale bewaarplicht (7 jaar). Apparaatregistraties die 90 dagen niet zijn gebruikt worden automatisch verwijderd. Bij beëindiging van het account verwijderen of anonimiseren we persoonsgegevens binnen een redelijke termijn, behoudens wettelijke verplichtingen.": "No conservamos los datos más tiempo del necesario. Los datos de facturación se conservan de acuerdo con la obligación legal de retención fiscal (7 años). Los registros de dispositivos que no se hayan utilizado durante 90 días se eliminarán automáticamente. Al finalizar la cuenta, eliminaremos o anonimizaremos los datos personales en un plazo razonable, salvo obligaciones legales.",
  "We gebruiken alleen functionele opslag (zoals een lokale apparaat-id en je inlogsessie) die noodzakelijk is voor de werking van de applicatie. We gebruiken geen tracking- of advertentiecookies.": "Solo utilizamos almacenamiento funcional (como un ID de dispositivo local y tu sesión de inicio de sesión) que es necesario para el funcionamiento de la aplicación. No utilizamos cookies de seguimiento o publicidad.",
  "We hebben de key ook gemaild naar": "También te hemos enviado la clave por correo electrónico a",
  "We hebben deze betaalinstructies ook naar je gemaild.": "También te hemos enviado estas instrucciones de pago por correo electrónico.",
  "We hebben een activatielink gestuurd naar": "Hemos enviado un enlace de activación a",
  "We konden de betaling niet bevestigen. Check je e-mail of probeer opnieuw.": "No pudimos confirmar el pago. Comprueba tu correo electrónico o inténtalo de nuevo.",
  "We kunnen deze privacyverklaring aanpassen. De meest actuele versie vind je altijd op deze pagina.": "Podemos modificar esta declaración de privacidad. La versión más actualizada siempre estará disponible en esta página.",
  "We nemen passende technische en organisatorische maatregelen, waaronder versleutelde wachtwoorden, toegangsbeperking per garage (multi-tenant isolatie) en versleutelde verbindingen (HTTPS).": "Tomamos medidas técnicas y organizativas adecuadas, incluyendo contraseñas cifradas, restricción de acceso por taller (aislamiento multi-tenant) y conexiones cifradas (HTTPS).",
  "We take appropriate technical and organizational measures, including encrypted passwords, access restriction per garage (multi-tenant isolation), and encrypted connections (HTTPS).": "We take appropriate technical and organizational measures, including encrypted passwords, access restriction per garage (multi-tenant isolation), and encrypted connections (HTTPS).",
  "We tonen deze site in jouw taal — wijzig hier": "Mostramos este sitio en tu idioma — cambiar aquí",
  "Webshop: pakketten bestellen, betalen (bank/PayPal) en automatische licentie-uitgifte": "Tienda online: pedir paquetes, pagar (banco/PayPal) y emisión automática de licencias",
  "Weekagenda": "Agenda semanal",
  "Weer inslaan": "Reabastecer",
  "Welkom bij": "Bienvenido a",
  "Welkom bij MonteurCentraal!": "¡Bienvenido a MonteurCentraal!",
  "Welkom terug!": "¡Bienvenido de nuevo!",
  "Werkbon": "Orden de trabajo",
  "Werkbon / Offerte / Factuur": "Orden de trabajo / Presupuesto / Factura",
  "Werkbon met alle foutcodes als regels — direct factureerbaar": "Orden de trabajo con todos los códigos de error como líneas — facturable directamente",
  "Werkbon verwijderd": "Orden de trabajo eliminada",
  "Werkbon verwijderen?": "¿Eliminar orden de trabajo?",
  "Werkdatum": "Fecha de trabajo",
  "Werkkaart: nieuwe bon bovenaan, open klant, nieuwe planning, open PDF": "Hoja de trabajo: nueva orden arriba, cliente abierto, nueva planificación, abrir PDF",
  "Werkorder": "Orden de trabajo",
  "Werkorder niet gevonden of de link is verlopen.": "Orden de trabajo no encontrada o el enlace ha caducado.",
  "Werkorder opgeslagen": "Orden de trabajo guardada",
  "Werkplaatsplanning": "Planificación del taller",
  "Werkplaatsstatus": "Estado del taller",
  "Werkplek / brug": "Puesto de trabajo / elevador",
  "Werkplek- & magazijnlocaties": "Ubicaciones de puestos de trabajo y almacén",
  "Werkstatus": "Estado del trabajo",
  "Werkt het op meerdere computers?": "¿Funciona en varios ordenadores?",
  "Werkt met Autel en andere OBD-diagnoserapporten": "Compatible con Autel y otros informes de diagnóstico OBD",
  "Werkt ook met buitenlandse documenten (bv. Duitse Zulassungsbescheinigung)": "También funciona con documentos extranjeros (p. ej., Zulassungsbescheinigung alemana)",
  "Werkt vlot op de werkvloer — alle pagina's (dashboard, planning, werkkaarten, klanten, voertuigen, onderdelen, handel, facturen) zijn responsive": "Funciona sin problemas en el taller — todas las páginas (panel de control, planificación, órdenes de trabajo, clientes, vehículos, piezas, comercio, facturas) son adaptables",
  "Werkt voor álle voertuigtypes: auto, camper, caravan, aanhanger, scooter, brommer, motor, vrachtwagen, oldtimer": "Funciona para TODO tipo de vehículos: coche, autocaravana, caravana, remolque, scooter, ciclomotor, moto, camión, clásico",
  "Werkzaamheden": "Trabajos",
  "Werkzaamheid": "Trabajo",
  "WhatsApp ons": "Envíanos un WhatsApp",
  "Wie heeft voorgeschoten?": "¿Quién ha adelantado el dinero?",
  "Wij delen gegevens alleen met partijen die nodig zijn om de dienst te leveren:": "Solo compartimos datos con las partes necesarias para prestar el servicio:",
  "Wij verkopen je gegevens nooit aan derden.": "Nunca vendemos tus datos a terceros.",
  "Wij verzoeken u vriendelijk het openstaande bedrag te voldoen. Heeft u inmiddels betaald? Dan kunt u deze herinnering als niet verzonden beschouwen.": "Le rogamos que abone el importe pendiente. ¿Ha pagado ya? En tal caso, puede hacer caso omiso de este recordatorio.",
  "Wijzig": "Modificar",
  "Wijzigen mislukt": "Error al modificar",
  "Wijzigingen niet opgeslagen": "Cambios no guardados",
  "Wil je de garage per e-mail op de hoogte stellen van de intrekking? OK = wel mailen, Annuleren = niet mailen": "¿Deseas notificar al taller por correo electrónico la retirada? OK = enviar correo, Cancelar = no enviar correo",
  "Winst": "Beneficio",
  "Winst & Verlies": "Pérdidas y ganancias",
  "Winst%": "Beneficio %",
  "Winstaandeel": "Participación en el beneficio",
  "Winstaandeel opgeslagen": "Participación en el beneficio guardada",
  "Winstaandeel per teamlid + voorgeschoten kosten": "Participación en el beneficio por miembro del equipo + gastos adelantados",
  "Winstaandeel per teamlid en voorgeschoten kosten verrekenen": "Calcular la participación en el beneficio por miembro del equipo y los gastos adelantados",
  "Winstberekening": "Cálculo de beneficios",
  "Winstverdeling per teamlid": "Distribución de beneficios por miembro del equipo",
  "Wis": "Borrar",
  "Wis filters en probeer opnieuw": "Borrar filtros y volver a intentarlo",
  "Wissen": "Borrar",
  "Wordt gebruikt op alle bonnen, facturen en offertes": "Se utiliza en todos los recibos, facturas y presupuestos",
  "Workflow": "Flujo de trabajo",
  "You have the right to access, rectify, erase, restrict, and port your personal data, and the right to object. Please contact us via": "You have the right to access, rectify, erase, restrict, and port your personal data, and the right to object. Please contact us via",
  "Zakelijk": "Empresarial",
  "Zakelijke klant, factuur per maand": "Cliente empresarial, factura mensual",
  "Zekerheid": "Seguridad",
  "Zelfde merk": "Misma marca",
  "Zet aan om je boekingspagina te activeren.": "Habilita para activar tu página de reservas.",
  "Zet de status op \"Bevestigd\" en klik op Bevestiging om de klant te informeren.": "Cambia el estado a \"Confirmado\" y haz clic en Confirmación para informar al cliente.",
  "Zet een klacht om in concrete offerteregels (arbeid + onderdelen)": "Convierte una queja en líneas de presupuesto concretas (mano de obra + piezas)",
  "Zet op beginscherm": "Añadir a la pantalla de inicio",
  "Zichtbare schade": "Daños visibles",
  "Zo goed als nieuw": "Como nuevo",
  "Zodra je betaling binnen is, ontvang je je licentiekey automatisch per e-mail op": "Una vez recibido tu pago, recibirás tu clave de licencia automáticamente por correo electrónico en",
  "Zoek": "Buscar",
  "Zoek artikel of code… (bijv. koppeling, olie)": "Buscar artículo o código… (ej. embrague, aceite)",
  "Zoek bij": "Buscar en",
  "Zoek claim...": "Buscar reclamación...",
  "Zoek code, omschrijving of locatie...": "Buscar código, descripción o ubicación...",
  "Zoek door klanten, bonnen, kentekens en documenten": "Buscar entre clientes, recibos, matrículas y documentos",
  "Zoek in keys of vertalingen...": "Buscar en claves o traducciones...",
  "Zoek kenteken, merk of model...": "Buscar matrícula, marca o modelo...",
  "Zoek kenteken/locatie/klant": "Buscar matrícula/ubicación/cliente",
  "Zoek kenteken/merk/klant": "Buscar matrícula/marca/cliente",
  "Zoek leverancier...": "Buscar proveedor...",
  "Zoek op kenteken, klantnaam, bonnummer of plaats": "Buscar por matrícula, nombre de cliente, número de recibo o localidad",
  "Zoek op merk, model...": "Buscar por marca, modelo...",
  "Zoek op naam, OEM, nummer, merk…": "Buscar por nombre, OEM, número, marca…",
  "Zoek op naam, klant of kenteken...": "Buscar por nombre, cliente o matrícula...",
  "Zoek op naam, plaats, telefoon, kenteken...": "Buscar por nombre, localidad, teléfono, matrícula...",
  "Zoek op nummer, klant, omschrijving, kenteken...": "Buscar por número, cliente, descripción, matrícula...",
  "Zoek op onderdeel, merk, model, OEM-nr...": "Buscar por pieza, marca, modelo, n.º OEM...",
  "Zoek ordernr of leverancier...": "Buscar n.º de pedido o proveedor...",
  "Zoeken op kenteken, OEM, nummer, merk; voorraadwaarde & verkoophistorie": "Buscar por matrícula, OEM, número, marca; valor de stock e historial de ventas",
  "Zoeken op klant of e-mail...": "Buscar por cliente o e-mail...",
  "Zoeken op leverancier, omschrijving, factuurnr...": "Buscar por proveedor, descripción, n.º de factura...",
  "Zoeken...": "Buscar...",
  "Zoekopdracht": "Búsqueda",
  "Zonder ingestelde sleutel werken de AI-knoppen niet.": "Sin una clave configurada, los botones de IA no funcionarán.",
  "aandacht": "atención",
  "actieve apparaten toe. Meld een ander apparaat af om op dit apparaat verder te werken.": "Demasiados dispositivos activos. Cierra sesión en otro dispositivo para seguir trabajando en este.",
  "actieve meldingen die aandacht vragen": "notificaciones activas que requieren atención",
  "afgekeurd": "rechazado",
  "afspraken": "citas",
  "afspraken met een dubbele boeking (zelfde brug of monteur op hetzelfde moment). Controleer de capaciteit.": "Citas con doble reserva (mismo elevador o mecánico al mismo tiempo). Comprueba la capacidad.",
  "all current data in your garage will be replaced by the contents of the file.": "all current data in your garage will be replaced by the contents of the file.",
  "all current data in your garage will be replaced with the contents of the file.": "all current data in your garage will be replaced with the contents of the file.",
  "alle arbeid + onderdelen over alle bonnen": "toda la mano de obra + piezas en todos los recibos",
  "alle functies waarbij automatisch gegevens, teksten, berekeningen, analyses of herkenningen worden gegenereerd.": "todas las funciones en las que se generan automáticamente datos, textos, cálculos, análisis o reconocimientos.",
  "alle huidige data in jouw garage wordt vervangen door de inhoud van het bestand.": "todos los datos actuales de tu taller serán reemplazados por el contenido del archivo.",
  "alleen als de garage zelf cloud back-up koppelt.": "solo si el taller vincula la copia de seguridad en la nube.",
  "alles + 25 medewerkers": "todo + 25 empleados",
  "als app voor sneller werken op je telefoon of pc.": "como app para trabajar más rápido en tu teléfono u ordenador.",
  "apparaten": "dispositivos",
  "arbeid": "mano de obra",
  "artikelen": "artículos",
  "auto": "coche",
  "automatisch": "automático",
  "backup.auto.desc": "enviamos automáticamente cada 24h una copia de seguridad nueva a tu carpeta en la nube.",
  "backup.cloud.desc": "Envía directamente una copia de seguridad completa a tu nube vinculada (Dropbox / Google Drive). El archivo aparecerá en tu",
  "backup.cloud.licenseRequired": "Licencia requerida. Activa primero una licencia PRO o ENTERPRISE en",
  "backup.cloud.linked": "Nube vinculada:",
  "backup.cloud.notLinked": "Aún no hay nube vinculada. Ve a",
  "backup.cloud.notLinked.suffix": "pestaña y vincula Dropbox o Google Drive.",
  "backup.download.desc": "Descarga una instantánea JSON completa de todos los datos (clientes, vehículos, recibos, agenda, stock, pagos, etc). Guarda este archivo en un lugar seguro (Dropbox / Google Drive / disco externo).",
  "backup.restore.desc": "Sube un archivo de copia de seguridad descargado previamente para restaurar tus datos.",
  "backup.restore.warning": "todos los datos actuales de tu taller se reemplazarán por el contenido del archivo.",
  "basis features": "funciones básicas",
  "bekend is, hebben we een reset-link verstuurd. De link is 2 uur geldig.": "conocida, hemos enviado un enlace de restablecimiento. El enlace es válido durante 2 horas.",
  "bellen": "llamar",
  "beschikbaar.": "disponible.",
  "bestelreferentie, e-mailadres, gekozen pakket.": "referencia de pedido, dirección de correo electrónico, paquete elegido.",
  "betalingen": "pagos",
  "bewerken": "editar",
  "bijv. remblokken voor": "ej. pastillas de freno delanteras",
  "binnenkort": "próximamente",
  "boekhouder@kantoor.nl": "contable@oficina.es",
  "bonnen": "recibos",
  "bonnen in behandeling": "recibos pendientes",
  "bv. 2e eigenaar, rookvrij, nieuwe winterbanden…": "ej. 2º propietario, no fumador, neumáticos de invierno nuevos…",
  "bv. Bagijnhof 33 of Kerkstraat 5": "ej. Bagijnhof 33 o Kerkstraat 5",
  "bv. Bosch, Shell, verhuurder": "ej. Bosch, Shell, arrendador",
  "bv. Deutsch, Français, Español": "ej. Deutsch, Français, Español",
  "bv. Garage Janssen": "ej. Taller García",
  "bv. Jan / Garage": "ej. Juan / Taller",
  "bv. Medemblik": "ej. Medemblik",
  "bv. Onderdelen bij Kroymans gehaald": "ej. Piezas obtenidas en Kroymans",
  "bv. Remblokken vervangen": "ej. Sustitución de pastillas de freno",
  "bv. Remblokken voor + olieservice": "ej. Pastillas de freno delanteras + servicio de aceite",
  "bv. Trillingen bij remmen, piepend geluid voorzijde": "ej. Vibraciones al frenar, ruido chirriante en la parte delantera",
  "bv. de, fr, es, pl": "ej. de, fr, es, pl",
  "bv. kleine kras achterbumper, steenslag motorkap": "ej. pequeño rasguño en el parachoques trasero, picadas en el capó",
  "bv. volledig onderhoudsboekje, dealer onderhouden": "ej. libro de mantenimiento completo, mantenido por concesionario",
  "cloud sync + 5 medewerkers": "sincronización en la nube + 5 empleados",
  "col.apk": "ITV",
  "col.kenteken": "Matrícula",
  "col.km": "KM",
  "col.merk_model": "Marca / Modelo",
  "common.open": "Abrir",
  "common.type": "Tipo",
  "controleer de voorgestelde koppelingen": "compruebe los enlaces sugeridos",
  "cs-card padded": "cs-card padded",
  "dagen": "días",
  "dagen geldig": "días de validez",
  "dagen open": "días abierto",
  "dagen verlopen": "días caducados",
  "dash.apk_alerts": "Alertas ITV (en 60 días)",
  "dash.audit_trail": "Historial de auditoría (última actividad)",
  "dash.open_amount": "Importe pendiente",
  "dash.quick_actions": "Acciones rápidas",
  "dash.recent_receipts": "Recibos recientes",
  "dash.refresh_alerts": "Actualizar notificaciones",
  "dash.revenue_per_month": "Facturación mensual (€) - últimos 12 meses",
  "dash.stock_alerts": "Alertas de stock (bajo mínimo)",
  "dash.subtitle": "Resumen del taller",
  "dash.this_month": "Este mes",
  "dash.this_week": "Esta semana",
  "dash.this_year": "Este año",
  "dash.title": "Panel de control",
  "dash.today": "Hoy",
  "dash.todays_planning": "Planificación de hoy",
  "dash.top_customers": "Top 5 clientes por facturación",
  "dash.top_open": "Top facturas pendientes",
  "dash.vehicles": "Vehículos",
  "de aanbieder van de software en bijbehorende diensten.": "el proveedor del software y los servicios asociados.",
  "de duur bepaalt automatisch de beschikbare tijdsloten": "la duración determina automáticamente los tramos horarios disponibles",
  "de online software (SaaS), website, API’s, mobiele toepassingen, AI-functionaliteiten en overige diensten van MonteurCentraal.": "el software online (SaaS), sitio web, APIs, aplicaciones móviles, funcionalidades de IA y otros servicios de MonteurCentraal.",
  "de persoonlijke toegang tot de dienst.": "el acceso personal al servicio.",
  "deel deze op je website, Google en social media": "compártelo en tu sitio web, Google y redes sociales",
  "deze maand": "este mes",
  "dgn": "días",
  "dit apparaat": "este dispositivo",
  "documenten in archief": "documentos en archivo",
  "door": "por",
  "e.g. Jan de Vries": "p. ej. Jan de Vries",
  "e.g., Garage Janssen": "p. ej., Taller Janssen",
  "e.g., Jan / Garage": "p. ej., Jan / Taller",
  "eenmalig": "una vez",
  "eenmalig, voor altijd": "una vez, para siempre",
  "en kies": "y selecciona",
  "en log in met je Google-account.": "e inicia sesión con tu cuenta de Google.",
  "en niet 100%. Pas de aandelen aan zodat ze samen 100% vormen.": "y no el 100 %. Ajusta las proporciones para que sumen el 100 %.",
  "exact zoals de PDF": "exactamente como el PDF",
  "facturen": "facturas",
  "fooi": "propina",
  "foto(\\'s) gedownload": "foto(s) descargada(s)",
  "foto(\\'s) opgeslagen": "foto(s) guardada(s)",
  "foutcode(s) gevonden": "código(s) de error encontrado(s)",
  "garage": "taller",
  "garantie": "garantía",
  "gebruik een": "usa un",
  "gebruiker": "usuario",
  "gebruikers": "usuarios",
  "geen": "no",
  "geen BTW": "sin IVA",
  "geen e-mail": "sin e-mail",
  "geen e-mailadres": "sin dirección de e-mail",
  "geen omschrijving": "sin descripción",
  "geen regels": "sin líneas",
  "geen vervaldatum": "sin fecha de vencimiento",
  "geen voorraadkoppeling": "sin vinculación de stock",
  "gegevens die klanten invoeren bij online afspraken.": "datos que los clientes introducen al solicitar citas online.",
  "gekopieerd": "copiado",
  "geselecteerd": "seleccionado",
  "getroffen voertuig(en) in je bestand": "vehículo(s) afectado(s) en tu registro",
  "gevonden voor kenteken": "encontrado para matrícula",
  "handig bij buitenlandse auto's": "útil para coches extranjeros",
  "handig bij buitenlandse auto\\'s": "útil para coches extranjeros",
  "handmatig": "manual",
  "herinnering": "recordatorio",
  "herinnering(en) verstuurd": "recordatorio(s) enviado(s)",
  "het recht om de dienst te gebruiken binnen de grenzen van het gekozen pakket.": "el derecho a usar el servicio dentro de los límites del paquete elegido.",
  "het systeem mailt klanten automatisch zodra een factuur vervalt": "el sistema envía correos electrónicos automáticamente a los clientes tan pronto como una factura vence",
  "iedere natuurlijke persoon of rechtspersoon die gebruikmaakt van de dienst.": "toda persona física o jurídica que utilice el servicio.",
  "in het opmerkingenveld van PayPal.": "en el campo de comentarios de PayPal.",
  "in wachtrij": "en cola",
  "incl.": "incl.",
  "inkoop + kosten": "compra + costes",
  "is op de hoogte gesteld.": "ha sido notificado.",
  "jaar geldig": "válido por un año",
  "jan de vries": "jan de vries",
  "kentekens en voertuiggegevens opvragen (openbare data).": "consultar matrículas y datos de vehículos (datos públicos).",
  "klant": "cliente",
  "klanten geregistreerd": "clientes registrados",
  "klik op een kenteken voor volledige historie": "haz clic en una matrícula para ver el historial completo",
  "koppeling": "vinculación",
  "koppeling(en) verwerken": "procesar vinculación(es)",
  "kost": "costo",
  "kosten": "costos",
  "laatst actief": "última actividad",
  "leeg": "vacío",
  "leveranciers": "proveedores",
  "licentie is direct beschikbaar.": "licencia disponible al instante.",
  "map.": "carpeta.",
  "marge ÷ kostprijs": "margen ÷ coste",
  "mary-jane van der berg": "mary-jane van der berg",
  "meldingen ververst": "notificaciones actualizadas",
  "mislukt": "fallido",
  "ml-auto h-4 w-4": "ml-auto h-4 w-4",
  "ml-auto text-xs tracking-widest opacity-60": "ml-auto text-xs tracking-widest opacity-60",
  "ml-auto text-xs tracking-widest text-muted-foreground": "ml-auto text-xs tracking-widest text-muted-foreground",
  "mt-auto flex flex-col gap-2 p-4": "mt-auto flex flex-col gap-2 p-4",
  "mx-auto flex w-full justify-center": "mx-auto flex w-full justify-center",
  "naam, contactgegevens, kenteken, voertuig- en reparatiegegevens.": "nombre, datos de contacto, matrícula, datos del vehículo y de reparación.",
  "naam, e-mailadres, bedrijfsgegevens, inloggegevens (versleuteld).": "nombre, dirección de correo electrónico, datos de la empresa, credenciales de inicio de sesión (encriptadas).",
  "nav.accounting": "Contabilidad",
  "nav.admaker": "Crear anuncio",
  "nav.ai": "IA",
  "nav.alerts": "Notificaciones",
  "nav.apk": "ITV y Mantenimiento",
  "nav.balance": "Balance",
  "nav.bankimport": "Importación bancaria",
  "nav.cartrade": "Compraventa de vehículos",
  "nav.customers": "Clientes",
  "nav.dashboard": "Dashboard",
  "nav.debtors": "Gestión de cobros",
  "nav.diagnose": "Diagnóstico IA",
  "nav.documents": "Documentos",
  "nav.expenses": "Gastos / Facturas de compra",
  "nav.faultcode": "Explicación de códigos de avería (IA)",
  "nav.garage": "Datos",
  "nav.layout": "Plantilla de recibo",
  "nav.ledger": "Libro mayor",
  "nav.oh_ads": "Anuncios",
  "nav.oh_history": "Historial de ventas",
  "nav.oh_new": "Recambios nuevos",
  "nav.oh_scrap": "Coches para desguace",
  "nav.oh_stock": "Stock",
  "nav.oh_used": "Recambios usados",
  "nav.oh_value": "Valoración",
  "nav.onlinebooking": "Citas online",
  "nav.parts": "Recambios",
  "nav.partstrade": "Comercio de recambios",
  "nav.payments": "Pagos",
  "nav.planning": "Agenda",
  "nav.purchaseorders": "Órdenes de compra",
  "nav.purchasing": "Compras",
  "nav.quoteassist": "Asistente de presupuestos (IA)",
  "nav.receipts": "Recibos",
  "nav.reminders": "Recordatorios automáticos",
  "nav.reporting": "Informes",
  "nav.search": "Buscar",
  "nav.settings": "Ajustes",
  "nav.settle": "Liquidación",
  "nav.showroom": "Showroom",
  "nav.suppliers": "Proveedores",
  "nav.tyrehotel": "Hotel de neumáticos",
  "nav.vatprofit": "IVA y beneficios",
  "nav.warranty": "Reclamaciones de garantía",
  "nav.whatsnew": "Novedades",
  "nav.workcard": "Orden de trabajo",
  "niet koppelen": "No vincular",
  "niet van toepassing voor aanhanger < 750kg, etc.": "no aplicable para remolques < 750 kg, etc.",
  "nieuw(e) artikel(en) aangemaakt in voorraad": "Nuevo(s) artículo(s) creado(s) en stock",
  "nieuwe journaalposten aangemaakt": "Nuevos asientos de diario creados",
  "nog": "Aún",
  "o.b.v. bedrag": "Basado en importe",
  "o.b.v. nummer": "Basado en número",
  "of": "o",
  "of klik om een PDF te kiezen (max 15 MB)": "o haga clic para elegir un PDF (máx. 15 MB)",
  "of typ kenteken": "o escriba la matrícula",
  "om bijvoorbeeld een vervangen onderdeel of voorgeschoten kosten te registreren.": "para registrar, por ejemplo, una pieza reemplazada o gastos adelantados.",
  "onder minimum voorraad": "Bajo stock mínimo",
  "onder vermelding van bonnummer": "indicando el número de recibo",
  "onderdelen": "Piezas",
  "only if the garage links cloud backup itself.": "only if the garage links cloud backup itself.",
  "open": "Abierto",
  "open facturen": "Facturas abiertas",
  "openstaand": "Pendiente",
  "optioneel": "Opcional",
  "optioneel — wie heeft onderdelen/kosten betaald": "Opcional — quién pagó las piezas/costes",
  "orders": "Pedidos",
  "over arbeid": "Sobre la mano de obra",
  "over te maken": "A transferir",
  "page.alerts.sub": "ITV, pagos pendientes y clientes inactivos",
  "page.alerts.title": "Notificaciones",
  "page.cartrade.sub": "Stock de compraventa y vehículos vendidos",
  "page.cartrade.title": "Compraventa de vehículos",
  "page.customers.sub": "Gestión de clientes con vehículos e historial",
  "page.customers.title": "Clientes",
  "page.dashboard.sub": "Resumen de su taller",
  "page.dashboard.title": "Dashboard",
  "page.documents.sub": "Gestión PDF y sincronización nube",
  "page.documents.title": "Documentos",
  "page.garage.sub": "Usado en recibos, facturas y presupuestos",
  "page.garage.title": "Datos del taller",
  "page.layout.sub": "Ajustar diseño de presupuestos y facturas",
  "page.layout.title": "Diseño recibos",
  "page.parts.sub": "Stock, precios compra y venta",
  "page.parts.title": "Recambios",
  "page.payments.sub": "Pagos registrados y facturas pendientes",
  "page.payments.title": "Pagos",
  "page.planning.sub": "Citas y agenda de trabajo",
  "page.planning.title": "Agenda",
  "page.receipts.sub": "Presupuestos, órdenes de trabajo y facturas",
  "page.receipts.title": "Recibos",
  "page.reporting.sub": "Informes financieros y operativos",
  "page.reporting.title": "Informes",
  "page.search.sub": "Buscar por matrícula, cliente, recibo o localidad",
  "page.search.title": "Buscar",
  "page.settings.sub": "Gestionar licencia, nube, equipo y copia de seguridad",
  "page.settings.title": "Ajustes",
  "page.settle.sub": "Ganancias por miembro + gastos anticipados",
  "page.settle.title": "Liquidación",
  "page.workcard.sub": "Trabajos abiertos y reparaciones en curso",
  "page.workcard.title": "Orden de trabajo",
  "pagina": "Página",
  "per": "Por",
  "poging": "Intento",
  "posten": "Asientos",
  "posten bijgewerkt": "Asientos actualizados",
  "reeds voldaan": "Ya pagado",
  "regel(s)": "Línea(s)",
  "regels": "Líneas",
  "regels totaal": "Total de líneas",
  "relative w-full overflow-auto": "relative w-full overflow-auto",
  "repeat(auto-fill, minmax(150px, 1fr))": "repeat(auto-fill, minmax(150px, 1fr))",
  "repeat(auto-fill, minmax(190px, 1fr))": "repeat(auto-fill, minmax(190px, 1fr))",
  "repeat(auto-fit, minmax(160px, 1fr))": "repeat(auto-fit, minmax(160px, 1fr))",
  "repeat(auto-fit, minmax(180px, 1fr))": "repeat(auto-fit, minmax(180px, 1fr))",
  "repeat(auto-fit, minmax(220px, 1fr))": "repeat(auto-fit, minmax(220px, 1fr))",
  "repeat(auto-fit, minmax(230px, 1fr))": "repeat(auto-fit, minmax(230px, 1fr))",
  "repeat(auto-fit, minmax(248px, 1fr))": "repeat(auto-fit, minmax(248px, 1fr))",
  "repeat(auto-fit, minmax(260px, 1fr))": "repeat(auto-fit, minmax(260px, 1fr))",
  "repeat(auto-fit, minmax(280px, 1fr))": "repeat(auto-fit, minmax(280px, 1fr))",
  "repeat(auto-fit, minmax(92px, 1fr))": "repeat(auto-fit, minmax(92px, 1fr))",
  "resultaten gevonden": "Resultados encontrados",
  "sets in opslag": "Juegos en almacén",
  "sleutels": "Llaves",
  "tab.backup": "Copia de seguridad",
  "tab.cloud": "Sincronización nube",
  "tab.general": "General",
  "tab.languages": "Idiomas",
  "tab.license": "Licencia",
  "tab.maillog": "Registro de correos",
  "tab.notifications": "Notificaciones",
  "tab.plans": "Planificación",
  "tab.smtp": "SMTP / Correo electrónico",
  "tab.team": "Equipo",
  "tabblad en koppel Dropbox of Google Drive.": "pestaña y vincule Dropbox o Google Drive.",
  "te koop": "En venta",
  "tik op": "tocar",
  "tonen": "mostrar",
  "totaal": "total",
  "totaal ontvangen": "total recibido",
  "transacties": "transacciones",
  "uur": "horas",
  "uw garage": "tu taller",
  "verbergen": "ocultar",
  "vergelijkbare": "similares",
  "verkochte onderdelen": "piezas vendidas",
  "verlies": "pérdida",
  "versturen van e-mails (afspraken, herinneringen, licenties).": "envío de correos electrónicos (citas, recordatorios, licencias).",
  "vervalt": "expira",
  "verwijderen?": "¿Eliminar?",
  "views": "vistas",
  "voor het draaien van de applicatie en database.": "para la ejecución de la aplicación y la base de datos.",
  "voorgeschoten door": "adelantado por",
  "waarvan fooi": "de los cuales propina",
  "wij sturen elke 24u automatisch een verse back-up naar je cloud-map.": "Enviamos automáticamente una copia de seguridad reciente a tu carpeta en la nube cada 24h.",
  "wijzigingen wachten op sync": "cambios pendientes de sincronización",
  "winst": "ganancia",
  "wisseltip(s)": "consejo(s)",
  "zien dezelfde data": "ven los mismos datos",
  "{count} meldingen geregenereerd": "{count} notificaciones regeneradas",
  "— Geen / handmatig —": "— Ninguno / manual —",
  "•••••••• (nieuwe sleutel invoeren om te wijzigen)": "•••••••• (introducir nueva clave para modificar)",
  "← Terug naar prijzen": "← Volver a precios",
  "🌍 AI-vertalen: vertaal de hele advertentie naar 8 talen (NL/EN/DE/FR/PL/ES/IT/TR) — natuurlijk, geen letterlijke vertaling": "🌍 Traducción IA: traduce el anuncio completo a 8 idiomas (NL/EN/DE/FR/PL/ES/IT/TR) — de forma natural, sin traducción literal",
  "🔥 Geen maandelijkse kosten ooit meer": "🔥 Sin costes mensuales, nunca más"
};
